import { CdkDragDrop, CdkDragStart } from '@angular/cdk/drag-drop';
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpEventType } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { commonImages } from '@images/common-images';
import { libraryImages } from '@images/library-images';
import { User } from '@models/user.model';
import { DashService } from '@modules/dash-board/dash.service';
import { ApiService } from '@services/api/api.service';
import { AuthService } from '@services/auth.service';
import { CheckPlatformService } from '@services/helpers/check-platform.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { LibraryHelper } from '@services/helpers/library-helper';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { TokenService } from '@services/helpers/token.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ActivityTrackerService } from '@services/user-activity/activity-tracker.service';
import { SharedDataService } from '@services/shared-data.service';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { ReduxService } from '@state-management/redux.service';
import * as JSZip from 'jszip';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { AutoComplete } from 'primeng/autocomplete';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MyPdfService } from '../../my-pdf.service';
import { LibImageEditorComponent } from '../lib-image-editor/lib-image-editor.component';
import { SalePresentationService } from '@modules/sale-presentation/sale-presentation.service';
import { MessageService } from 'primeng/api';
import { MessageService as MessageServices } from '@services/util/message.service';

import * as pdfjsLib from 'pdfjs-dist';
import { LoadingService } from '@common/loading/loading.service';

(pdfjsLib as any).GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.2.67/pdf.worker.min.js`;

@Component({
  selector: 'app-library-view-mode',
  templateUrl: './library-view-mode.component.html',
  styleUrls: ['./library-view-mode.component.scss'],
})
export class LibraryViewModeComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('pdffile') pdffile: ElementRef;
  @ViewChild('filefolderRename') filefolderRename: ElementRef;
  @ViewChild('folderName') folderName: ElementRef;
  @ViewChild('getLinkField') getLinkField: ElementRef;
  @ViewChild('getLinkPath') getLinkPath: ElementRef;
  @ViewChild('userautocomplete') userAutoCompleteDropdown: AutoComplete;
  @ViewChild('filesOptions', { static: true }) filesOptions!: OverlayPanel;
  @ViewChild('libraryviewmode') libraryViewMode: ElementRef;
  @ViewChildren('folderOptions') folderOptions: QueryList<any>;
  @ViewChild('libimageeditor') libImageEditor: LibImageEditorComponent;
  @ViewChild('libraryfilewrap') libraryFileWrap: ElementRef;

  @Input() videoTourLinks = null; //: Observable<any> = null;
  @Input() category = '';
  @Input() isNotSharedPage = true;
  @Input() librarydata: [] = [];
  @Input() fileUploadInputId = 'fileUpload';
  @Input() tooltipText: string = '';
  @Input() isBackBtnShown = true;
  @Input() backAndBreadCrumHide = true;
  @Input() isRoute = true;
  @Input() isBackBtnIndex: any;
  @Input() contract_Id = '';
  @Input() eoi_Id = '';
  @Input() propertyId = '';
  @Input() floorPlan_Name = '';
  @Input() noShowListingButton: boolean;
  @Input() is_project: boolean = false;
  @Input() isInternalFolder: boolean = false;
  @Input() hidePropertyLibrary = false;
  @Input() isInternal: boolean;
  @Input('defaultopen') defaultOpen = '';
  @Input() isContractLibrary = false;
  @Input() isListingLibrary = false;
  @Input() isUserOffice = false;
  @Input() isFullObj = false;
  @Input('innerdefault') innerDefault = '';
  @Input() nestedInnerDefault = '';
  @Input() noSideBar: boolean = false;
  @Input() appraisalsFolderId = '';
  @Input() eoiData: any = null;
  /**
   * Opt-in: keeps the viewer inside one folder of the project library (matched by name, case-insensitive),
   * e.g. 'project documents'. Only that folder is listed at the project root, and the breadcrumb, back
   * button and folder navigation cannot go above it. Null (the default) leaves the library unrestricted.
   */
  @Input() lockToFolder: string | null = null;
  @Output() LibraryOutputData = new EventEmitter<[]>();
  @Output() onRemove = new EventEmitter<boolean>();
  @Output() emitFolderId = new EventEmitter<[]>();
  @Output() imageUploadedLenght = new EventEmitter<any>();
  @Output() imageUploadedError = new EventEmitter<any>();
  @Output() videoLinks = new EventEmitter<any>();
  @Output() parentComp = new EventEmitter<any>();

  userRoleId: String = '';
  operationManagerRoleId: String = '610a0f1dc61edfcf62d62bb6';
  isHiddenWorkspaceVisible: Boolean = false;
  user_team_ids: string = Crypto.decrypt(this.localStorageService.GetItem('teams_id'));
  fileEmbedVideoURL: string = '';
  filePWLink: string;
  fileImagePWLink: string;
  images = libraryImages;
  common_images = commonImages;
  // Default Variables
  isAccord: boolean = false;
  imageGalleryPreview: string[] = [];
  page_title = 'My Files';
  library_type = 'private';
  S3Path = environment.S3 + '/';
  public loading: boolean = false;
  public GridView: boolean = true;
  showRightBar: Boolean = false;
  public items = [];
  public sortingMenu = [];
  directoryList = [
    { name: 'My Files', value: 'myfiles' },
    { name: 'Recent Files', value: 'recentfiles' },
  ];
  selectedDirectory: any = null;
  // file upload
  humanizeBytes: Function;
  dragOver: boolean;

  // Modal
  addFolderModal: boolean = false;
  modalRenameFolderFile: boolean = false;
  modalMoveFolder: boolean = false;
  modalPreview: boolean = false;
  modalGetLink: boolean = false;
  modalShare: boolean = false;
  isRequestPending: boolean = false;
  isTooltipDisabled: boolean = false;
  isAddingInWorkspace: boolean = false;
  serviceSubscription: Subscription;

  //Office
  officeServiceSubscription: Subscription;

  // Auth
  public authUser: any;
  public authUserID = null;

  // Data
  public allDataLibrary: any;
  public libraryData: any;
  public libraryDataCopy: any;
  public sharedWithMeData: any;
  public sharedFilterData: any;
  public favLibraryData: any = [];
  public recentLibraryData: any = [];
  public trashLibraryData: any = [];
  public draggedProduct: any;
  public searchedResultId: string = '';
  public searchedResultName: string = '';
  public userPermission: string[] = Crypto.decrypt(this.localStorageService.GetItem('_per'));
  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));

  // Sidebar
  onlyFoldersData: any;
  cachingFoldersData: any;
  public folderList: any = [];
  public $folderList: any;
  selectedSidebarLink: any;

  // Form
  error: any;
  selectedFileFolderID: any = [];
  fileFolderRename: any;
  viewDialog = false;

  // Folder
  readyToUploadFiles: any = [];
  fileUploadingLoader: boolean = false;
  isWorkspace: boolean = false;

  // Action
  selectItem: any;
  selectedItems: any = [];
  sortMenuLabel = 'Sort';
  reorderData: any = false;
  searchKeyword: string;
  embedVideoURL: string = '';
  onlineTour1: string = '';
  temp_id: any;
  onlineTour2: string = '';

  // Share
  allUsers: any[];
  selectedUsersToShare: any[] = [];
  filteredUsers: any[];
  sharePermissionOfficeLibrary: any[] = [
    { name: 'Editor', value: 'edit' },
    { name: 'Remove user', value: 'remove' },
  ];
  sharePermission: any[] = [
    { name: 'Viewer', value: 'view' },
    { name: 'Editor', value: 'edit' },
    { name: 'Remove user', value: 'remove' },
  ];

  //Team
  teams: any[] = [];

  breadcrumbItems: Array<{ label?: any; url?: any }> = [];
  reNameTo: any = null;
  reNaming: boolean = false;
  responsiveOptions: { breakpoint: string; numVisible: number; numScroll: number }[] = [];
  activeOfficeId: string = '';
  privateLibRoot: any = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private Api: ApiService,
    private Auth: AuthService,
    private toastr: ToastrService,
    private redux: ReduxService,
    public libHelper: LibraryHelper,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private _sharedDataService: SharedDataService,
    private _primeMessageService: MessageService,
    private message: MessageServices,
    private ngZone: NgZone,
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private tokenService: TokenService,
    private lmService: LeadManagementService,
    private sp: SalePresentationService,
    private checkPlatformService: CheckPlatformService,
    private pdfService: MyPdfService,
    private dash: DashService,
    private loadingService: LoadingService,
    private activityTracker: ActivityTrackerService,
    private remmiConfirm: RemmiConfirmService
  ) {
    this.dragOver = false;

    this.searchKeyword = '';
    this.authUserID = Crypto.decrypt(this.localStorageService.GetItem('uid'));
    this.activeOfficeId = this.Api.getOfficeId();

    this.responsiveOptions = [
      {
        breakpoint: '1200px',
        numVisible: 4,
        numScroll: 4,
      },
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2,
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
      },
    ];

    // Click Outside
    this.renderer.listen('window', 'click', (e: any) => {
      if (!this.libraryFileWrap?.nativeElement?.contains(e.target)) {
        if (!e?.target?.classList?.contains('pi-ellipsis-v') == true && e?.target?.id != 'extra-menu') {
          this.filesOptions.hide();
          this.resetSelectedItems();
        } else if (e?.target?.id != 'extra-menu' && !e?.target?.classList?.contains('pi-ellipsis-v')) {
          this.filesOptions.hide();
          this.resetSelectedItems();
        }
      }
    });

    // Data Sort
    this.sortingMenu = [
      { label: 'Sort A to Z', command: () => this.dataSorting('atoz') },
      { label: 'Sort Z to A', command: () => this.dataSorting('ztoa') },
      { label: 'Modified Oldest', command: () => this.dataSorting('old') },
      { label: 'Modified Latest', command: () => this.dataSorting('new') },
    ];
  }

  /**
   * Handles changes to input properties using Angular's ngOnChanges lifecycle hook.
   * It checks for changes in 'appraisalsFolderId' and 'propertyId' and updates the breadcrumb navigation accordingly.
   */
  ngOnChanges(changes: SimpleChanges): void {
    // Check if 'appraisalsFolderId' has changed and has a valid value

    if (changes?.videoTourLinks?.currentValue) {
      this.embedVideoURL = changes?.videoTourLinks?.currentValue?.video;
      this.onlineTour1 = changes?.videoTourLinks?.currentValue?.tour1;
      this.onlineTour2 = changes?.videoTourLinks?.currentValue?.tour2;
    }
    if (!changes?.['appraisalsFolderId']?.currentValue) {
      return;
    } else {
      // If library data exists, update the selected folders and navigation menu
      if (this.libraryData?.length > 0) {
        this.selectFolders(this.propertyId, true);
        var extractedPathString = this.getNestedPath(this.allDataLibrary, this.propertyId);
        this.getNavigationMenu(extractedPathString);
      } else {
        // Reset breadcrumb items if no library data
        this.breadcrumbItems = [];
      }
    }

    // Check if 'propertyId' has changed and has a valid value
    if (!changes?.['propertyId']?.currentValue) {
      return;
    } else {
      // If library data exists, update the selected folders and navigation menu
      if (this.libraryData?.length > 0) {
        this.selectFolders(this.propertyId);
        var extractedPathString = this.getNestedPath(this.allDataLibrary, this.propertyId);
        this.getNavigationMenu(extractedPathString);
      } else {
        // Reset breadcrumb items if no library data
        this.breadcrumbItems = [];
      }
    }
  }

  /**
   * Cleans up subscriptions when the component is destroyed to prevent memory leaks.
   */
  ngOnDestroy(): void {
    // Unsubscribe from service subscriptions
    this.serviceSubscription?.unsubscribe();
    this.officeServiceSubscription?.unsubscribe();
    this.lifetimeSubs.unsubscribe();

    // Unsubscribe from resize subscription if it exists
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  /**
   * Handles different triggered actions based on the response method.
   * It processes actions such as copying, moving, renaming, removing, and uploading files/folders.
   */
  triggerFuncHandler(response) {
    switch (response?.method) {
      case 'makecopy':
        // Create a copy of the folder or file
        this.makeCopyFolderFile(response?.dataset);
        break;
      case 'movefilefolder':
        // Show the move folder modal
        this.showMoveFolderModal(response?.dataset, 'folder');
        break;
      case 'renamefilefolder':
        // Show the rename modal
        this.showRenameModal(response?.dataset);
        break;
      case 'remove':
        // Remove the specified folder or file
        this.removeFolderFile(response?.dataset);
        break;
      case 'newfilefolder':
        // Show modal to add a new folder
        this.showAddFolderModal(false);
        break;
      case 'fileupload':
        // Trigger file upload if file uploader ID matches
        response?.file_uploader_id === this.fileUploadInputId && this.triggerFileUpload(response?.file_type);
        break;
      case 'workspacecreation':
        // Show modal to create a new workspace
        this.showAddFolderModal(true);
        break;
      case 'propertyfolders':
        // Select folders and update navigation menu if 'propertyId' exists
        if (this.propertyId?.length > 0) {
          this.selectFolders(response?.dataset);
          var extractedPathString = this.getNestedPath(this.allDataLibrary, response?.dataset);
          this.getNavigationMenu(extractedPathString);
        }
        break;
      default:
        break;
    }
  }

  backBtnValue: any;
  innerWidth: number;
  private resizeSubscription: Subscription;
  // Streams that outlive this component (route params of an embedding page, shared-service
  // subjects, the window listener). Left open, a destroyed instance kept refetching the tree.
  private readonly lifetimeSubs = new Subscription();
  screenWidth: any;
  mobToggle: any = false;
  isAdmin: any = false;
  /**
   * Initializes the component and sets up subscriptions for various data sources.
   * It determines user roles, listens for window resize events, and fetches necessary data.
   */
  ngOnInit() {
    // Determine if the user has admin privileges
    this.isAdmin = this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager' ? true : false;

    // Set the back button index, defaulting to 1 if not provided
    this.backBtnValue = this.isBackBtnIndex ? this.isBackBtnIndex : 1;
    this.innerWidth = window.innerWidth;

    // Listen to window resize events and update the innerWidth property
    this.lifetimeSubs.add(
      this.renderer.listen('window', 'resize', () => {
        this.innerWidth = window.innerWidth;
      })
    );

    if (this.is_project) {
      this.lmService.GetProjectDetail(this.propertyId);
    }

    // Determine the type of library based on the URL path
    let url = this.router.url.split('?')[0];
    if (url.includes('/library/private')) {
      this.library_type = 'private';
    } else {
      this.library_type = 'office';
    }
    // Subscribe to shared data service to handle incoming library data updates
    this.serviceSubscription = this._sharedDataService?.libraryGetDataHandlerObservable?.subscribe({
      next: response => {
        this.triggerFuncHandler(response);
      },
      error: () => {},
    });

    // Listen for query parameter changes to handle search-related properties
    this.lifetimeSubs.add(
      this.route.queryParams.subscribe({
        next: params => {
          if (params['Id']?.toString() || params['id']?.toString()) {
            if (!this.propertyId && !this.contract_Id) {
              this.searchedResultId = params['Id']?.toString() ? params['Id']?.toString() : params['id']?.toString();
            }
          } else {
            this.searchedResultId = '';
            this.searchedResultName = '';
          }
          this.sideBarLev1(null);
        },
      })
    );

    // Fetch authenticated user details and workspace data
    this.getAuthUser();

    // My Workspace, its recent files, the office staff list and the folder tree are only ever
    // read by the full Library page's own panels and dialogs. Embedded in a listing, a contract
    // or an EOI none of them is on screen, so they are fetched when something actually opens
    // that needs them (`showShareModal`, `showMoveFolderModal`) rather than on the way in.
    if (!this.isEmbeddedLibrary) {
      this.getAllWorkspace();
      this.getWorkspaceRecentAccess();
      this.getAllUsers();
      this.getOnlyFolders();
      this.loadData();
    }

    if (this.isInternal) {
      this.loadInternalUsers();
    }

    // Listen for office change events and reload necessary data
    this.officeServiceSubscription = this.Auth.getChangeUserOffice().subscribe({
      next: response => {
        if (response === 'change default office') {
          setTimeout(() => {
            this.getAuthUser();
            this.getAllWorkspace();
            this.getWorkspaceRecentAccess();
            this.getAllUsers();
            this.activeOfficeId = this.Api.getOfficeId();

            // Reload data and reset modal states
            this.getOnlyFolders();
            this.modalShare = false;
            this.loadData();
          }, 500);
        }
      },
    });

    // Listen for library reload triggers and fetch all data if triggered
    this.lifetimeSubs.add(
      this._sharedDataService.reLoadLibrary.subscribe({
        next: data => {
          if (data) {
            this.tempFix = true;
            this.getAllData();
          }
        },
      })
    );

    // Subscribe to screen size changes to manage mobile toggle behavior
    this.resizeSubscription = this.dash.screenSize$.subscribe({
      next: size => {
        this.screenWidth = size.width;
        this.mobToggle = this.screenWidth < 567;
      },
    });

    // Subscribe to authenticated user details and update user information
    this.lifetimeSubs.add(
      this.Auth.UserSub.subscribe({
        next: user => {
          this.user_detail = user;
        },
      })
    );
  }

  /**
   * Loads data for teams associated with the selected office.
   * Fetches teams from the API and updates the `teams` property if data is available.
   */
  loadData() {
    if (this.Api.getOfficeId()) {
      this.Api.get('/teams?include=office,users&office_id=' + this.Api.getOfficeId(), this.search).subscribe({
        next: response => {
          if (response.status == true) {
            this.teams = response.data;
          }
        },
      });
    }
  }

  /**
   * Resets the selected items array and clears the selection.
   */
  resetSelectedItems() {
    this.selectedItems = [];
    this.selectItem = '';
  }

  /**
   * Controls the visibility of overlay panels based on the provided ID.
   * It shows the overlay panel for the selected folder and hides others.
   * @param event - The event that triggered the function.
   * @param Id - The ID of the folder to show the overlay panel for.
   */
  resetOverlayPanel(event, Id) {
    this.folderOptions.map(item => {
      const itemID = item.el.nativeElement.getAttribute('id');
      if (itemID == Id) {
        item.show(event, item);
      } else {
        item.hide(event);
      }
    });
  }

  /**
   * Sorts `libraryData` based on the selected sorting type.
   * @param type - The sorting type (e.g., 'atoz', 'ztoa', 'old', 'new').
   */
  dataSorting(type) {
    if (type == 'atoz') {
      this.sortMenuLabel = 'Alphabetically, A-Z';
      this.libraryData = this.libraryData.sort(Utils.SortAtoZ);
    } else if (type == 'ztoa') {
      this.sortMenuLabel = 'Alphabetically, Z-A';
      this.libraryData = this.libraryData.sort(Utils.SortZtoA);
    } else if (type == 'old') {
      this.sortMenuLabel = 'Date, old to new';
      this.libraryData.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    } else if (type == 'new') {
      this.sortMenuLabel = 'Date, new to old';
      this.libraryData.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    }
  }

  /**
   * Searches for files or folders within `libraryData` based on the input value.
   * If no value is provided, it resets `libraryData` to its original state.
   * @param value - The search input string.
   */
  search(value: string): void {
    this.libraryData = this.libraryDataCopy;

    if (value) {
      // Filter libraryData based on the search value (case-insensitive)
      this.libraryData = this.libraryData.filter(val => val?.name?.toLowerCase().includes(value.trim().toLowerCase()));
    } else if (value === null || value === '') {
      // Reset to the original library data if search is cleared
      this.libraryData = this.libraryDataCopy;
    } else {
      // Handle search for different categories
      if (this.page_title == 'My Files' || this.category == 'useroffice') {
        this.libraryData = this.allDataLibrary;
        if (this.propertyId?.length > 0) {
          this.selectFolders(this.propertyId, true);
          var extractedPathString = this.getNestedPath(this.libraryData, this.propertyId);
          this.getNavigationMenu(extractedPathString);
        }
      }
      if (this.page_title == 'Shared with me') {
        this.libraryData = this.sharedFilterData;
      }
      if (this.page_title == 'Trash Files') {
        this.libraryData = this.trashLibraryData;
      }
      if (this.page_title == 'Favourites') {
        this.libraryData = this.favLibraryData;
      }
    }
  }

  // ====================
  //  GET Functions
  // ====================

  isDraggableFeature: boolean = false;
  /**
   * Handles sidebar navigation and updates the view based on the selected item.
   * Sets the page title, updates the selected sidebar link, and calls appropriate data-fetching functions.
   * @param item - The sidebar item selected by the user.
   */
  sideBarLev1(item) {
    if (item?.label == 'My Files' || this.category == 'folder') {
      this.getAllData();
      this.page_title = 'My Files';
      this.selectedSidebarLink = 0;
      this.isDraggableFeature = true;
      this.GridView = true;
    }
    if (item?.label == 'Shared with me' || this.category == 'shared') {
      this.getSharedWithMe();
      this.page_title = 'Shared with me';
      this.selectedSidebarLink = 1;
    }
    if (item?.label == 'Recent' || this.category == 'recent') {
      this.getAllRecent();
      this.page_title = 'Recent Files';
      this.selectedSidebarLink = 2;
    }
    if (item?.label == 'Favourites' || this.category == 'favourite') {
      this.getAllFavourite();
      this.page_title = 'Favourites Files';
      this.selectedSidebarLink = 3;
    }
    if (item?.label == 'Trash' || this.category == 'trash') {
      this.getAllTrash();
      this.page_title = 'Trash Files';
      this.selectedSidebarLink = 4;
    }
    if (item?.label == 'My Workspace' || this.category == 'workspace') {
      this.getAllWorkspace();
      this.getSelectedDirectory(this.selectedDirectory);
      this.page_title = 'My Workspace';
      this.selectedSidebarLink = 5;
      this.isDraggableFeature = false;
    }
    if (this.category == 'useroffice') {
      this.userRoleId = Crypto.decrypt(this.localStorageService.GetItem('roleid'));
      this.getPrivateOfficeFolders();
      this.page_title = 'User Office';
      this.selectedSidebarLink = 6;
      this.isDraggableFeature = true;
    }
  }

  /**
   * Fetches only folder-type items for moving operations.
   * Calls an API to get folders that are not marked as deleted.
   */
  /** Embedded in another screen — a listing, a contract, an EOI — rather than the Library page. */
  get isEmbeddedLibrary(): boolean {
    return !!(this.propertyId || this.contract_Id || this.eoi_Id);
  }

  getOnlyFolders() {
    if (this.authUserID) {
      var param = [
        {
          user_id: this.authUserID,
          library_type: this.library_type,
        },
      ];
      this.Api.get('/library/only-folders?', param[0]).subscribe({
        next: response => {
          // Filters out deleted folders and stores the result in `onlyFoldersData`
          this.onlyFoldersData = response?.data.filter(f => f.is_deleted == false);
        },
      });
    }
  }

  // #GET-00
  // Auth Functions
  /**
   * Retrieves the authenticated user’s data, including offices, permissions, and groups.
   * Updates the user state and adjusts the directory list based on the active office.
   */
  getAuthUser() {
    this.loading = true;

    // Fetch authenticated user details from the API
    this.redux.getUser().subscribe({
      next: response => {
        const data = JSON.parse(JSON.stringify(response));
        this.loading = false;

        // Store the retrieved user data
        this.authUser = data.data as User;

        // Retrieve the active office ID from local storage
        this.activeOfficeId = this.Api.getOfficeId();

        // Find the directory entry for 'my_office'
        let filterOfficeDirectory = this.directoryList.filter(folder => folder?.value == 'myoffice')?.[0];

        // Get the user’s office name based on the active office ID
        let filterUserOfficeName = this.authUser?.offices?.data?.filter(office => office?._id == this.Api.getOfficeId())?.[0];

        // If 'my_office' exists in the directory list, update its name
        if (filterOfficeDirectory?.name?.length > 0) {
          this.directoryList = this.directoryList?.map(folder => {
            if (folder?.value == 'myoffice') {
              folder.name = filterUserOfficeName?.name;
            }
            return folder;
          });
        } else {
          // If 'my_office' is not found, add it to the directory list
          this.directoryList = [...this.directoryList, { name: filterUserOfficeName?.name, value: 'myoffice' }];
        }

        // Store the authenticated user data in the authentication service
        this.Auth.setAuthUser(this.authUser);
      },

      error: () => {
        this.loading = false;
      },
    });
  }

  // #GET-01
  // All Library Data (Folder + Files)
  directoryListData: any[] = [];
  tempFix: boolean = false; // to load editor thumbs when required
  /**
   * Fetches all data related to the authenticated user's private library.
   * Updates library data, directory list, gallery items, and handles filtering logic.
   */
  getAllData() {
    this.folderList = [];

    // Proceed only if the authenticated user ID is available
    if (this.authUserID) {
      this.loading = true;

      // API call to fetch the user's private folder and file data
      this.Api.get(`/library/private/folder-file/${this.authUserID}`).subscribe({
        next: async response => {
          this.privateLibRoot = response.data._id;

          // Store and filter retrieved library data, excluding deleted items
          this.libraryDataCopy =
            this.libraryData =
            this.allDataLibrary =
              response.data.childrens
                .filter(f => f.is_deleted == false)
                ?.map(el => {
                  if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
                    el = { ...el, ispermission: true };
                    return el;
                  } else {
                    return el;
                  }
                });

          // Check if all items have the 'is_offline' property
          const hasIsOfflineField = this.allDataLibrary.every(item => item?.hasOwnProperty('is_offline'));

          this.galItems = [];
          this.portalImages = [];

          if (!hasIsOfflineField) {
            // Assign 'is_offline' as false if missing
            this.allDataLibrary?.forEach(item => {
              if (!item?.hasOwnProperty('is_offline')) {
                item['is_offline'] = false;
              }
            });

            // Separate images into online and offline galleries
            this.allDataLibrary?.forEach(item => {
              if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png')) {
                if (item?.is_offline === false) {
                  this.galItems.push(item);
                } else if (item?.is_offline === true) {
                  this.portalImages.push(item);
                }
              }

              // Special handling for 'Floorplans' folder
              if (item.type == 'folder' && item.name == 'Floorplans') {
                if (!this.galItems.some(galItem => galItem._id === item._id)) {
                  this.galItems.push(item);
                }
              }
            });

            // Ensure 'Floor_plans' folder is placed last in sorting
            this.galItems.sort((a, b) => {
              if (a.type === 'folder' && a.name === 'Floorplans') return 1;
              if (b.type === 'folder' && b.name === 'Floorplans') return -1;
              return 0;
            });
          }

          if (this.page_title == 'My Workspace') {
            // Process directory listing for workspace view
            this.directoryListData = this.getDirectoryListing(this.allDataLibrary?.filter(data => !data?.is_workspace));
            this.GridView = true;
          } else {
            // Process general library data excluding workspace items
            this.libraryDataCopy = this.libraryData = this.allDataLibrary?.filter(data => !data?.is_workspace);

            // Reinitialize gallery items
            this.galItems = [];
            this.portalImages = [];

            const hasIsOfflineField = this.allDataLibrary.every(item => item?.hasOwnProperty('is_offline'));

            if (!hasIsOfflineField) {
              // Assign 'is_offline' as false if missing
              this.allDataLibrary.forEach(item => {
                if (!item.hasOwnProperty('is_offline')) {
                  item.is_offline = false;
                }
              });
            }

            // Process images and folders again for general library
            this.allDataLibrary.forEach(item => {
              if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png')) {
                if (item.is_offline === false) {
                  this.galItems.push(item);
                } else if (item.is_offline === true) {
                  this.portalImages.push(item);
                }
              }
              if (item.type == 'folder' && item.name == 'Floorplans') {
                if (!this.galItems.some(galItem => galItem._id === item._id)) {
                  this.galItems.push(item);
                }
              }
            });

            // Ensure 'Floor_plans' folder is placed last in sorting
            this.galItems.sort((a, b) => {
              if (a.type === 'folder' && a.name === 'Floorplans') return 1;
              if (b.type === 'folder' && b.name === 'Floorplans') return -1;
              return 0;
            });

            if (this.libEdit && this.tempFix) {
              this.tempFix = false;

              // Retrieve searched folder data recursively
              let tResult: any = await this.selectFolder_recursive(this.searchedResultId, this.allDataLibrary, true);
              let tLibraryData = tResult instanceof Array && tResult?.filter(f => f.is_deleted == false);

              // Update gallery items from search results
              this.galItems = tLibraryData.filter(item => {
                return item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png');
              });

              if (!this.searchedResultId) {
                // Reset gallery items if no search result found
                this.galItems = [];
                this.portalImages = [];

                const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));

                if (!hasIsOfflineField) {
                  this.libraryData.forEach(item => {
                    if (!item.hasOwnProperty('is_offline')) {
                      item.is_offline = false;
                    }
                  });
                }

                this.libraryData.forEach(item => {
                  if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png')) {
                    if (item.is_offline === false) {
                      this.galItems.push(item);
                    } else if (item.is_offline === true) {
                      this.portalImages.push(item);
                    }
                  }
                  if (item.type == 'folder' && item.name == 'Floorplans') {
                    if (!this.galItems.some(galItem => galItem._id === item._id)) {
                      this.galItems.push(item);
                    }
                  }
                });

                // Ensure 'Floor_plans' folder is placed last in sorting
                this.galItems.sort((a, b) => {
                  if (a.type === 'folder' && a.name === 'Floorplans') return 1;
                  if (b.type === 'folder' && b.name === 'Floorplans') return -1;
                  return 0;
                });
              }

              // Add additional metadata to gallery items
              this.galItems.forEach(n => {
                if (n.type !== 'folder' && (n.file_type === 'image/jpeg' || n.file_type === 'image/png')) {
                  n.info_div = {
                    uploadedby: this.getUserName(n?.user_id),
                    modified: moment(n?.updated_at)?.format('DD MMM YYYY'),
                    created: moment(n?.created_at)?.format('DD MMM YYYY'),
                    dimentions: this.getImageDimenssion(this.getLargeImageByPath(n)),
                  };
                }
              });
            }
          }

          // Filter search results based on user input
          if (this.searchKeyword) {
            this.galItems = this.galItems.filter(val => val.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
            if (this.galItems?.length == 0) this.searchKeyword = '';
          }

          // Extract query parameters for search functionality. Only the current value is read
          // here; ngOnInit's subscription already applies the same assignment on later changes.
          this.route.queryParams.pipe(take(1)).subscribe({
            next: params => {
              if (params['Id']?.toString() || params['id']?.toString()) {
                if (!this.propertyId && !this.contract_Id) {
                  this.searchedResultId = params['Id']?.toString() ? params['Id']?.toString() : params['id']?.toString();
                }
              }
            },
          });

          // If a search result ID exists, process the folder selection
          if (this.searchedResultId?.length > 0) {
            this.selectFolders(this.searchedResultId);
            var extractedPathString = this.getNestedPath(this.libraryData, this.searchedResultId);
            this.getNavigationMenu(extractedPathString);
          } else {
            this.breadcrumbItems = [];
          }

          this.loading = false;

          // Retrieve folder list and refresh shared data
          this.$folderList = this.allDataLibrary?.filter(f => f.type == 'folder');
          this._sharedDataService?.triggerFuncEventHandler({ dataset: null, method: 'refresh' });

          this.temp_id = response.data._id;
          this.privateLibRoot = response.data._id;
        },
      });
    }
  }

  // #GET-02
  // Get Shared With Me
  getSharedWithMe() {
    if (this.authUserID) {
      // Prepare request parameters with user ID and library type
      var param = {
        userId: this.authUserID,
        library_type: this.library_type,
      };

      this.loading = true;

      // API call to fetch shared folder and file data
      this.Api.get('/library/share-folder-file', param).subscribe({
        next: response => {
          this.sharedFilterData = [];
          this.sharedWithMeData = response.data;

          // Iterate through the response data and extract folder/file information
          this.sharedWithMeData.forEach(f => {
            this.sharedFilterData.push({
              ...f.folder_or_file,
              manage: f?.manage,
              is_favourite: f?.is_favourite,
            });
          });

          // Handle different UI cases based on `page_title`
          if (this.page_title == 'My Workspace') {
            // Convert shared data into directory listing format
            this.directoryListData = this.getDirectoryListing(this.sharedFilterData);
          } else {
            // Filter out deleted items and apply permission logic for specific roles
            this.libraryDataCopy =
              this.libraryData =
              this.allDataLibrary =
                this.sharedFilterData
                  .filter(f => f.is_deleted == false)
                  ?.map(el => {
                    if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
                      el = { ...el, ispermission: true };
                      return el;
                    }
                  });
          }

          // If a specific folder is searched, select it
          if (this.searchedResultId) {
            this.selectFolders(this.searchedResultId);
          }

          // Set loading to false after the operation completes
          this.loading = false;
        },
      });
    }
  }

  // #GET-03
  // Get Favourites
  getAllFavourite() {
    if (this.authUserID) {
      // Prepare request parameters with user ID and library type
      var param = [
        {
          userId: this.authUserID,
          library_type: this.library_type,
        },
      ];

      // API call to fetch favorite folders and files
      this.Api.get('/library/get-fav-folder-file', param[0]).subscribe({
        next: response => {
          // Filter out deleted items from the response data
          this.favLibraryData = response.data.filter(f => f.is_deleted == false);

          // Process the favorite library data and apply permission logic for specific roles
          this.libraryDataCopy = this.libraryData = this.favLibraryData
            .filter(f => f.is_deleted == false)
            ?.map(el => {
              if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
                el = { ...el, ispermission: true };
                return el;
              }
            });

          // If a specific folder is searched, select it
          if (this.searchedResultId) {
            this.selectFolders(this.searchedResultId);
          }

          // Trigger a refresh event via the shared data service
          this._sharedDataService?.triggerFuncEventHandler({ dataset: null, method: 'refresh' });
        },
      });
    }
  }

  // #GET-04
  // Get Recent
  getAllRecent() {
    if (this.authUserID) {
      // Prepare request parameters with user ID and library type set to 'private'
      var param = [
        {
          userId: this.authUserID,
          library_type: 'private',
        },
      ];

      // Set loading state to true before making the API call
      this.loading = true;

      // API call to fetch recently accessed files
      this.Api.get('/library/get-recent-access', param[0]).subscribe({
        next: response => {
          let data = [];

          // Extract file objects from response data
          response.data.forEach(f => {
            data.push(f.file);
          });

          // Filter out deleted files
          this.recentLibraryData = data?.filter(f => f.is_deleted == false);

          // Check if the current page is not 'My Workspace'
          if (this.page_title !== 'My Workspace') {
            // Apply permission logic for specific roles and filter out deleted files
            this.libraryDataCopy = this.libraryData = this.recentLibraryData
              .filter(f => f.is_deleted == false)
              ?.map(el => {
                if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
                  el = { ...el, ispermission: true };
                  return el;
                }
              });
          } else {
            // If on 'My Workspace', filter out non-file types
            this.recentLibraryData = this.recentLibraryData?.filter(f => f?.type === 'file');

            // Update directory listing based on recent files
            this.directoryListData = this.getDirectoryListing(this.recentLibraryData);
          }

          // If a specific folder is searched, select it
          if (this.searchedResultId) {
            this.selectFolders(this.searchedResultId);
          }

          // Trigger a refresh event via the shared data service
          this._sharedDataService?.triggerFuncEventHandler({ dataset: null, method: 'refresh' });

          // Reset loading state to false after API response
          this.loading = false;
        },
      });
    }
  }

  // #GET-05
  // Get Trash
  getAllTrash() {
    // Reset the library data before fetching new trash data
    this.libraryData = '';

    if (this.authUserID) {
      // Prepare request parameters with user ID and library type set to 'private'
      var param = [
        {
          userId: this.authUserID,
          library_type: 'private',
        },
      ];

      // API call to fetch trashed folders and files
      this.Api.get('/library/get-trash-folder-file', param[0]).subscribe({
        next: response => {
          // Store the response data in trashLibraryData
          this.trashLibraryData = response.data;

          // Apply permission logic for specific roles
          this.libraryDataCopy = this.libraryData = this.trashLibraryData?.map(el => {
            if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
              el = { ...el, ispermission: true };
              return el;
            }
          });

          // If a specific folder is searched, select it
          if (this.searchedResultId) {
            this.selectFolders(this.searchedResultId);
          }

          // Trigger a refresh event via the shared data service
          this._sharedDataService?.triggerFuncEventHandler({ dataset: null, method: 'refresh' });
        },
      });
    }
  }

  // #GET-06
  // Get Users
  getAllUsers() {
    // Define API request parameters including user ID and office ID
    let param = {
      per_page: 'all', // Fetch all users without pagination
      uid: this.authUserID, // Current authenticated user ID
      officeid: this.Api.getOfficeId(), // Retrieve office ID from local storage
    };

    // Proceed only if an office ID exists
    if (param['officeid']) {
      // API call to fetch all office staff
      this.Api.get('/users/office-staff-list?show=staff', param).subscribe({
        next: response => {
          // Check if the API response is successful
          if (response.status == true) {
            // Store the retrieved user data
            this.allUsers = response.data;
          }
        },
      });
    }
  }

  filteredUserFromList: String = '';
  /**
   * Filters users and teams based on the search query.
   * - Filters users whose email or full name matches the search query.
   * - Filters teams whose name matches the search query.
   * - Assigns a "manage" permission to each matched user/team based on selectedUsersToShare.
   * - Adds a "category" and formatted "email" for teams.
   */
  filterUsers(event) {
    let selectedUser = [];
    let query = (this.filteredUserFromList = event.query);

    // Filter users based on email or full name matching the query
    this.allUsers
      ?.filter(
        user =>
          user?.email?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1 || user?.full_name?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1
      )
      ?.forEach(element => {
        // Assign manage permission from selectedUsersToShare, default to 'view'
        element.manage = this.selectedUsersToShare.filter(res => res?._id === element?._id)?.[0]?.manage || 'view';
        selectedUser?.push(element);
      });

    // Filter teams based on name matching the query
    this.teams
      ?.filter(team => team?.name?.toLowerCase()?.indexOf(query?.toLowerCase()) !== -1)
      ?.forEach(element => {
        // Assign manage permission and categorize as "team"
        element.manage = this.selectedUsersToShare.filter(res => res?._id === element?._id)?.[0]?.manage || 'view';
        element.category = 'team';
        element.email = `${element?.name} [Team]`;
        selectedUser?.push(element);
      });

    // Store filtered users and teams
    this.filteredUsers = selectedUser;
  }

  /**
   * Clears the filtered user search input when a user is selected.
   */
  onSelectUsers() {
    this.filteredUserFromList = '';
  }

  /**
   * Handles search submission when the user enters an email.
   * - If the entered email is valid and not found in allUsers, adds it as a new disabled user.
   * - Updates the user autocomplete dropdown with the new user.
   */
  onSearchSubmit() {
    // Check if the entered input is a valid email
    if (Utils.isEmail(this.filteredUserFromList)) {
      // If the email is not found in allUsers, add a new disabled user
      if (this.allUsers?.filter(user => user?.email == this.filteredUserFromList)?.length == 0) {
        try {
          let newUser = {
            _id: '',
            full_name: this.filteredUserFromList.split('@')?.[0], // Extract name from email
            email: this.filteredUserFromList,
            manage: 'view',
            is_disabled: true,
          };

          // Add the new user to the selected users list
          this.selectedUsersToShare?.push(newUser);

          // Select the new user in the autocomplete dropdown
          // this.userAutoCompleteDropdown?.selectItem(newUser);

          // Clear the search input field
          this.filteredUserFromList = '';
        } catch (error) {}
      }
    }
  }

  // ====================
  //  POST Functions
  // ====================
  // #POST-01
  // Add Folder
  /**
   * Adds a new folder to the library.
   * - Retrieves the selected sidebar link as the parent folder ID.
   * - Constructs the request parameters, including user ID, library type, folder name, and access settings.
   * - Validates the folder name before making an API call.
   * - Sends a request to add the folder and handles the response.
   * - Displays success or error messages accordingly.
   */
  addFolder() {
    // Get the selected sidebar link ID if available, otherwise set to an empty string
    let id = this.selectedSidebarLink != null && this.selectedSidebarLink?.length != undefined ? this.selectedSidebarLink : '';

    // Prepare the API request parameters
    var param = [
      {
        user_id: this.authUserID, // Authenticated user ID
        type: 'folder', // Folder type
        library_type: this.library_type, // Library type (e.g., private, shared)
        parentId: id, // Parent folder ID
        name: this.folderName?.nativeElement?.value?.trim(), // Folder name
        is_workspace: this.isWorkspace, // Indicates if the folder belongs to a workspace
        item_category: 'private', // Folder category
        private_file_access: this.file_type_nature === 'private' ? true : false, // Set private access based on file type nature
      },
    ];

    // Validate folder name before proceeding
    if (
      this.folderName?.nativeElement?.value !== undefined &&
      this.folderName?.nativeElement?.value != null &&
      this.folderName?.nativeElement?.value?.trim() != ''
    ) {
      this.loading = true; // Show loading indicator

      // Send API request to add the folder
      this.Api.post(`/library/add-folder-file`, param[0]).subscribe({
        next: response => {
          if (response.status == true) {
            // Show success message
            this.toastr.success('Folder added successfully');

            // Reset form and states
            this.addFolderModal = this.isWorkspace = this.loading = false;
            this.selectedSidebarLink = null;

            // Refresh sidebar
            this.sideBarLev1(null);
          } else {
            this.loading = false;
            // Show error message from API response
            this.toastr.error(response.message);
          }
        },
      });
    } else {
      // If folder name is empty, show validation error
      this.loading = false;
      this.error = 'Name is required!';
    }
  }

  // #POST-02
  // Add File
  async addNewFiles(_isEmbedUrl?: boolean) {
    this.percentageLoading = 100 / this.readyToUploadFiles?.length;
    this.filesUploadProgressStatus = this.readyToUploadFiles?.map((record: any, index: number) => ({
      id: index,
      name: record?.name || '',
      percentage: 0,
      drag: false,
    }));
    this.filesUploadingStatus.next(this.filesUploadProgressStatus);
    let number = 0;
    const id = this.selectedSidebarLink != null && this.selectedSidebarLink?.length != undefined ? this.selectedSidebarLink : '';
    // Loop through files one by one
    for (const [index, file] of this.readyToUploadFiles.entries()) {
      this.dragLoading = true;
      if (!this.modifiedArray.includes(file?.name)) {
        await this.uploadFile(file, id, number, _isEmbedUrl); // Wait for the current file upload to finish
        number++; // Move to the next file after the previous upload completes
      }

      // Final operation after last file is uploaded
      if (index === this.readyToUploadFiles?.length - 1) {
        this.searchKeyword = '';
        this.sideBarLev1(null);
      }
    }
  }

  /**
   * Uploads a file to the server.
   * - Constructs the request parameters, including user ID, office ID, file details, and library type.
   * - Tracks the file upload progress and updates the progress bar accordingly.
   * - Handles success and error responses, triggering relevant UI updates.
   * - Uses Promises to allow asynchronous handling of the upload status.
   *
   * @param file - The file to be uploaded.
   * @param parentId - The ID of the parent folder where the file will be uploaded.
   * @param number - A unique identifier for tracking the file upload progress.
   * @param _isEmbedUrl - Boolean indicating if the file is an embedded URL.
   * @returns A Promise that resolves when the upload is complete or rejects on error.
   */
  uploadFile(file: any, parentId: string, number: number, _isEmbedUrl: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      // Prepare API request parameters
      var param = {
        user_id: this.authUserID, // Authenticated user ID
        office_id: this.activeOfficeId, // Active office ID
        group_id: '', // Group ID (if applicable)
        type: 'file', // Type of item being uploaded
        library_type: this.library_type, // Library type (e.g., private, shared)
        file: [file], // File being uploaded
        parentId: parentId, // Parent folder ID
        name: '', // File name (if applicable)
        private_file_access: this.file_type_nature === 'private' ? true : false, // Set private access based on file type nature
      };

      // If the file is an embedded URL, add the corresponding flag
      if (_isEmbedUrl) {
        param['is_url'] = true;
      }

      this.fileUploadingLoader = this.loading = true; // Show loading indicators

      // API call for file upload
      this.http
        .post(`${this.Api.baseUrl}/library/add-folder-file`, param, {
          headers: {
            Authorization: 'Bearer ' + this.tokenService.getToken(), // Authorization token
          },
          reportProgress: true, // Enable progress tracking
          observe: 'events', // Observe upload progress events
        })
        .subscribe({
          next: (response: any) => {
            const { type, loaded = 0, total = 0, body } = response || { type: null, loaded: 0, total: 0, body: null };

            if (type === HttpEventType.UploadProgress) {
              // Calculate and update file upload progress
              let progress = Math.round((100 * loaded) / total);
              this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                if (record?.id === number) {
                  record = { ...record, percentage: progress || -1 };
                }
                return record;
              });
              this.filesUploadingStatus.next(this.filesUploadProgressStatus);
            } else if (type === HttpEventType.Response) {
              // Handle response after file upload is completed
              const { status } = body;
              this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                if (record?.id === number) {
                  record = { ...record, percentage: status ? 100 : -1 };
                }
                return record;
              });
              this.dragLoading = false;
              this.filesUploadingStatus.next(this.filesUploadProgressStatus);
            }
          },
          error: err => {
            // Handle errors and show appropriate messages
            this.toastr.error(err?.error?.message ? err?.error?.message : 'Something went wrong');
            this.fileUploadingLoader = this.loading = false;
            reject(err); // Reject the promise on error
          },
          complete: () => {
            // Complete the upload process
            this.loaderPercentage.next(Math.round(this.percentageLoading * number));
            this.fileUploadingLoader = this.loading = false;
            resolve(); // Resolve the promise when the upload completes
          },
        });
    });
  }

  // =======================
  //  #actions
  //  Action Menu Functions
  // =======================
  // # Rename File Folder (01)
  /**
   * Renames a folder or file.
   * - Ensures the new name is not empty and contains only alphanumeric characters.
   * - Constructs the request payload with the user ID, library type, item ID, and new name.
   * - Sends a PUT request to update the name in the backend.
   * - Displays success or error messages based on the API response.
   */
  renameFolderFile() {
    // Check if the new name is provided and not just whitespace
    if (this.fileFolderRename !== undefined && this.fileFolderRename != null && this.fileFolderRename?.trim() != '') {
      // Validate if the name contains only alphanumeric characters
      if (!this.hasAlphanumeric(this.fileFolderRename?.trim())) {
        this.error = 'Name should be alpha numeric characters';
        return;
      }

      // Prepare request payload
      var param = [
        {
          user_id: this.renameUserId || this.authUserID, // Use renameUserId if available, otherwise fallback to authUserID
          library_type: this.library_type, // Library type (e.g., private, shared)
          id: this.selectedFileFolderID, // ID of the file/folder to rename
          name: this.fileFolderRename?.trim(), // Trimmed new name
        },
      ];

      // API call to rename the folder/file
      this.Api.put('/library/rename-folder-file', param[0]).subscribe({
        next: response => {
          if (response.status == true) {
            // Refresh the sidebar after successful rename
            this.sideBarLev1(null);
            this.filefolderRename.nativeElement.value = ''; // Clear the input field
            this.modalRenameFolderFile = false; // Close the rename modal
            this.toastr.success('Name change successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message
          }
        },
      });
    } else {
      this.error = 'Name is required!'; // Display error if name is empty
    }
  }

  // # Add Favourite (02)
  /**
   * Adds a file or folder to the favorites list.
   * - Ensures that the provided ID is valid.
   * - Sends a PUT request to mark the item as a favorite.
   * - Updates the UI and shows a success message upon successful addition.
   *
   * @param id - The ID of the file or folder to be added to favorites.
   */
  addToFavourite(id) {
    if (id) {
      // Prepare request payload
      var param = [
        {
          user_id: this.authUserID, // ID of the authenticated user
          library_type: this.library_type, // Type of library (e.g., private, shared)
          id: id, // ID of the item to be favorite
          is_favourite: true, // Mark as favorite
        },
      ];

      // API call to add the item to favorites
      this.Api.put('/library/add-remove-from-fav', param[0]).subscribe({
        next: response => {
          if (response.status == true) {
            this.addToRecent(id); // Add the item to the recent items list
            this.sideBarLev1(null); // Refresh the sidebar
            this.isWorkspaceModalOpened = false; // Close the workspace modal if open
            this.toastr.success('Added to favourite successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message if request fails
          }
        },
      });
    }
  }

  /**
   * Removes a file or folder from the favorites list.
   * - Ensures that the provided ID is valid.
   * - Sends a PUT request to remove the item from favorites.
   * - Updates the UI and shows a success message upon successful removal.
   *
   * @param id - The ID of the file or folder to be removed from favorites.
   */
  removeToFavourite(id) {
    if (id) {
      // Prepare request payload
      var param = [
        {
          user_id: this.authUserID, // ID of the authenticated user
          library_type: this.library_type, // Type of library (e.g., private, shared)
          id: id, // ID of the item to be removed from favorites
          is_favourite: false, // Un-mark as favorite
        },
      ];

      // API call to remove the item from favorites
      this.Api.put('/library/add-remove-from-fav', param[0]).subscribe({
        next: response => {
          if (response.status == true) {
            this.sideBarLev1(null); // Refresh the sidebar
            this.isWorkspaceModalOpened = false; // Close the workspace modal if open
            this.toastr.success('Removed from favourite successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message if request fails
          }
        },
      });
    }
  }

  // # Add Recent ()
  /**
   * Adds a file or folder to the recent access list.
   * - Ensures that the provided ID is valid.
   * - Sends a POST request to update the recent access list.
   * - Updates the UI based on the user's current context.
   *
   * @param id - The ID of the file or folder to be added to recent access.
   */
  addToRecent(id) {
    if (id) {
      // Prepare request payload
      var param = [
        {
          userId: this.authUserID, // ID of the authenticated user
          library_type: this.library_type, // Type of library (e.g., private, shared)
          fileId: id, // ID of the item to be added to recent access
        },
      ];

      // API call to add the item to recent access
      this.Api.post('/library/add-to-recent-access', param[0]).subscribe({
        next: response => {
          if (response.status == true) {
            if (this.propertyId) {
              this.sideBarLev1(null); // Refresh the sidebar if propertyId exists
            } else {
              // Handle navigation based on query parameters
              this.lifetimeSubs.add(
                this.route.queryParams.subscribe(params => {
                  if (params['Id']?.toString() || params['id']?.toString()) {
                    let id = params['Id']?.toString() ? params['Id']?.toString() : params['id']?.toString();
                    this.selectFolders(id); // Select the folder based on query parameter
                  } else {
                    // Reset searched result if no valid ID is found in query parameters
                    this.searchedResultId = '';
                    this.searchedResultName = '';
                  }
                })
              );
            }
          } else {
            this.toastr.error(response.message); // Show error message if request fails
          }
        },
      });
    }
  }

  // # Move (03)
  folderParentID: any;
  /**
   * Moves a file or folder to a different parent directory.
   * - Ensures that a valid parent folder is selected.
   * - Determines the appropriate API endpoint based on the category.
   * - Sends a PUT request to move the file/folder.
   * - Updates the UI and shows success/error messages accordingly.
   */
  moveFolderFile() {
    // Validate that a folder is selected
    if (this.folderParentID === undefined || this.folderParentID == null || this.folderParentID?.length == 0) {
      this.toastr.error('Folder not selected');
      return;
    }

    // Prepare request payload
    var param = {
      user_id: this.authUserID, // ID of the authenticated user
      id: this.selectedFileFolderID, // ID of the file or folder to move
      parentId: this.folderParentID, // New parent folder ID
    };

    let url = '';

    // Determine the correct API endpoint based on the category type
    if (this.category == 'useroffice') {
      url += '/office-library/move-folder-file';
      param['office_id'] = this.activeOfficeId; // Office ID for office library
      param['propertyId'] = this.propertyId ? this.propertyId : this.officeLibraryReferenceId;
    } else {
      url += '/library/move-folder-file';
      param['library_type'] = this.library_type; // Define library type for standard library
    }

    // API call to move the folder/file
    this.Api.put(url, param).subscribe({
      next: response => {
        if (response.status == true) {
          // If not moving in 'useroffice' category, add to recent access
          this.category != 'useroffice' && this.addToRecent(this.selectedFileFolderID);
          this.sideBarLev1(null); // Refresh the sidebar
          this.resetSelectedItems(); // Reset selected items
          this.modalMoveFolder = false; // Close the move folder modal
          this.isRequestPending = false; // Reset request state
          this.toastr.success('Moved successfully'); // Show success message
        } else {
          this.toastr.error(response.message); // Show error message if request fails
          this.isRequestPending = false;
        }
      },
    });
  }

  // # Make a Copy (04)
  /**
   * Creates a copy of a specified file or folder.
   * - Ensures that a valid item is provided.
   * - Sends a POST request to copy the file/folder.
   * - Updates the UI and shows success/error messages accordingly.
   *
   * @param {any} item - The file or folder to be copied.
   */
  makeCopyFolderFile(item) {
    if (item) {
      // Prepare request payload
      var param = [
        {
          user_id: this.authUserID, // ID of the authenticated user
          library_type: this.library_type, // Type of library (e.g., personal, shared, etc.)
          id: item?._id, // ID of the item to be copied
        },
      ];

      // API call to copy the folder/file
      this.Api.post('/library/copy-folder-file', param[0]).subscribe({
        next: response => {
          if (response.status == true) {
            this.sideBarLev1(null); // Refresh the sidebar
            this.resetSelectedItems(); // Reset selected items after copying
            this.toastr.success('Copied successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message if request fails
          }
        },
      });
    }
  }

  // # Get Link (05)
  /**
   * Generates a link for a folder or file.
   * - Uses the item's path or the first item's path if an array is passed.
   * - Assigns the generated link to the input field.
   *
   * @param {any} item - The file or folder object.
   */
  getLinkFolderFile(item) {
    let link = this.S3Path + (item.path ? item.path : item[0].path);
    this.getLinkField.nativeElement.value = link;
  }

  /**
   * Copies the generated link to the clipboard.
   * - Selects the input field content.
   * - Executes the copy command (only if in a browser environment).
   * - Blurs the input field after copying.
   * - Resets selected items.
   */
  copyToClipboard() {
    this.getLinkField.nativeElement.select();
    this.checkPlatformService.isBrowser() && document.execCommand('copy');
    this.getLinkField.nativeElement.blur();
    this.resetSelectedItems();
  }

  /**
   * Shares a folder or file with selected users.
   * - Iterates through selected users and prepares a share list.
   * - Sends a request to share the folder/file with specified users.
   * - Updates UI and shows appropriate success/error messages.
   */
  shareFolderFile() {
    let shareWithUser: any = [];
    this.selectedUsersToShare.forEach(f => {
      if (f?.category == 'team') {
        if (f?.user_members && f?.user_members?.length > 0) {
          f?.user_members?.forEach(element => {
            shareWithUser.push({ to_user_id: element?._id, manage: f?.manage });
          });
        }
      } else {
        shareWithUser.push({ to_user_id: f?._id != '' ? f?._id : f?.email, manage: f?.manage });
      }
    });

    this.isRequestPending = true;
    this.isPending = true;

    if (shareWithUser.length > 0) {
      let param = {
        from_user_id: this.authUserID,
        library_type: this.library_type,
        folder_or_file_id: this.selectedFileFolderID,
        file_type: this.file_type,
        shareWith: shareWithUser,
        path: this.router.url,
      };

      this.Api.post('/library/share-folder-file', param).subscribe({
        next: response => {
          if (response.status == true) {
            this.addToRecent(this.selectedFileFolderID);
            this.sideBarLev1(null);
            this.resetSelectedItems();
            this.modalShare = false;
            this.selectedUsersToShare = [];
            this.isRequestPending = false;
            this.isPending = false;
            this.toastr.success('Shared successfully');
          } else {
            this.isRequestPending = false;
            this.toastr.error(response.message);
          }
        },
      });
    }
  }

  /**
   * Moves a folder or file to trash.
   * - Collects valid item IDs based on user permissions.
   * - Sends a request to update the status to "deleted."
   * - Shows appropriate messages based on the response.
   *
   * @param {any} Items - Single or multiple items to be moved to trash.
   */
  removeFolderFile(Items) {
    let ids: any = [];

    if (Items?.length) {
      Items.forEach(f => {
        if (f?._id && (f?.user_id == this.authUserID || f?.manage == 'edit')) {
          ids.push(f._id);
        }
      });
    } else {
      if (Items._id && (Items?.user_id == this.authUserID || Items?.manage == 'edit')) {
        ids.push(Items._id);
      }
    }

    if (ids?.length > 0) {
      this.remmiConfirm
        .delete({
          title: 'Move To Trash?',
          message: 'You can restore it from Trash later.',
          subject:
            ids.length === 1 ? (Items?.length ? Items[0]?.name : Items?.name) : `${ids.length} ${ids.length === 1 ? 'item' : 'items'} selected`,
          confirmLabel: 'Move To Trash',
        })
        .subscribe(isConfirmed => {
          if (!isConfirmed) {
            return;
          }
          var param = [
            {
              user_id: this.authUserID,
              library_type: 'private',
              id: ids,
              is_deleted: true,
            },
          ];

          this.Api.put('/library/add-remove-from-trash', param[0]).subscribe({
            next: response => {
              if (response.status == true) {
                this.sideBarLev1(null);
                this.resetSelectedItems();
                this.toastr.success('File moved to trash');
              } else {
                this.toastr.error(response.message);
              }
            },
          });
        });
    } else {
      this.toastr.error('Viewer access only');
    }
  }

  /**
   * Deletes selected files or moves them to trash.
   * - Handles different library types (personal vs. office).
   * - Ensures only valid files are deleted.
   * - Updates UI after deletion.
   *
   * @param {any} Items - Single or multiple items to be deleted.
   */
  removeFiles(Items) {
    let ids: any = [];

    if (Items?.length) {
      Items.forEach(f => {
        if (f?._id) {
          ids.push(f._id);
        }
      });
    } else {
      if (Items._id) {
        ids.push(Items._id);
      }
    }

    if (ids?.length > 0) {
      this.dragEditLoading = true;
      var param = [
        {
          user_id: this.authUserID,
          library_type: this.library_type,
          id: ids,
          is_deleted: true,
        },
      ];

      if (this.library_type == 'office') {
        let param = {
          office_id: this.Api.getOfficeId(),
          id: ids,
          propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId,
          user_id: this.authUserID,
        };

        this.Api.delete(`/office-library/delete-folder-file`, param).subscribe({
          next: response => {
            if (response?.status) {
              this.onRemove.emit(true);
              this.toastr.success('Deleted successfully');
              this.galItems = this.galItems.filter(n => !Items.includes(n));
              this.portalImages = this.portalImages.filter(n => !Items.includes(n));
              this.libraryDataCopy = this.libraryData = this.libraryData.filter(n => !Items.includes(n));
              this.sideBarLev1(null);
              this.resetSelectedItems();
              this.selectedGalItems = [];
              this.dragEditLoading = false;
            } else {
              this.toastr.error(`${response?.message}`);
              this.dragEditLoading = false;
            }
          },
          error: error => {
            this.toastr.error(error?.error?.message || 'Something went wrong');
            this.dragEditLoading = false;
          },
        });
      } else {
        this.Api.put('/library/add-remove-from-trash', param[0]).subscribe({
          next: response => {
            if (response.status == true) {
              this.galItems = this.galItems.filter(n => !Items.includes(n));
              this.portalImages = this.portalImages.filter(n => !Items.includes(n));
              this.libraryDataCopy = this.libraryData = this.libraryData.filter(n => !Items.includes(n));
              this.sideBarLev1(null);
              this.resetSelectedItems();
              this.toastr.success('File moved to trash');
              this.selectedGalItems = [];
              this.dragEditLoading = false;
            } else {
              this.toastr.error(response.message);
              this.dragEditLoading = false;
            }
          },
        });
      }
    } else {
      this.toastr.error('Viewer access only');
    }
  }

  // # Restore (06)
  /**
   * Restores a folder or file from the trash.
   *
   * This function sends a request to the API to restore a file or folder
   * by updating its 'is_deleted' status to false. If the restore operation
   * is successful, the sidebar is refreshed, and a success message is shown.
   * Otherwise, an error message is displayed.
   *
   * @param {number} id - The ID of the folder or file to be restored.
   */
  restoreFolderFile(id) {
    // Ensure the ID is valid (not undefined or null)
    if (id !== undefined && id != null) {
      // Prepare the API request parameters
      var param = {
        user_id: this.authUserID, // Current authenticated user ID
        library_type: this.library_type, // Type of library (e.g., file or folder)
        is_deleted: false, // Set is_deleted to false to restore the item
        id: [id], // Array containing the ID of the item to be restored
      };

      // Make an API request to restore the file/folder
      this.Api.put('/library/add-remove-from-trash', param).subscribe({
        next: response => {
          // If the API response status is true, restore was successful
          if (response.status == true) {
            this.sideBarLev1(null); // Refresh sidebar
            this.toastr.success('File restored'); // Show success notification
          } else {
            this.toastr.error(response.message); // Show error message if restore fails
          }
        },
      });
    }
  }

  /**
   * Deletes a specific folder or file permanently.
   *
   * This function sends a request to the API to delete a folder or file by its ID.
   * If the deletion is successful, the trash list is refreshed, and a success message is shown.
   * Otherwise, an error message is displayed.
   *
   * @param {number} id - The ID of the folder or file to be deleted.
   */
  deleteFolderFile(id) {
    let ids: any = [];

    // Check if a valid ID is provided
    if (id) {
      ids.push(id); // Add the ID to the array

      this.remmiConfirm
        .delete({
          title: 'Delete Forever?',
          message: 'This item will be permanently deleted.',
          confirmLabel: 'Delete Permanently',
        })
        .subscribe(isConfirmed => {
          if (!isConfirmed) {
            return;
          }
          // Prepare the API request parameters
          var param = [
            {
              user_id: this.authUserID, // Current authenticated user ID
              library_type: this.library_type, // Type of library (file or folder)
              id: ids, // List of IDs to be deleted
            },
          ];

          // Make an API request to delete the file/folder
          this.Api.delete('/library/delete-folder-file', param[0]).subscribe({
            next: response => {
              // If deletion is successful, refresh trash list and show success message
              if (response.status == true) {
                this.getAllTrash(); // Refresh the trash list
                this.toastr.success('File permanently deleted'); // Show success notification
              } else {
                this.toastr.error(response.message); // Show error message if deletion fails
              }
            },
          });
        });
    }
  }

  /**
   * Empties the trash by permanently deleting all selected files and folders.
   *
   * This function collects all selected files from the trash and sends an API request
   * to delete them. If successful, the trash list is refreshed, and a success message
   * is displayed. Otherwise, an error message is shown.
   */
  emptyTrash() {
    let ids = [];

    // Loop through trash data and collect selected file IDs
    this.trashLibraryData?.forEach(f => {
      if (f?.is_Selected === true) {
        ids.push(f._id); // Add the file ID to the deletion list
      }
    });

    if (!ids.length) {
      return;
    }
    this.remmiConfirm
      .delete({
        title: 'Delete Forever?',
        message: 'The selected items will be permanently deleted from Trash.',
        subject: `${ids.length} ${ids.length === 1 ? 'item' : 'items'} selected`,
        confirmLabel: 'Delete Permanently',
      })
      .subscribe(isConfirmed => {
        if (!isConfirmed) {
          return;
        }
        // Prepare the API request parameters
        var param = {
          user_id: this.authUserID, // Current authenticated user ID
          library_type: 'private', // Library type set to private
          id: ids, // List of IDs to be deleted
        };

        // Make an API request to delete selected files permanently
        this.Api.delete('/library/delete-folder-file', param).subscribe({
          next: response => {
            // If deletion is successful, refresh trash list and show success message
            if (response.status == true) {
              this.getAllTrash(); // Refresh the trash list
              this.toastr.success('File permanently deleted'); // Show success notification
            } else {
              this.toastr.error(response.message); // Show error message if deletion fails
            }
          },
        });
      });
  }

  // ====================
  // # 10
  // Helping Functions
  // ====================
  // #Folders
  contractRootId = null;
  listingRootId = null;

  /**
   * Sets the folder name input field and validates it.
   *
   * This function assigns the provided folder name to the input field and checks if the name is valid.
   * If the value is empty or only contains spaces, an error message is set.
   *
   * @param {string} value - The folder name to be set.
   */
  getFolderName(value) {
    // Ensure the value is not undefined or null
    if (value !== undefined && value != null) {
      this.folderName.nativeElement.value = value; // Set folder name in the input field

      // Validate if the name is provided
      value?.trim()?.length > 0 ? (this.error = '') : (this.error = 'Name is required!');
    }
  }

  /**
   * Sets the name for renaming a file or folder.
   *
   * This function trims the provided name, assigns it to `fileFolderRename`, and validates it.
   * If the name is empty or only contains spaces, an error message is set.
   *
   * @param {string} value - The new name for the file or folder.
   */
  setRenameFileFolder(value) {
    // Ensure the trimmed value is not undefined or null
    if (value?.trim() !== undefined && value?.trim() != null) {
      this.fileFolderRename = value?.trim(); // Assign trimmed value to fileFolderRename

      // Validate if the name is provided
      value?.trim()?.length > 0 ? (this.error = '') : (this.error = 'Name is required!');
    }
  }

  /**
   * Recursively searches for a folder in a hierarchical structure.
   *
   * This function traverses the folder structure to find a folder by its ID.
   * If found, it returns the folder's children. If `setFolderName` is true,
   * it also updates the page title. Additionally, it updates contract and listing root IDs
   * if applicable.
   *
   * @param {string} fileOrFolderId - The ID of the folder to search for.
   * @param {Array} array - The folder structure to search within.
   * @param {boolean} setFolderName - Whether to set the folder name in the UI.
   * @returns {Promise<Array>} - The child folders of the matched folder, or an empty array if not found.
   */
  selectFolder_recursive = async (fileOrFolderId, array, setFolderName) => {
    // Ensure a valid ID is provided
    if (fileOrFolderId) {
      // Iterate over the folder structure
      for (const node of array) {
        if (node?.type === 'folder') {
          // Check if the current folder matches the given ID
          if (node?._id == fileOrFolderId || node?.ref_id === fileOrFolderId) {
            if (setFolderName) {
              this.page_title = node?.name; // Set page title if required
            }
            // Update contract and listing root IDs if applicable
            this.contractRootId = this.isContractLibrary ? node?._id : null;
            this.listingRootId = this.isListingLibrary ? node?._id : null;

            return node?.childrens || []; // Return child folders if found
          }
          // If the current folder has children, perform a recursive search
          else if (node?.childrens && node?.childrens?.length > 0) {
            const result = await this.selectFolder_recursive(fileOrFolderId, node?.childrens || [], setFolderName);
            if (result.length > 0) {
              return result; // Return result if found in nested children
            }
          }
        }
      }
    }
    return []; // Return an empty array if the folder is not found
  };

  /**
   * Handles breadcrumb click events and selects the corresponding folder.
   *
   * This function is triggered when a breadcrumb is clicked and
   * calls `selectFolders` to navigate to the selected folder.
   *
   * @param {string} event - The ID of the selected breadcrumb folder.
   */
  getBreadId(event) {
    if (event) this.selectFolders(event); // Select folder based on breadcrumb ID
  }

  // ngFor passes (index, item); this used to take the index as the item, so every row keyed
  // as undefined. Falls back to the index for rows without an _id.
  trackById(index: number, item: any) {
    return item?._id ?? index;
  }

  isLoad: boolean = true;

  async selectFolders(item, isFirstLoad = false) {
    this.isLoad = false;
    setTimeout(() => {
      this.isLoad = true;
    }, 100);
    this.libraryData = null;
    if (item?._id) {
      this.emitFolderId.emit(item._id);
    }
    this.workspaceImgCopyId = null;
    var resId = null;
    // let internal_user = Crypto.decrypt(this.localStorageService.GetItem('internal_user'));

    if (!this.propertyId || this.category == 'workspace') {
      this.selectedSidebarLink = 1;
      this.page_title = 'My Files';
    }

    if (item?._id) {
      if (this.category != 'useroffice' && this.category !== 'folder') {
        this.addToRecent(item?._id);
      }
      resId = item?._id;
      if (this.isRoute) {
        if ((item?.name == 'Properties' || item?.name == 'Projects' || item?.hasOwnProperty('can_delete')) && this.propertyId == '') {
          this.router.navigate(['/library/private/office'], {
            queryParams: { Id: resId },
            queryParamsHandling: 'merge', // remove to replace all query params by provided
          });
        } else if (this.propertyId == '' && this.isNotSharedPage == true) {
          this.router.navigate(['/library/private'], {
            queryParams: { Id: resId },
          });
        }
      }
    } else {
      resId = item;
      this.workspaceImgCopyId = item;
    }
    if (this.lockToFolder && !isFirstLoad) {
      resId = this.clampToLockedFolder(resId);
    }
    this.userRoleId = Crypto.decrypt(this.localStorageService.GetItem('roleid'));
    this.selectedSidebarLink = resId;

    if (this.is_project == true) {
      let result: any = await this.selectFolder_recursive(resId, this.allDataLibrary, true);
      this.libraryDataCopy = this.libraryData =
        result instanceof Array &&
        result
          ?.filter(f => f.is_deleted == false)
          ?.map(el => {
            if (this.userRole == 'contacts' || this.isInternalFolder) {
              el = { ...el, ispermission: false };
            } else {
              el = { ...el, ispermission: true };
            }
            return el;
          });
      let isExist = this.libraryData?.find(el => el?.name?.toLowerCase() == 'project documents');
      if (isExist) {
        if (this.userRole == 'contacts' || this.isInternalFolder) {
          this.libraryData = this.libraryDataCopy;
          this.libraryData = this.libraryData
            ?.filter(el => el?.name?.toLowerCase() == 'project documents')
            ?.map(x => {
              return { ...x, ispermission: false };
            });
        }
        // else if (this.userRole == 'sales agent' && internal_user?.toString()?.includes(this.Api.getUserId())) {
        //   this.libraryData = this.libraryDataCopy;
        //   this.libraryData = this.libraryData
        //     ?.filter(el => el?.name?.toLowerCase() == 'project documents' || el?.name?.toLowerCase() == 'project admin documents')
        //     ?.map(x => {
        //       return { ...x, ispermission: true };
        //     });
        // } else {
        //   this.libraryData = this.libraryData.map(x => {
        //     return { ...x, ispermission: true };
        //   });
        // }
      }

      this.libraryData = this.filterToLockedFolder(this.libraryData);

      let allowPermission = this.allowPermission();

      if (allowPermission == false) {
        this.libraryData = this.libraryData?.map(ele => {
          ele = { ...ele, ispermission: ele?.user_id == this.Api.getUserId() ? true : false };
          return ele;
        });
      }

      console.log('this.libraryData', this.libraryData);
    } else {
      let result: any = await this.selectFolder_recursive(resId, this.allDataLibrary, true);
      if (result?.length > 0) {
        if (result[0]?.type == 'matrix') {
          result = result?.filter(f => f?.type == 'matrix' && f?.user_id == this.Api.getUserId());
        } else {
          result;
        }
      }
      this.libraryDataCopy = this.libraryData =
        result instanceof Array &&
        result
          ?.filter(f => f.is_deleted == false)
          .map(el => {
            if (this.userRole == 'contacts' || this.isInternalFolder) {
              el = { ...el, ispermission: false };
            } else {
              el = { ...el, ispermission: true };
            }
            return el;
          });
    }
    this.galItems = [];
    this.portalImages = [];
    const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));
    if (!hasIsOfflineField) {
      this.libraryData.forEach(item => {
        if (!item.hasOwnProperty('is_offline')) {
          item.is_offline = false;
        }
      });
    }
    this.libraryData.forEach(item => {
      if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png' || item.file_type === 'image/jpeg')) {
        if (item.is_offline === false) {
          this.galItems.push(item);
        } else if (item.is_offline === true) {
          this.portalImages.push(item);
        }
      }
      if (item.type == 'folder' && item.name == 'Floorplans') {
        if (!this.galItems.some(galItem => galItem._id === item._id)) {
          this.galItems.push(item);
        }
      }
    });
    this.galItems.sort((a, b) => {
      if (a.type === 'folder' && a.name === 'Floorplans') return 1;
      if (b.type === 'folder' && b.name === 'Floorplans') return -1;
      return 0;
    });
    this.lmService.exportProjectAllocationsCarStorage = {
      ...this.lmService.exportProjectAllocationsCarStorage,
      project_logo_folder: this.libraryData,
    };
    if (isFirstLoad) {
      if (this.defaultOpen?.length > 0) {
        this.GridView = true;
      }

      if (this.userRole == 'contacts' || this.isInternalFolder) {
        this.libraryData = this.libraryDataCopy;
        this.libraryData = this.libraryData
          ?.filter(el => el?.name?.toLowerCase() == 'project documents')
          ?.map(x => {
            return { ...x, ispermission: false };
          });
      }

      // else if (this.userRole == 'sales agent' && internal_user?.toString()?.includes(this.Api.getUserId())) {
      //   this.libraryData = this.libraryDataCopy;
      //   this.libraryData = this.libraryData
      //     ?.filter(el => el?.name?.toLowerCase() == 'project documents' || el?.name?.toLowerCase() == 'project admin documents')
      //     ?.map(x => {
      //       return { ...x, ispermission: true };
      //     });
      // } else {
      //   this.libraryData = this.libraryData.map(x => {
      //     return { ...x, ispermission: true };
      //   });
      // }
      this.libraryData = this.filterToLockedFolder(this.libraryData);
      let filteredDefaultFolder = this.libraryData?.filter(f => f?.name?.toLowerCase()?.indexOf(this.defaultOpen?.toLowerCase()) !== -1);
      if (this.innerDefault != '' && this.innerDefault != null && filteredDefaultFolder.length > 0) {
        for (let filterFolderData of filteredDefaultFolder) {
          filteredDefaultFolder = filterFolderData.childrens.filter(f => f?.name?.toLowerCase()?.indexOf(this.innerDefault?.toLowerCase()) !== -1);
        }
      }
      if (this.nestedInnerDefault != '' && this.nestedInnerDefault != null && filteredDefaultFolder.length > 0) {
        for (let filterFolderData of filteredDefaultFolder) {
          filteredDefaultFolder = filterFolderData.childrens.filter(
            f => f?.name?.toLowerCase()?.indexOf(this.nestedInnerDefault?.toLowerCase()) !== -1
          );
        }
      }
      if (this.appraisalsFolderId != '' && this.appraisalsFolderId != null && filteredDefaultFolder.length > 0) {
        for (let filterFolderData of filteredDefaultFolder) {
          filteredDefaultFolder = filterFolderData.childrens.filter(f => f?.ref_id?.indexOf(this.appraisalsFolderId) !== -1);
        }
      } else if (this.appraisalsFolderId != '' && this.appraisalsFolderId != null && filteredDefaultFolder.length === 0) {
        let appFolder = this.libraryData.filter(x => x.name == 'Appraisals');
        if (appFolder) {
          filteredDefaultFolder = appFolder[0]?.childrens.filter(x => x?.ref_id == this.appraisalsFolderId);
        }
      }
      if (filteredDefaultFolder?.length > 0) {
        this.libraryData = filteredDefaultFolder;
        this.selectFolders(filteredDefaultFolder?.[0]?._id, false);
      }
      if (!this.innerDefault && this.propertyId) {
        this.allDataLibrary?.forEach(ele => {
          if (ele?.name === 'Properties') {
            if (ele?.childrens?.length > 0) {
              ele?.childrens?.forEach(el => {
                if (el?.ref_id === this.propertyId) {
                  this.searchedResultId = el?._id;
                }
              });
            }
          }
        });
      }
    } else {
      this.searchedResultId = resId;
      var extractedPathString = this.getNestedPath(this.allDataLibrary, resId);
      this.getNavigationMenu(extractedPathString);
      if (this.defaultOpen == 'images') {
        this.libraryData.sort((a, b) => {
          if (a.type === 'file' && b.type === 'folder') {
            return -1;
          }
          if (a.type === 'folder' && b.type === 'file') {
            return 1;
          }
          return 0;
        });
      }
    }

    this.tooltipText = '';

    let existViewFolder = this.breadcrumbItems?.find(folder => folder?.label?.toLowerCase() == 'views');
    existViewFolder ? (this.tooltipText = 'Rename images as per the level, e.g ‘Level 1.jpg’, ‘Level 2.jpg’.') : (this.tooltipText = '');

    const tooltipMessages = {
      views: 'Rename images as per the level, e.g ‘Level 1.jpg’, ‘Level 2.jpg’.',
      gallery: 'Do not create folders without adding images. Folders are sub-categories for the gallery.',
    };

    for (const [key, message] of Object.entries(tooltipMessages)) {
      const exists = this.breadcrumbItems?.some(folder => folder?.label?.toLowerCase() === key);
      if (exists) {
        this.tooltipText = message;
        break; // stop after first match
      }
    }
    if (this.searchKeyword) this.searchKeyword = '';
  }

  /** With `lockToFolder` set, a listing that holds the locked folder (the project root) shows only that folder. */
  private filterToLockedFolder(items: any[]): any[] {
    const lock = this.lockToFolder?.toLowerCase();
    if (!lock || !(items instanceof Array) || !items.some(el => el?.name?.toLowerCase() == lock)) {
      return items;
    }
    return items.filter(el => el?.name?.toLowerCase() == lock);
  }

  /** The nodes from the library root down to `id`, or null when `id` is not in the tree. */
  private findNodeTrail(arr: any[], id: string): any[] | null {
    for (const node of arr instanceof Array ? arr : []) {
      if (node?._id === id) {
        return [node];
      }
      const child = node?.childrens ? this.findNodeTrail(node.childrens, id) : null;
      if (child) {
        return [node, ...child];
      }
    }
    return null;
  }

  /** The locked folder's id: the one under this project's folder when there is one, else the first match. */
  private findLockedFolderId(): string | null {
    const lock = this.lockToFolder?.toLowerCase();
    let fallback: string | null = null;
    let inProject: string | null = null;
    const walk = (arr: any[], underProject: boolean) => {
      for (const node of arr instanceof Array ? arr : []) {
        const isProject = underProject || (!!this.propertyId && node?.ref_id === this.propertyId);
        if (node?.type == 'folder' && node?.name?.toLowerCase() == lock && !node?.is_deleted) {
          fallback = fallback ?? node._id;
          if (isProject && !inProject) {
            inProject = node._id;
          }
        }
        if (node?.childrens) {
          walk(node.childrens, isProject);
        }
      }
    };
    walk(this.allDataLibrary, false);
    return inProject ?? fallback;
  }

  /** With `lockToFolder` set, a folder outside (or above) the locked folder is swapped for the locked folder. */
  private clampToLockedFolder(resId: any): any {
    const lock = this.lockToFolder?.toLowerCase();
    const trail = typeof resId === 'string' ? this.findNodeTrail(this.allDataLibrary, resId) : null;
    if (trail?.some(node => node?.name?.toLowerCase() == lock)) {
      return resId;
    }
    return this.findLockedFolderId() ?? resId;
  }

  allowPermission() {
    let project_association = this.lmService.ProjectDetail?.projectassociation_settings[0];
    let user_id = this.Api.getUserId();

    // High priority roles
    let isAdminRole = this.userRole === 'master admin' || this.userRole === 'operations manager';

    // Admin users
    let isAdminUser = project_association?.admins_users?.includes(user_id) || project_association?.salesmanagers_users?.includes(user_id);

    let isAdminTeamUser =
      project_association?.salesmanagers_teams_users?.includes(user_id) || project_association?.admins_teams_users?.includes(user_id);

    return isAdminRole || isAdminUser || isAdminTeamUser;
  }

  checkPermission() {
    let allowPermission = this.allowPermission();
    if (this.is_project && allowPermission == false) {
      let notAllowFileDelete = this.selectedItems?.filter(el => el?.user_id !== this.Api.getUserId());
      return notAllowFileDelete?.length > 0 ? false : true;
    } else {
      return true;
    }
  }

  // #Files
  file_type_nature = null;
  filesuploadEvent: any;
  renameUserId: String = '';

  /**
   * Triggers file upload by simulating a click event on the hidden file input element.
   * @param file - The type of file being uploaded (optional).
   */
  triggerFileUpload(file = null) {
    this.file_type_nature = file;
    try {
      // Get the file input element using its ID and trigger a click event.
      let el: HTMLElement = document.getElementById(this.fileUploadInputId) as HTMLElement;
      el.click();
    } catch (error) {
      // Silently catch errors if the element is not found or other issues occur.
    }
  }

  /**
   * Handles file selection from the file input.
   * Reads the selected files and processes them based on allowed file types.
   * @param event - The file input change event.
   */

  /** Upload whitelist: images, PDF and Word documents. */
  private readonly uploadFileTypes = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/jpg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  };

  /**
   * Whether the picked file may be uploaded. Windows hands over an empty or generic
   * `file.type` for .doc/.docx often enough that the MIME check alone would reject
   * valid Word files, so the extension is accepted as a fallback.
   */
  private isSupportedUploadFile(file: File): boolean {
    if (!file) {
      return false;
    }
    if (this.uploadFileTypes[file.type]) {
      return true;
    }
    const extensions = Object.values(this.uploadFileTypes).reduce((all, list) => all.concat(list), []);
    return extensions.some(extension => file.name?.toLowerCase().endsWith(extension));
  }

  private isPdfFile(file: File): boolean {
    return file?.type === 'application/pdf' || !!file?.name?.toLowerCase().endsWith('.pdf');
  }

  async onSelectFile(event) {
    this.filesuploadEvent = event;
    if (event?.target?.files) {
      this.readyToUploadFiles = [];
      let existFloorplansFolder = this.breadcrumbItems?.find(folder => folder?.label?.toLowerCase() == 'brochure');
      const isBrochureFolder = this.innerDefault?.toLowerCase() == 'brochure' || existFloorplansFolder;
      const firstFile: File = event.target.files[0];
      // The brochure path rasterises every page through pdf.js, so only a PDF can take it —
      // a Word or image file dropped in the same folder goes through the plain reader below.
      if (isBrochureFolder && this.isPdfFile(firstFile)) {
        const file = firstFile;
        if (!file) return;
        const pdfBase64 = await this.fileToBase64(file);
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await (pdfjsLib as any).getDocument({ data: arrayBuffer }).promise;
        const totalPages = pdf.numPages;
        const pagesData: any[] = [
          {
            name: file?.name,
            fileSrc: pdfBase64,
          },
        ]; // <-- ARRAY for storing all pages
        for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
          const page = await pdf.getPage(pageNum);

          const viewport = page.getViewport({ scale: 2 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d')!;

          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: context, viewport }).promise;

          const base64Image: string = canvas.toDataURL('image/jpeg', 0.95);

          // Upload each page image
          pagesData.push({
            name: `${file?.name}_page_${pageNum}.jpg`,
            fileSrc: base64Image,
          });

          this.progress = Math.round((pageNum / totalPages) * 100);
        }

        this.readyToUploadFiles = pagesData;
        this.addNewFileFolderPrivateFolder('file');

        console.log('if work', pagesData);
      } else {
        console.log('else work');
        const filePromises = Array.from(event?.target?.files)?.map((file: File) => {
          if (this.innerDefault == 'floorplans') {
            if (!this.isPdfFile(file)) {
              this.toastr.error('Please upload PDF files only');
              return;
            } else {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async (eventFile: any) => {
                  try {
                    resolve(this.readyToUploadFiles.push({ name: file?.name, fileSrc: eventFile?.target?.result }));
                  } catch (err) {
                    reject(err);
                  }
                };
                reader.onerror = error => {
                  reject(error);
                };
                reader.readAsDataURL(file);
              });
            }
          } else {
            if (!this.isSupportedUploadFile(file)) {
              this.toastr.error('File type not supported');
              return;
            } else {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async (eventFile: any) => {
                  try {
                    resolve(this.readyToUploadFiles.push({ name: file?.name, fileSrc: eventFile?.target?.result }));
                  } catch (err) {
                    reject(err);
                  }
                };
                reader.onerror = error => {
                  reject(error);
                };
                reader.readAsDataURL(file);
              });
            }
          }
        });
        // Wait for all promises to be resolved
        if (await Promise.all(filePromises)) {
          if (this.category == 'useroffice') {
            this.addNewFileFolderPrivateFolder('file');
          } else {
            this.addNewFiles();
          }
        } else {
          this.toastr.error('File read error.');
        }
      }
    }

    event.target.value = '';
  }

  // async onSelectFile(event) {
  //   this.filesuploadEvent = event;
  //   if (event?.target?.files) {
  //     this.readyToUploadFiles = [];
  //     let existFloorplansFolder = this.breadcrumbItems?.find(folder => folder?.label?.toLowerCase() == 'brochure');
  //     if (this.innerDefault?.toLowerCase() == 'brochure' || existFloorplansFolder) {
  //       const file = event.target.files[0];
  //       if (!file) return;
  //       const pdfBase64 = await this.fileToBase64(file);
  //       const arrayBuffer = await file.arrayBuffer();
  //       const pdf = await (pdfjsLib as any).getDocument({ data: arrayBuffer }).promise;
  //       const totalPages = pdf.numPages;
  //       const pagesData: any[] = [
  //         {
  //           name: file?.name,
  //           fileSrc: pdfBase64,
  //         },
  //       ]; // <-- ARRAY for storing all pages
  //       for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
  //         const page = await pdf.getPage(pageNum);

  //         const viewport = page.getViewport({ scale: 2 });
  //         const canvas = document.createElement('canvas');
  //         const context = canvas.getContext('2d')!;

  //         canvas.width = viewport.width;
  //         canvas.height = viewport.height;

  //         await page.render({ canvasContext: context, viewport }).promise;

  //         const base64Image: string = canvas.toDataURL('image/jpeg', 0.95);

  //         // Upload each page image
  //         pagesData.push({
  //           name: `${file?.name}_page_${pageNum}.jpg`,
  //           fileSrc: base64Image,
  //         });

  //         this.progress = Math.round((pageNum / totalPages) * 100);
  //       }

  //       this.readyToUploadFiles = pagesData;
  //       this.addNewFileFolderPrivateFolder('file');

  //       console.log('if work', pagesData);
  //     } else {
  //       console.log('else work');
  //       const filePromises = Array.from(event?.target?.files)?.map((file: File) => {
  //         const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
  //         const floorTypes = ['application/pdf'];
  //         if (this.innerDefault == 'floorplans') {
  //           if (!floorTypes.includes(file.type)) {
  //             this.toastr.error('Please upload PDF files only');
  //             return;
  //           } else {
  //             return new Promise((resolve, reject) => {
  //               const reader = new FileReader();
  //               reader.onload = async (eventFile: any) => {
  //                 try {
  //                   resolve(this.readyToUploadFiles.push({ name: file?.name, fileSrc: eventFile?.target?.result }));
  //                 } catch (err) {
  //                   reject(err);
  //                 }
  //               };
  //               reader.onerror = error => {
  //                 reject(error);
  //               };
  //               reader.readAsDataURL(file);
  //             });
  //           }
  //         } else {
  //           if (!allowedTypes.includes(file.type)) {
  //             this.toastr.error('File type not supported');
  //             return;
  //           } else {
  //             return new Promise((resolve, reject) => {
  //               const reader = new FileReader();
  //               reader.onload = async (eventFile: any) => {
  //                 try {
  //                   resolve(this.readyToUploadFiles.push({ name: file?.name, fileSrc: eventFile?.target?.result }));
  //                 } catch (err) {
  //                   reject(err);
  //                 }
  //               };
  //               reader.onerror = error => {
  //                 reject(error);
  //               };
  //               reader.readAsDataURL(file);
  //             });
  //           }
  //         }
  //       });
  //       // Wait for all promises to be resolved
  //       if (await Promise.all(filePromises)) {
  //         if (this.category == 'useroffice') {
  //           this.addNewFileFolderPrivateFolder('file');
  //         } else {
  //           this.addNewFiles();
  //         }
  //       } else {
  //         this.toastr.error('File read error.');
  //       }
  //     }
  //   }

  //   event.target.value = '';
  // }

  progress = 0;
  private async fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = err => reject(err);
      reader.readAsDataURL(file);
    });
  }

  /**
   * Toggles the add folder modal.
   * Resets the folder name input field.
   * @param isWorkspaceCreation - Flag indicating whether the modal is for workspace creation.
   */
  showAddFolderModal(isWorkspaceCreation = false) {
    this.isWorkspace = isWorkspaceCreation;
    this.addFolderModal = !this.addFolderModal;
    this.folderName.nativeElement.value = '';
  }

  /**
   * Displays the rename modal for a file or folder.
   * Prevents renaming if the user has only viewer access.
   * @param item - The file or folder to be renamed.
   */
  showRenameModal(item) {
    if (item?.can_delete !== undefined && item?.can_delete != null && item?.can_delete == false) {
      this.toastr.error(`Viewer access only`);
    } else {
      this.modalRenameFolderFile = !this.modalRenameFolderFile;
      this.isWorkspace = item?.files_or_folders ? true : false;
      this.selectedFileFolderID = item?._id;
      this.renameUserId = item?.user_id;
      this.fileFolderRename = this.filefolderRename.nativeElement.value = item?.name;
    }
  }

  /**
   * Opens the modal to move a folder.
   * Determines if the folder is being moved to a workspace or another folder.
   * @param item - The folder to be moved.
   * @param moveToFolderOrWorkspace - Specifies whether the destination is a workspace or folder.
   */
  showMoveFolderModal(item, moveToFolderOrWorkspace = 'folder') {
    this.modalMoveFolder = !this.modalMoveFolder;
    this.selectedFileFolderID = item?._id;

    // Embedded, the destinations are not read on the way in; the picker fills as they arrive.
    if (moveToFolderOrWorkspace == 'workspace' && !this.workspaceDataList?.length) {
      this.getAllWorkspace();
    } else if (moveToFolderOrWorkspace != 'workspace' && !this.onlyFoldersData?.length) {
      this.getOnlyFolders();
    }

    if (moveToFolderOrWorkspace == 'workspace') {
      this.isAddingInWorkspace = true;
      // Filter workspaces that are not deleted or hidden and map them for selection.
      this.cachingFoldersData = this.workspaceDataList
        ?.filter(folder => folder?.is_deleted == false && folder?.is_hide == false)
        ?.map(folder => ({ ...folder, label: folder?.name }));
    } else {
      this.isAddingInWorkspace = false;
      // Filter folders that are not workspaces.
      this.cachingFoldersData = this.onlyFoldersData?.filter(folder => !folder?.is_workspace);
    }
  }

  /**
   * Sets the selected parent folder ID.
   * @param val - The selected folder ID.
   */
  selectParentFolder(val) {
    if (val) {
      this.folderParentID = val;
    }
  }

  selectedNode: any;
  selectedNodeToMoveIN: any;
  ModalGetPath = false;
  FileSharedUsersList: any = [];
  file_type = null;
  sharedItems = null;
  imageLength: any[] = [];
  // Handles node selection and updates the parent folder ID
  nodeSelect() {
    this.folderParentID = this.selectedNodeToMoveIN?._id;
  }

  checkPublicPrivate(file) {
    if (file?.private_file_access == true) {
      this.file_access = true; // Trigger file access validation
      this.pendingAction = 'preview';
      this.selectedContextMenuItem = file;
    } else {
      this.showModalPreview(file); // Show preview modal for the file
    }
  }

  isImagePreviewLoading = false;
  // Displays the preview modal for a selected file item
  showModalPreview(item) {
    this.fileImagePWLink = null;
    this.isImagePreviewLoading = true;
    if (item?.type == 'file') {
      this.searchedResultId = null;
      this.isWorkspaceModalOpened = false;
      this.modalPreview = true;

      // Check if the file is an image, a direct URL, or another file type
      if (item.file_type != 'image/png' && item.file_type != 'image/jpeg' && item.file_type != 'image/jpg' && !item?.is_url) {
        this.filePWLink = this.S3Path + item.path; // Set file path for preview
      } else if (item?.is_url) {
        this.fileEmbedVideoURL = this.extractIframeTagFromInnerHtml(item?.path) || ''; // Extract and set embedded video URL
      } else {
        this.imageGalleryPreview = this.libraryData?.filter((record: any) => record?.type != 'folder' && record?.file_type?.startsWith('image'));
        this.fileImagePWLink = this.S3Path + item.path;
      }
      this.isImagePreviewLoading = false; // only render now
      this.addToRecent(item._id); // Add file to the recent items list
    }
  }

  // Opens the "Get Link" modal and retrieves the shareable link
  showModalGetLink(item) {
    this.modalGetLink = true;
    this.getLinkFolderFile(item);
  }

  // Opens the "Get Path" modal and constructs the full file path
  showModalGetPath(item) {
    this.ModalGetPath = true;
    let path = 'Library/';

    // Construct the path using breadcrumb items
    this.breadcrumbItems?.forEach(element => {
      path += element?.label + '/';
    });

    path += item?.name;
    this.getLinkPath.nativeElement.value = path; // Set the constructed path in the input field
  }

  // Opens the "Share" modal and retrieves the list of users who can share the file
  showModalShare(item) {
    this.sharedItems = item;
    this.selectedUsersToShare = [];

    // Check category and fetch shared user list accordingly
    if (this.propertyId?.length > 0 || this.category == 'useroffice') {
      this.getAllUserListFileSharedPrivateLibrary(item);
    } else {
      this.getAllFileSharedUser(item?._id);
    }

    // Embedded, neither the staff list nor the teams are read on the way in; the share picker
    // searches both, so this is the first time either is needed.
    if (!this.allUsers?.length) {
      this.getAllUsers();
    }
    if (!this.teams?.length) {
      this.loadData();
    }

    this.modalShare = true;
    this.selectedFileFolderID = [];

    // Store the selected file/folder IDs and file type
    if (item instanceof Array) {
      item.forEach(f => {
        this.selectedFileFolderID.push(f?._id);
        this.file_type = f?.type;
      });
    } else {
      this.selectedFileFolderID.push(item?._id);
      this.file_type = item?.type;
    }
  }

  // Fetches the list of users with whom the file is shared
  getAllFileSharedUser(id) {
    this.FileSharedUsersList = [];

    if (id !== undefined && id != null && id?.length > 0) {
      var param = {
        userId: this.authUserID,
        libraryType: this.library_type,
      };

      // API call to fetch shared users
      this.Api.get(`/library/shared-with-detail/${id}`, param).subscribe({
        next: data => {
          if (data?.status == true) {
            let response = data?.data;
            if (response !== undefined && response != null && response?.length > 0) {
              response?.forEach(element => {
                if (element?.user !== undefined && element?.user != null) {
                  this.FileSharedUsersList?.push({ ...element?.user, manage: element?.manage });
                }
              });
            }

            // Merge the lists while removing duplicates
            this.selectedUsersToShare = [
              ...new Map([...this.selectedUsersToShare, ...this.FileSharedUsersList].map(user => [user._id, user])).values(),
            ];
          } else {
            this.toastr.error(data.message);
          }
        },
      });
    }
  }

  /** Permission a share-row dropdown held before it was changed, so a cancelled 'remove' can be undone. */
  permissionBeforeChange: string = null;

  rememberPermission(item) {
    this.permissionBeforeChange = item?.manage;
  }

  // Handles changes in user permissions and removes user access if needed
  onChangeUserPermission(event, item) {
    if (event?.value == 'remove') {
      if (this.propertyId?.length > 0) {
        // Remove user from shared file list and show a success message
        this.selectedUsersToShare = this.FileSharedUsersList = this.selectedUsersToShare?.filter(r => r?._id != item?._id);
        this.toastr.success('User access ended');
      } else {
        // The dropdown has already switched to 'remove'; on Cancel put back the permission it had on focus.
        const previousPermission = this.permissionBeforeChange;
        this.remmiConfirm
          .ask({
            title: 'Stop Sharing?',
            message: 'This user will lose access to the shared item.',
            subject: item?.name,
            confirmLabel: 'Stop Sharing',
            tone: 'warning',
          })
          .subscribe(isConfirmed => {
            if (!isConfirmed) {
              item.manage = previousPermission;
              return;
            }
            // Remove user and call API to remove them from shared files
            this.selectedUsersToShare = this.FileSharedUsersList = this.selectedUsersToShare?.filter(r => r?._id != item?._id);
            this.removeUserFromSharedFile(item?._id);
          });
      }
    } else {
      this.permissionBeforeChange = event?.value;
    }
  }

  // Removes a user from the shared file list
  removeUserFromSharedFile(userId) {
    var param = {
      from_user_id: this.authUserID,
      library_type: this.library_type,
      folder_or_file_id: this.selectedFileFolderID,
      to_user_id: [userId],
    };
    this.Api.delete('/library/remove-from-shared-users', param).subscribe({
      next: response => {
        if (response.status == true) {
          this.getAllFileSharedUser(this.selectedFileFolderID); // Refresh shared users list
          this.toastr.success('User access ended');
        } else {
          this.toastr.error(response.message);
        }
      },
    });
  }

  // Handles item selection based on user interaction
  _selectItem(clickEvent, item) {
    // Navigate based on item type
    if (item?.type === 'matrix') {
      this.router.navigateByUrl('/project_/sale-board/' + item.ref_id);
    }
    if (item?.type === 'reports') {
      this.router.navigateByUrl('/report/edit-report/' + item.ref_id);
    }

    // Handle multiple selections with Ctrl or Command key
    if (clickEvent.ctrlKey || clickEvent.metaKey) {
      if (this.selectedItems.indexOf(item) === -1) {
        this.selectedItems.push(item);
      } else {
        if (this.selectItem?._id !== item?._id) {
          const index = this.selectedItems.findIndex(selected => selected._id === item._id);
          if (index !== -1) {
            this.selectedItems.splice(index, 1);
          }
        }
      }
    } else {
      // Single selection mode
      this.selectedItems = [];
      let s_item = item;
      this.selectedItems.push(s_item);
      this.selectItem = this.selectedContextMenuItem = this.selectedItems[0];
    }
  }

  // Retrieves the original large image path
  getOriginalLargeImageByPath(item) {
    if (!this.imageLength?.find(x => x?.name == item?.name)) {
      this.imageLength.push(item);
      this.imageUploadedLenght.emit(this.imageLength?.length);
    }
    if (!item?.path && item?.path != null) {
      item = this.images?.lib_drag_image;
    }
    let thePath = this.S3Path + item?.orignal_path;
    return thePath + '?n=575';
  }

  // Retrieves the large image path
  getLargeImageByPath(item) {
    if (!this.imageLength?.find(x => x?.name == item?.name)) {
      this.imageLength.push(item);
      this.imageUploadedLenght.emit(this.imageLength?.length);
    }
    if (!item?.path && item?.path != null) {
      item = this.images?.lib_drag_image;
    }
    let thePath = this.S3Path + item?.path;
    return thePath + '?n=575';
  }

  // Retrieves the compressed image path
  getCompressImageByPath(item) {
    if (!this.imageLength?.find(x => x?.name == item?.name)) {
      this.imageLength.push(item);
      this.imageUploadedLenght.emit(this.imageLength?.length);
    }
    if (item?.type !== 'matrix' && !item?.path && item?.path != null) {
      item = this.images?.lib_drag_image;
    }
    if (item?.type === 'matrix') {
      return this.images?.lib_file_image;
    }
    let thePath =
      item.compressedPath && item.compressedPath != null && item.compressedPath != '' ? this.S3Path + item?.compressedPath : this.S3Path + item?.path;
    return thePath + '?n=575';
  }

  // Retrieves the thumbnail or fallback image path
  getImageByPath(item) {
    if (!this.imageLength?.find(x => x?.name == item?.name)) {
      this.imageLength.push(item);
      this.imageUploadedLenght.emit(this.imageLength?.length);
    }
    if (!item?.path && item?.path != null) {
      item = this.images?.lib_drag_image;
    }
    let thePath = item.thumbPath && item.thumbPath != null && item.thumbPath != '' ? this.S3Path + item?.thumbPath : this.S3Path + item?.path;
    return thePath + '?n=575';
  }

  // Checks if an image is in the "not found" list
  isImageNotFound(item) {
    return this.imgNotFoundList.includes(item?.name);
  }

  user_detail = null;
  file_access = false;
  file_access_pin = null;
  download_file = null;
  download_multiple_file = false;
  download_multiple_files = [];
  // Fetches the details of the currently logged-in user
  getLoginUserDetail() {
    this.redux.getUser().subscribe({
      next: response => {
        const data = JSON.parse(JSON.stringify(response));
        this.user_detail = data?.data;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  // Downloads a file. If the file has private access, user authentication is required before download.
  downloadFile(item) {
    if (!navigator.onLine) {
      this.toastr.error('No internet connection');
      return;
    }

    if (item?.private_file_access == true) {
      this.file_access = true; // Trigger file access validation
      this.download_file = item;
      this.getLoginUserDetail(); // Fetch user details for verification
    } else {
      this.trackDownload(1);
      window.location.href = this.S3Path + item?.path; // Directly download the file
    }
  }

  private trackDownload(count: number): void {
    this.activityTracker.track('document_download', { meta: { count, module: 'library' } });
  }

  checkFileAccess(item, action) {
    let array = this.libEdit ? this.selectedGalItems : this.selectedItems;
    let includePrivateFile = array?.some(x => x?.private_file_access == true);
    if (includePrivateFile) {
      this.file_access = true; // Trigger file access validation
      this.pendingAction = action; // Store the pending action
      this.selectedContextMenuItem = item;
      this.getLoginUserDetail(); // Fetch user details for verification
    } else if (action == 'share') {
      this.showModalShare(this.selectedItems);
    } else if (action == 'remove') {
      console.log('selectedItems', this.selectedItems);
      let delete_item = this.selectedItems?.length > 0 ? this.selectedItems : item;
      this.category != 'useroffice' && this.removeFolderFile(delete_item);
      this.category == 'useroffice' && this.removeOfficeLibraryFileFolders(delete_item);
    }
  }

  // Validates the user-entered PIN for file access
  checkPin() {
    if (!this.file_access_pin) {
      this.toastr.error('Please enter PIN first');
      return;
    }
    if (this.user_detail?.file_access_pin === this.file_access_pin) {
      this.file_access = false; // Close the PIN popup
      this.toastr.success('PIN matched successfully');

      // If there's a pending action (e.g., download), execute it
      if (this.pendingAction == 'download') {
        if (this.download_multiple_file == true) {
          this.downloadMoreFile(this.download_multiple_files);
        } else {
          this.trackDownload(1);
          window.location.href = this.S3Path + this.download_file?.path;
        }
      } else if (this.pendingAction == 'popup-editor-delete') {
        this.selectedContextMenuItem = null;
        this.removeFiles(this.selectedGalItems);
      } else if (this.pendingAction == 'popup-editor-duplicate') {
        this.selectedContextMenuItem = null;
        this.duplicateFiles();
      } else {
        this.executeContextMenuAction(this.pendingAction);
      }

      // Reset related variables
      this.file_access_pin = null;
      this.pendingAction = null;
      this.download_file = null;
    } else {
      this.toastr.error('Invalid PIN');
    }
  }

  // Downloads multiple files as a ZIP archive
  downloadMoreFile(files) {
    this.trackDownload(files?.length || 0);
    const zip = new JSZip.default();
    files.forEach(el => {
      const fileUrl = this.S3Path + el?.path;
      const fileName = el?.name;

      // Fetch each file and add it to the ZIP archive
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          zip.file(fileName, blob);
          if (Object.keys(zip.files).length === files.length) {
            zip.generateAsync({ type: 'blob' }).then(zipBlob => {
              const downloadLink = document.createElement('a');
              downloadLink.href = URL.createObjectURL(zipBlob);
              downloadLink.download = 'library_file.zip';
              downloadLink.click();
              URL.revokeObjectURL(downloadLink.href);
              document.body.removeChild(downloadLink);
            });
          }
        });
    });

    // Reset multiple file download flags
    this.download_multiple_file = false;
    this.download_multiple_files = [];
  }

  // Handles the download of multiple files with a private access check
  downloadMultiple(files) {
    if (files?.length > 0) {
      let isPrivateExist = files?.find(el => el?.private_file_access == true);

      if (isPrivateExist) {
        this.file_access = true; // Trigger file access validation
        this.download_multiple_file = true;
        this.download_multiple_files = files;
        this.getLoginUserDetail(); // Fetch user details
      } else {
        this.trackDownload(files.length);
        const zip = new JSZip.default();
        files.forEach(el => {
          const fileUrl = this.S3Path + el?.path;
          const fileName = el?.name;

          // Fetch each file and add it to the ZIP archive
          fetch(fileUrl)
            .then(response => response.blob())
            .then(blob => {
              zip.file(fileName, blob);
              if (Object.keys(zip.files).length === files.length) {
                zip.generateAsync({ type: 'blob' }).then(zipBlob => {
                  const downloadLink = document.createElement('a');
                  downloadLink.href = URL.createObjectURL(zipBlob);
                  downloadLink.download = 'library_file.zip';
                  downloadLink.click();
                  URL.revokeObjectURL(downloadLink.href);
                  document.body.removeChild(downloadLink);
                });
              }
            });
        });
      }
    }
  }

  // Retrieves the full name of a user based on their ID
  getUserName(id) {
    return this.allUsers?.filter(user => user?._id == id)?.[0]?.full_name ? this.allUsers?.filter(user => user?._id == id)?.[0]?.full_name : 'N/A';
  }

  // Generates an HTML tooltip containing file or folder details
  getFolderFileInformationTooltipHandler(item) {
    var info = '';
    if (item?.name) {
      info += `<li style='display: table-row; font-size: ${this.propertyId?.length > 0 ? '10px' : '12px'}; white-space: normal; word-wrap: break-word;'><span style='display: table-cell;'>Name: </span>${item?.name}</li>`;
    }
    if (item?.user_id) {
      info += `<li style='display: table-row;font-size: ${this.propertyId?.length > 0 ? '10px' : '12px'}'><span style='display: table-cell;'>Creator:  </span>${this.getUserName(item?.user_id)}</li>`;
    }
    if (item?.created_at) {
      info += `<li style='display: table-row;font-size: ${this.propertyId?.length > 0 ? '10px' : '12px'}'><span style='display: table-cell;'>Created:  </span>${moment(item?.created_at)?.format('DD MMM YYYY')}</li>`;
    }
    if (item?.updated_at) {
      info += `<li style='display: table-row;font-size: ${this.propertyId?.length > 0 ? '10px' : '12px'}'><span style='display: table-cell;'>Modified:&nbsp;&nbsp;</span>${moment(item?.updated_at)?.format('DD MMM YYYY')}</li>`;
    }
    return info?.length > 0 ? `<ul class="text-truncate" style='list-style: none;'> ${info} </ul>` : 'N/A';
  }

  // Handles file selection and prepares data for upload
  fileChange(event) {
    let fileList: FileList = event.target.files;

    if (fileList?.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();

      return formData.append('uploadFile', file, file.name);
    }
  }

  //#region "Workspace"

  workspaceDataList: any = [];
  isWorkspaceModalOpened: boolean = false;
  workspaceDetailedData: any = null;
  workspaceRecentFiles: any[] = [];
  getWorkspaceRecentAccess() {
    var param = {
      user_id: this.authUserID,
      library_type: 'private', //this.library_type,
    };
    this.Api.get('/library/workspace-recent', param).subscribe({
      next: data => {
        if (data.status == true) {
          let response = data?.data;
          if (response !== undefined && response != null && response?.length > 0) {
            response?.forEach(element => {
              if (element !== undefined && element != null && element?.file !== undefined && element?.file != null) {
                this.workspaceRecentFiles.push(element);
              }
            });
          }
        } else {
          this.toastr.error(data.message);
        }
      },
    });
  }
  // Adds a file to the user's recent workspace list
  addToRecentWorkspace(id) {
    var param = {
      user_id: this.authUserID, // Current authenticated user's ID
      file_id: id, // ID of the file to be added
      workspace_id: this.folderParentID, // ID of the parent workspace
      library_type: this.library_type, // Type of library (e.g., personal, shared)
    };

    // Ensure the file ID is valid before making the API call
    if (id !== undefined && id != null) {
      this.Api.post('/library/add-workspace-recent', param).subscribe({
        next: response => {
          if (response.status == true) {
            this.workspaceRecentFiles = response?.data; // Update the recent files list
          } else {
            this.toastr.error(response.message); // Show error message if request fails
          }
        },
      });
    }
  }

  // Opens the workspace modal and assigns the selected workspace data
  openWorkspaceModal(item) {
    this.isWorkspaceModalOpened = true; // Set modal visibility to true
    this.workspaceDetailedData = item; // Store the selected workspace details
  }

  // Creates a new workspace if the folder name is valid
  createNewWorkspace() {
    if (this.folderName?.nativeElement?.value?.trim()?.length > 0) {
      let param = {
        user_id: this.authUserID, // Current authenticated user's ID
        library_type: this.library_type, // Type of library (e.g., personal, shared)
        name: this.folderName?.nativeElement?.value?.trim(), // Workspace name from input
        item_category: 'workspace', // Category of the item
      };

      this.loading = true; // Start loading indicator

      // API call to create a new workspace
      this.Api.post('/library/new-workspace', param).subscribe({
        next: response => {
          if (response.status == true) {
            this.sideBarLev1(null); // Refresh sidebar or update UI
            this.resetSelectedItems(); // Reset selected items
            this.addFolderModal = false; // Close the create folder modal
            this.selectedUsersToShare = []; // Clear selected users list
            this.isRequestPending = false; // Reset request flag
            this.loading = false; // Stop loading indicator
            this.toastr.success('Workspace created successfully'); // Show success message
          } else {
            this.loading = false; // Stop loading on error
            this.toastr.error(response.message); // Show error message
          }
        },
      });
    }
  }

  // Adds a selected file or folder into the workspace
  addItemIntoWorkspace() {
    // Check if a folder is selected before proceeding
    if (this.folderParentID === undefined || this.folderParentID == null || this.folderParentID?.length == 0) {
      this.toastr.error('Folder not selected'); // Show error message if no folder is selected
      return;
    }

    // Prepare the request parameters
    let param = {
      user_id: this.authUserID, // ID of the authenticated user
      library_type: this.library_type, // Type of library (e.g., personal, shared)
      id: this.folderParentID, // ID of the selected folder
      file_or_folder_id: this.selectedFileFolderID, // ID of the file or folder to be added
    };

    // API call to add the item into the workspace
    this.Api.post('/library/add-into-workspace', param).subscribe({
      next: response => {
        if (response.status == true) {
          this.addToRecentWorkspace(this.selectedFileFolderID); // Add to recent workspace
          this.sideBarLev1(null); // Refresh the sidebar or update UI
          this.resetSelectedItems(); // Reset selected items
          this.modalMoveFolder = false; // Close move folder modal
          this.isRequestPending = false; // Reset request flag
          this.toastr.success('Added successfully'); // Show success message
        } else {
          this.toastr.error(response.message); // Show error message
          this.isRequestPending = this.modalMoveFolder = false; // Reset request and modal state
        }
      },
      error: error => {
        this.toastr.error(error?.error?.message); // Handle API error response
      },
    });
  }

  // Checks if a string contains at least one alphanumeric character (A-Z, a-z, 0-9)
  hasAlphanumeric(str) {
    const alphanumericRegex = /[a-zA-Z0-9]/; // Regular expression for alphanumeric check
    return alphanumericRegex.test(str); // Returns true if the string contains at least one alphanumeric character
  }

  // Renames a workspace with validation for non-empty and alphanumeric names
  renameWorkspace() {
    // Check if the new name is defined, not null, and not an empty string
    if (this.fileFolderRename !== undefined && this.fileFolderRename != null && this.fileFolderRename?.trim() != '') {
      // Validate if the name contains at least one alphanumeric character
      if (!this.hasAlphanumeric(this.fileFolderRename?.trim())) {
        this.error = 'Name should be alpha-numeric characters'; // Set error message
        return;
      }

      // Prepare the request parameters
      var param = {
        id: this.selectedFileFolderID, // ID of the selected file or folder
        name: this.fileFolderRename?.trim(), // Trimmed new name for the workspace
      };

      // API call to rename the workspace
      this.Api.put('/library/rename-workspace', param).subscribe({
        next: response => {
          if (response.status == true) {
            this.sideBarLev1(null); // Refresh the sidebar or update UI
            this.filefolderRename.nativeElement.value = ''; // Clear the input field
            this.modalRenameFolderFile = false; // Close the rename modal
            this.toastr.success('Name changed successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message
          }
        },
      });
    } else {
      this.error = 'Name is required!'; // Show error if the input name is empty
    }
  }

  // Removes an item (file or folder) from the workspace
  removeItemFromWorkspace(id) {
    // Prepare the request parameters
    let params = {
      id: this.workspaceDetailedData?._id, // ID of the workspace
      file_or_folder_id: id, // ID of the item to be removed
    };

    // Check if the item ID is valid before making the API call
    if (id !== undefined && id != null && id?.length > 0) {
      this.remmiConfirm
        .delete({
          title: 'Remove From Workspace?',
          message: 'The item will be removed from this workspace. The file itself is not deleted.',
          confirmLabel: 'Remove',
        })
        .subscribe(isConfirmed => {
          if (!isConfirmed) {
            return;
          }
          this.Api.put(`/library/remove-item-from-workspace`, params).subscribe({
            next: response => {
              if (response.status == true) {
                this.isWorkspaceModalOpened = false; // Close the workspace modal
                this.sideBarLev1(null); // Refresh the sidebar or update UI
                this.toastr.success('Item removed successfully'); // Show success message
              } else {
                this.toastr.error(response.message); // Show error message
              }
            },
          });
        });
    }
  }

  // Removes a workspace based on the provided ID
  removeWorkspace(id) {
    // Check if the workspace ID is valid before making the API call
    if (id !== undefined && id != null && id?.length > 0) {
      this.remmiConfirm
        .delete({
          title: 'Delete Workspace?',
          message: 'This workspace will be deleted.',
          confirmLabel: 'Delete',
        })
        .subscribe(isConfirmed => {
          if (!isConfirmed) {
            return;
          }
          this.Api.delete(`/library/delete-workspace/${id}`, null).subscribe({
            next: response => {
              if (response.status == true) {
                this.sideBarLev1(null); // Refresh the sidebar or update UI
                this.toastr.success('Workspace removed successfully'); // Show success message
              } else {
                this.toastr.error(response.message); // Show error message
              }
            },
          });
        });
    }
  }

  // Toggles the visibility of a workspace (hide or show)
  hideShowWorkspace(id) {
    // Check if the workspace ID is valid before making the API call
    if (id !== undefined && id != null && id?.length > 0) {
      this.Api.put(`/library/show-hide-workspace/${id}`, null).subscribe({
        next: response => {
          if (response.status == true) {
            this.sideBarLev1(null); // Refresh the sidebar or update UI
            this.toastr.success('Workspace hide successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message
          }
        },
      });
    }
  }

  // Fetches all workspaces associated with the authenticated user
  getAllWorkspace() {
    var param = {
      user_id: this.authUserID, // User ID of the authenticated user
      library_type: this.library_type, // Type of the library being accessed
      office_id: this.activeOfficeId, // Active office ID
    };

    // API call to fetch workspace data
    this.Api.get(`/library/workspace`, param).subscribe({
      next: response => {
        if (response.status == true) {
          this.workspaceDataList = response.data; // Store the fetched workspace data

          // If the user is on the 'My Workspace' page, process the data accordingly
          if (this.page_title == 'My Workspace') {
            if (this.isHiddenWorkspaceVisible) {
              // Filter out hidden or non-deleted workspaces
              this.libraryDataCopy =
                this.libraryData =
                this.allDataLibrary =
                  this.workspaceDataList
                    ?.filter(folder => folder?.is_hide || folder?.is_deleted == false)
                    .map(el => {
                      // Grant permission to specific roles
                      if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
                        el = { ...el, ispermission: true };
                        return el;
                      }
                    });
            } else {
              // Same filtering logic applied for non-hidden workspaces
              this.libraryDataCopy =
                this.libraryData =
                this.allDataLibrary =
                  this.workspaceDataList
                    ?.filter(folder => folder?.is_hide || folder?.is_deleted == false)
                    .map(el => {
                      if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
                        el = { ...el, ispermission: true };
                        return el;
                      }
                    });
            }
            this.loading = false; // Stop loading indicator
          }
        } else {
          this.toastr.error(response.message); // Show error message
        }
      },
    });
  }

  // Adds a selected item into a workspace
  addToWorkspace(item) {
    // Ensure the item has a valid ID before proceeding
    if (item?._id === undefined || item?._id == null || item?._id?.length == 0) {
      this.toastr.error('Folder not selected');
      return;
    }

    // Store the selected item and its parent folder ID
    this.selectedFileFolderID = item?._id;
    this.folderParentID = this.selectedContextMenuItem?._id;

    // Call function to add the item to the workspace
    this.addItemIntoWorkspace();
  }

  // Toggles visibility of hidden workspaces based on user selection
  onChangeWorkspaceHidden() {
    if (this.isHiddenWorkspaceVisible) {
      // Show only hidden workspaces
      this.libraryData = this.workspaceDataList?.filter(folder => folder?.is_hide);
    } else {
      // Show only visible workspaces
      this.libraryData = this.workspaceDataList?.filter(folder => folder?.is_hide == false);
    }
  }

  dragDropFileId: String = '';
  /**
   * Handles the start of a drag event.
   * Sets the `dragDropFileId` only if no request is currently pending.
   *
   * @param event - The drag event object
   * @param item - The item being dragged
   */
  onDragStart(event: DragEvent, item: any) {
    event?.stopPropagation(); // Prevents event bubbling
    if (!this.isRequestPending) {
      this.dragDropFileId = item?._id; // Store the ID of the dragged item
    }
  }

  /**
   * Handles the drag-over event when an item is dragged over a drop target.
   * It prevents the default event behavior, disables tooltips, and displays a message
   * depending on the drop target.
   *
   * @param event - The drag event object
   * @param item - The target item over which the dragged item is hovering
   */
  onDragOver(event: any, item: any) {
    event?.preventDefault(); // Allows the drop event to occur
    event?.stopPropagation(); // Prevents event propagation
    this.isTooltipDisabled = true; // Disables tooltips during drag operation

    // Check if the drag is over the main drag-and-drop area
    if (event?.currentTarget?.id == 'drag-n-drop-main-td') {
      this.addDragNDropStyles('drag-n-drop-main-td'); // Apply styles
      this._primeMessageService.add({
        severity: 'info',
        detail: `Drop files to instantly upload them to: ${this.searchedResultName ? this.searchedResultName : 'My Files'}`,
        sticky: true,
        closable: false,
        icon: 'pi-cloud-upload',
      });
    }
    // Check if the drag is over the main drag-and-drop area
    if (event?.currentTarget?.id == 'drag-n-drop-edit') {
      // this.addDragNDropStyles('drag-n-drop-main-td'); // Apply styles
      this._primeMessageService.add({
        severity: 'info',
        detail: `Drop files to instantly upload them to: ${this.searchedResultName ? this.searchedResultName : 'My Files'}`,
        sticky: true,
        closable: false,
        icon: 'pi-cloud-upload',
      });
    }
    // Check if the drag is over the main drag-and-drop area
    if (event?.currentTarget?.id == 'portalImgList') {
      // this.addDragNDropStyles('drag-n-drop-main-td'); // Apply styles
      this._primeMessageService.add({
        severity: 'info',
        detail: `Drop files to instantly upload them to: ${this.searchedResultName ? this.searchedResultName : 'My Files'}`,
        sticky: true,
        closable: false,
        icon: 'pi-cloud-upload',
      });
    }
    // Check if dragging over the primary drag area
    else if (event?.currentTarget?.id == 'drag-n-drop-main') {
      this.addDragNDropStyles(event?.target?.id); // Apply styles
      this._primeMessageService.add({
        severity: 'info',
        detail: `Drop files to instantly upload them to: ${this.searchedResultName ? this.searchedResultName : 'My Files'}`,
        sticky: true,
        closable: false,
        icon: 'pi-cloud-upload',
      });
    }
    // Check if the dragged item is a different folder from the target folder
    else if (this.dragDropFileId != item?._id && item?.type == 'folder') {
      this.addDragNDropStyles(item?._id); // Apply styles to the target folder
      this._primeMessageService.add({
        severity: 'info',
        detail: `Drop files to instantly upload them to: ${item?.name}`,
        sticky: true,
        closable: false,
        icon: 'pi-cloud-upload',
      });
    }
    // Check if dragging over an empty area
    else if ((item?._id === undefined || item?._id == null) && event?.currentTarget?.id !== undefined && event?.currentTarget?.id == '') {
      this.addDragNDropStyles('drag-n-drop-main'); // Apply styles to the main area
      this._primeMessageService.add({
        severity: 'info',
        detail: `Drop files to instantly upload them to: ${this.searchedResultName ? this.searchedResultName : 'My Files'}`,
        sticky: true,
        closable: false,
        icon: 'pi-cloud-upload',
      });
    }
  }

  /**
   * Handles the drag end event.
   * Resets tooltip visibility, clears the dragged item ID, and resets styles.
   */
  onDragEnd() {
    this.isTooltipDisabled = false; // Re-enable tooltips after drag ends
    this.dragDropFileId = ''; // Clear the stored dragged item ID
    this.neutralizeDragNDropStyles('drag-n-drop-main'); // Reset styles
  }

  loaderPercentage: Subject<any> = new Subject<any>();
  percentageLoading: any;
  /**
   * Handles fetching folder data and processing drag-and-drop file uploads.
   *
   * @param {string} id - The ID of the folder to fetch data for (optional, defaults to '').
   * @param {any} items - The items being transferred during drag-and-drop.
   */
  async getFolderDataHandler(id = '', items) {
    let filteredLibData: any = []; // Stores the filtered library data

    if (id != '') {
      // Fetch folder data recursively based on the provided ID
      let result: any = await this.selectFolder_recursive(id, this.allDataLibrary, false);
      filteredLibData = result instanceof Array && result?.filter(f => f.is_deleted == false);
    } else {
      // If no ID is provided, use the default library data
      filteredLibData = this.libraryData;
    }

    // Process the transferred items and send them to the server
    this.getFilesDataTransferItems(items, filteredLibData).then(files => {
      let url = '/library/drag-drop-folders-files'; // Default API endpoint
      let data = {
        user_id: this.authUserID,
        library_type: 'private',
        parentId: id,
        childrens: files,
      };

      // Check if the category is 'useroffice' and modify API parameters accordingly
      if (this.category == 'useroffice') {
        data['office_id'] = this.activeOfficeId;
        data['property_id'] = this.propertyId ? this.propertyId : this.officeLibraryReferenceId;
        data['library_type'] = 'office';
        url = '/library/office-library/drag-drop-folders-files'; // Update API endpoint for office library
      }

      this.loading = true; // Set loading state to true

      // Make API call to upload the files and handle the response
      this.Api.post(url, data).subscribe({
        next: response => {
          if (response.status) {
            // Reset various states upon successful upload
            this.sideBarLev1(null);
            this.folderParentID = null;
            this.loading = false;
            this.dragLoading = false;
            this.dragEditLoading = false;
            this.selectedFileFolderID = this.officeLibraryReferenceId = null;
            this.filesUploadProgressStatus = [];
            this.filesUploadingStatus.next(this.filesUploadProgressStatus);
            this.toastr.success('Data saved successfully');
          } else {
            this.dragLoading = false;
            this.toastr.error(response.message); // Show error message
          }
        },
        error: error => {
          // Handle errors and reset loading states
          this.loading = false;
          this.dragLoading = false;
          this.dragEditLoading = false;
          this.filesUploadProgressStatus = [];
          this.filesUploadingStatus.next(this.filesUploadProgressStatus);
          this.toastr.error(error?.error?.message);
        },
      });
    });
  }

  dragLoading = false;
  dragEditLoading = false;
  /**
   * Handles the drop event for drag-and-drop functionality.
   * Determines the target location and processes the dropped files or folders accordingly.
   *
   * @param {any} event - The drop event containing the dragged data.
   * @param {any} item - The item where the drop occurred.
   */
  onDrop(event: any, item: any) {
    event?.preventDefault(); // Prevent default behavior of the browser
    event?.stopPropagation(); // Stop event propagation

    const items = event.dataTransfer.items; // Extract the dragged items

    if (event?.target?.id === 'drag-n-drop-main-td') {
      // If dropped on the main drag-and-drop area
      this.getFolderDataHandler(this.searchedResultId ? this.searchedResultId : this.propertyId, items);
      this.neutralizeDragNDropStyles(event?.target?.id);
    } else if (item?._id) {
      // If the item has an ID, check if it is a folder
      if (item?.type === 'folder') {
        if (this.dragDropFileId !== undefined && this.dragDropFileId != null && this.dragDropFileId != '') {
          // If a file is being dragged and dropped into a folder
          this.isRequestPending = true;
          this.folderParentID = item?._id;
          this.selectedFileFolderID = this.dragDropFileId;
          this.moveFolderFile(); // Move the file to the new folder
          this.neutralizeDragNDropStyles('drag-n-drop-main');
        } else if (items?.length > 0) {
          // If files are dropped into a folder
          this.getFolderDataHandler(item?._id, items);
        }
        this.neutralizeDragNDropStyles(item?._id);
      }
    } else if (event?.target?.id === 'drag-n-drop-main') {
      // If dropped on the main drag area
      this.dragLoading = true;
      this.getFolderDataHandler(this.searchedResultId ? this.searchedResultId : this.propertyId, items);
      this.neutralizeDragNDropStyles(event?.target?.id);
    } else if (event?.target?.id === 'drag-n-drop-edit') {
      // If dropped on the edit drag area
      this.dragEditLoading = true;
      this.getFolderDataHandler(this.searchedResultId ? this.searchedResultId : this.propertyId, items);
      this.neutralizeDragNDropStyles(event?.target?.id);
    } else {
      // Neutralize drag-and-drop styles if dropped elsewhere
      this.neutralizeDragNDropStyles('drag-n-drop-main');
    }

    // Ensure styles are reset after drop
    this.neutralizeDragNDropStyles('drag-n-drop-main');
    this.isTooltipDisabled = false; // Enable tooltips again
    this._primeMessageService.clear(); // Clear any messages
  }

  folderIds = '';
  /**
   * Removes drag-and-drop styles from the specified element.
   * Ensures that drop zones and background highlights are cleared after a drag event.
   *
   * @param {string} id - The ID of the element to neutralize styles for.
   */
  neutralizeDragNDropStyles(id = '') {
    let element = this.checkPlatformService.isBrowser() ? document.getElementById(id) : null;
    if (element !== undefined && element != null) {
      if (element?.classList?.contains('dropzone')) {
        // Remove dropzone highlight from the element
        element?.classList?.remove('dropzone');
      } else if (id === 'drag-n-drop-main-td') {
        // Remove dropzone highlight from table body if applicable
        let tbodyTag = this.checkPlatformService.isBrowser() ? document.getElementsByTagName('tbody') : null;
        tbodyTag?.[0]?.classList?.remove('dropzone');
      } else if (element?.classList?.contains('bg-primary')) {
        // Remove primary background styling
        element?.classList?.remove('bg-primary');
      }
    }
  }

  /**
   * Adds drag-and-drop styles to the specified element.
   * Highlights the target element to indicate a valid drop area.
   *
   * @param {string} id - The ID of the element to apply styles to.
   */
  addDragNDropStyles(id = '') {
    let element = this.checkPlatformService.isBrowser() ? document.getElementById(id) : null;
    if (element !== undefined && element != null) {
      if (id === 'drag-n-drop-main') {
        // Apply dropzone highlight to the main drag area
        element?.classList?.add('dropzone');
      } else if (id === 'drag-n-drop-main-td') {
        // Apply dropzone highlight to table body if applicable
        let tbodyTag = this.checkPlatformService.isBrowser() ? document.getElementsByTagName('tbody') : null;
        tbodyTag?.[0]?.classList?.add('dropzone');
      } else {
        // Apply primary background styling
        element?.classList?.add('bg-primary');
      }
    }
  }

  /**
   * Handles the drag leave event.
   * Removes drag-and-drop styles when the dragged item leaves a drop zone.
   *
   * @param {any} event - The drag leave event.
   * @param {any} item - The item being dragged.
   */
  onDragLeave(event: any, item: any) {
    // Check if the item is a folder and has a valid ID
    if (item?._id?.length > 0 && item?.type == 'folder') {
      // Set the folderParentID to the item's ID
      this.folderParentID = item?._id;
      // Remove drag-and-drop styles from the folder element
      this.neutralizeDragNDropStyles(item?._id);
    } else {
      // Reset folderParentID and remove styles from the event target element
      this.folderParentID = null;
      this.neutralizeDragNDropStyles(event?.target?.id);
    }

    // Clear any messages related to the drag event
    this._primeMessageService.clear();
  }

  /**
   * Processes files and directories from the DataTransfer API.
   * Converts the dragged files/folders into a structured format for further processing.
   *
   * @param {any} dataTransferItems - The data transfer items containing files/folders.
   * @param {any} folderFiles - The existing folder files where new files will be added.
   * @returns {Promise<any[]>} - A promise that resolves with the processed files and directories.
   */
  getFilesDataTransferItems(dataTransferItems, folderFiles) {
    var libData: any = folderFiles;

    /**
     * Recursively traverses the file tree structure and extracts file/folder details.
     *
     * @param {any} item - The file system entry (file or folder).
     * @param {any[]} folder - The folder array where files/folders are added.
     * @returns {Promise<any>} - A promise that resolves when traversal is complete.
     */
    async function traverseFileTreePromise(item, folder) {
      return await new Promise(resolve => {
        if (item?.isFile) {
          // If the item is a file
          var reader = new FileReader();
          item.file(async file => {
            reader.readAsDataURL(file);
            await new Promise(res => reader.addEventListener('load', res))
              .then(event => {
                var data: any = event;
                // Check for duplicate filenames and append ' - copy' if needed
                let decideName = libData?.filter(lib_item => lib_item?.name === file?.name)?.length > 0 ? file?.name + ' - copy' : file?.name;
                // Add file to the folder structure
                folder.push({ type: 'file', name: decideName, file: data?.target?.result?.toString(), childrens: [] });
              })
              .catch(e => console.error(e));
            resolve(file);
          });
        } else if (item?.isDirectory) {
          // If the item is a directory
          let dirReader = item?.createReader();
          dirReader.readEntries(async entries => {
            let entriesPromises = [];
            var subfolder = [];
            // Check for duplicate folder names and append ' - copy' if needed
            let decideName = libData?.filter(lib_item => lib_item?.name === item.name)?.length > 0 ? item.name + ' - copy' : item.name;
            // Add folder to the parent folder
            folder.push({ name: decideName, type: 'folder', childrens: subfolder });
            // Recursively process all entries inside the directory
            for (let entry of entries) entriesPromises.push(await traverseFileTreePromise(entry, subfolder));
            resolve(Promise.all(entriesPromises));
          });
        }
      });
    }

    let files = [];
    return new Promise(async resolve => {
      let entriesPromises = [];
      // Process each dragged file/folder
      for (let it of dataTransferItems) {
        await entriesPromises.push(traverseFileTreePromise(it.webkitGetAsEntry(), files));
      }
      // Wait for all file/folder processing to complete
      Promise.all(entriesPromises).then(() => {
        // Update file upload progress
        this.filesUploadProgressStatus = files?.map((record: any, index: number) => ({
          id: index,
          name: record.name || '',
          percentage: 0,
          drag: true,
        }));
        this.filesUploadingStatus.next(this.filesUploadProgressStatus);
        resolve(files);
      });
    });
  }

  /**
   * Adds a new folder to the library.
   *
   * This function collects the necessary folder details, validates the folder name,
   * and sends a request to the API to create a new folder.
   *
   * @returns {Promise<any>} - The result of the API call if successful, or an error message if validation fails.
   */
  async addFolderSync() {
    // Construct the folder parameters with user details and folder properties
    var param = [
      {
        user_id: this.authUserID, // Authenticated user ID
        type: 'folder', // Folder type
        library_type: this.library_type, // Type of the library
        parentId: this.folderIds, // Parent folder ID (if any)
        name: this.folderName.nativeElement?.value?.trim(), // Folder name (trimmed)
        item_category: 'private', // Folder category (private)
        private_file_access: this.file_type_nature === 'private' ? true : false, // Private access flag
      },
    ];

    // Validate folder name before making the API call
    if (
      this.folderName?.nativeElement?.value !== undefined &&
      this.folderName?.nativeElement?.value != null &&
      this.folderName.nativeElement?.value?.trim() != ''
    ) {
      // Call the API to add the folder
      let result = await this.Api.post('/library/add-folder-file', param[0]).subscribe();
      return result;
    } else {
      // Show error message if the folder name is missing
      this.error = 'Name is required!';
    }
  }

  contextmenuVisible = false;
  contextmenuX = 0;
  contextmenuY = 0;
  isFile: boolean = false;
  isFavourite: boolean = false;
  selectedContextMenuItem: any = null;
  recentClickedContextMenu: boolean = false;
  /**
   * Handles the right-click event to display a context menu.
   *
   * This function determines the position of the context menu, checks if it should be visible,
   * and adjusts its placement to prevent overflow.
   *
   * @param {Event} event - The right-click event.
   * @param {any} menu - The menu item that was right-clicked.
   * @param {boolean} [isRecentFileClicked=false] - Indicates if the right-clicked item is a recent file.
   */
  rightClickHandler(event, menu, isRecentFileClicked = false) {
    // Track if a recent file was clicked
    this.recentClickedContextMenu = isRecentFileClicked;

    // Prevent default right-click behavior
    event?.preventDefault();
    event?.stopPropagation();

    // Initialize context menu position
    this.contextmenuY = 0;

    // Check if a valid menu item was clicked
    if (menu?._id) {
      this.selectedContextMenuItem = menu;
      menu?.type === 'file' ? (this.isFile = true) : (this.isFile = false);
      menu?.is_favourite ? (this.isFavourite = true) : (this.isFavourite = false);
      this.contextmenuVisible = true;
    } else {
      this.contextmenuVisible = false;
    }

    // Get the parent scrollable element
    let parentDivElement = this.checkPlatformService.isBrowser() ? document.getElementById('rightbarwithscroll') : null;
    var rect = parentDivElement?.getBoundingClientRect();
    var positionYOnScrollDiv = event?.clientY + parentDivElement?.scrollTop - rect?.top;

    /**
     * Checks if the context menu overflows outside the parent container.
     *
     * @param {HTMLElement} parentElement - The parent container element.
     * @param {HTMLElement} overlayMenu - The overlay menu element.
     * @returns {boolean} - Returns true if the menu is overflowing.
     */
    function isMenuOverflowed(parentElement: HTMLElement, overlayMenu: HTMLElement): boolean {
      const parentRect = parentElement.getBoundingClientRect();
      const menuRect = overlayMenu?.children?.[0]?.getBoundingClientRect();
      return menuRect?.top < parentRect?.top;
    }

    // Delay execution to calculate and adjust context menu positioning
    setTimeout(() => {
      // Set position type for the context menu
      if (this.propertyId?.length > 0) {
        this.filesOptions.style.position = 'fixed';
      }

      // Adjust horizontal position based on screen width
      if (screen?.width - event?.x > 300) {
        let screenWidth = window?.innerWidth;
        this.contextmenuX = this.propertyId?.length > 0 ? event?.x - (screenWidth * 0.05 + 70) : event?.x;
      } else {
        this.contextmenuX = this.page_title == 'My Workspace' ? event?.x - 250 : event?.x - 300;
      }

      // Adjust vertical position to prevent overflow
      setTimeout(() => {
        let isOverflowedElement = isMenuOverflowed(this.libraryViewMode.nativeElement, this.filesOptions.el.nativeElement);
        if (isOverflowedElement) {
          this.contextmenuY =
            this.page_title === 'My Workspace' ? event?.pageY + 10 : this.propertyId?.length > 0 ? positionYOnScrollDiv - 10 : event?.pageY + 30;

          let overlayHeight = this.filesOptions.el.nativeElement?.children?.[0]?.offsetHeight || 0;
          this.contextmenuY = this.contextmenuY - overlayHeight / 1.5;
        } else {
          this.contextmenuY =
            this.page_title === 'My Workspace' ? event?.pageY + 10 : this.propertyId?.length > 0 ? positionYOnScrollDiv - 10 : event?.pageY + 30;
        }
      }, 300);
    }, 300);

    // Ensure a minimum value for context menu Y position
    if (this.contextmenuY === 0) this.contextmenuY = 5;
  }

  /**
   * Generates file paths and sends them to the parent component.
   *
   * This function processes an array of items, constructs file URLs using `S3Path`,
   * and passes the result to `parentComp`. It also resets the `isDragDropSorting` flag.
   *
   * @param {any[]} [item=[]] - Array of file objects to be processed.
   */
  useThisInParent(item: any[] = []) {
    // Map each item to generate the full path using S3Path
    let link = item?.map(value => this.S3Path + (value?.path ? value?.path : value?.[0]?.path));

    // Send the generated paths to the parent component
    if (this.isFullObj) {
      this.parentComp.next(item);
    } else {
      this.parentComp.next(link);
    }

    // Reset drag-and-drop sorting flag
    this.isDragDropSorting = false;
  }

  pendingAction = null;
  contextMenuHandler(event, methodName) {
    event?.preventDefault();

    // Check if file access is private
    if (this.selectedContextMenuItem?.private_file_access === true) {
      this.file_access = true; // Show the PIN popup
      this.download_file = this.selectedContextMenuItem; // Store the selected file
      this.pendingAction = methodName; // Store the action to be executed later
      return;
    }

    this.executeContextMenuAction(methodName);
  }

  /**
   * Executes an action from the context menu based on the selected method name.
   *
   * This function handles different file/folder operations like previewing, sharing,
   * moving, renaming, downloading, and deleting items. The action performed depends
   * on the provided `methodName` and the selected context menu item.
   *
   * @param {string} methodName - The name of the action to be executed.
   */
  executeContextMenuAction(methodName) {
    switch (methodName) {
      case 'preview':
        // Show preview modal for the selected item
        this.showModalPreview(this.selectedContextMenuItem);
        break;
      case 'share':
        // Open share modal for the selected item
        this.showModalShare(this.selectedContextMenuItem);
        break;
      case 'link':
        // Open get link modal
        this.showModalGetLink(this.selectedContextMenuItem);
        break;
      case 'path':
        // Open get path modal
        this.showModalGetPath(this.selectedContextMenuItem);
        break;
      case 'move-to-folder':
        // Open move-to-folder modal
        this.showMoveFolderModal(this.selectedContextMenuItem, 'folder');
        break;
      case 'workspace':
        // Open move-to-workspace modal
        this.showMoveFolderModal(this.selectedContextMenuItem, 'workspace');
        break;
      case 'add-to-favourite':
        // Add the selected item to favorites
        this.addToFavourite(this.selectedContextMenuItem?._id);
        break;
      case 'remove-from-favourite':
        // Remove the selected item from favorites
        this.removeToFavourite(this.selectedContextMenuItem?._id);
        break;
      case 'create-slider':
        // Show rename modal
        this.showRenameModal(this.selectedContextMenuItem);
        break;
      case 'remove-slider':
        // Show rename modal
        this.showRenameModal(this.selectedContextMenuItem);
        break;
      case 'rename':
        // Show rename modal
        this.showRenameModal(this.selectedContextMenuItem);
        break;
      case 'copy':
        // Copy the selected item based on category
        if (this.category == 'useroffice') {
          this.makeACopyLibraryFolderFile(this.selectedContextMenuItem);
        } else {
          this.makeCopyFolderFile(this.selectedContextMenuItem);
        }
        break;
      case 'download':
        // Download the selected file
        this.downloadFile(this.selectedContextMenuItem);
        break;
      case 'remove':
        // Remove the selected item based on category
        if (this.category == 'useroffice') {
          this.removeOfficeLibraryFileFolders([this.selectedContextMenuItem]);
        } else if (this.category == 'workspace') {
          if (this.isWorkspaceModalOpened) {
            this.removeItemFromWorkspace(this.selectedContextMenuItem?._id);
          } else {
            this.removeWorkspace(this.selectedContextMenuItem?._id);
          }
        } else {
          this.removeFolderFile(this.selectedContextMenuItem);
        }
        break;
      case 'restore':
        // Restore the selected item
        this.restoreFolderFile(this.selectedContextMenuItem?._id);
        break;
      case 'delete-forever':
        // Permanently delete the selected item
        this.deleteFolderFile(this.selectedContextMenuItem?._id);
        break;
      case 'hide-workspace':
        // Toggle visibility of workspace item
        this.hideShowWorkspace(this.selectedContextMenuItem?._id);
        break;
      case 'add-files':
        // Show right bar for file addition
        this.showRightBar = true;
        break;
      default:
        // No action for unrecognized method names
        break;
    }
  }

  closeRightBar() {
    this.showRightBar = false;
  }

  /**
   * Recursively processes a directory listing to structure the data properly.
   *
   * Each item in the given array is updated to include a `data` property containing
   * name, size, and ID. If an item has child elements, they are assigned to the `children`
   * property, and the function is called recursively.
   *
   * @param {Array} value - The directory listing array to process.
   * @returns {Array} - The processed directory listing with structured data.
   */
  getDirectoryListing(value) {
    for (const item of value) {
      // Add a `data` object with essential properties
      item.data = { name: item?.name, size: item?.readable_file_size, _id: item?._id };

      // Check if the item has children and process them recursively
      if (item?.childrens !== undefined && item?.childrens != null && item?.childrens?.length > 0) {
        item.children = item?.childrens;
        this.getDirectoryListing(item?.childrens);
      }
    }
    return value;
  }

  /**
   * Recursively retrieves the nested path of an item within a hierarchical array.
   *
   * The function traverses the array to find the item matching the given ID. If found,
   * it constructs a breadcrumb-like path in JSON format, containing the item's label and URL.
   * If the item has a reference ID (`ref_id`), it is stored in `officeLibraryReferenceId`.
   *
   * @param {Array} arr - The array to search within.
   * @param {string} id - The ID of the target item.
   * @returns {string | undefined} - The constructed path in JSON format, or undefined if not found.
   */
  getNestedPath = (arr, id) => {
    try {
      if (arr instanceof Array) {
        for (let item of arr) {
          // If the item matches the target ID, return its path
          if (item._id === id) {
            if (item?.ref_id !== undefined && item?.ref_id != null && item?.ref_id != '') {
              this.officeLibraryReferenceId = item?.ref_id;
            }
            return `/${JSON.stringify({ label: item?.name, url: id })}`;
          }

          // If the item has children, search within them recursively
          if (item?.childrens) {
            if (item?.ref_id !== undefined && item?.ref_id != null && item?.ref_id != '') {
              this.officeLibraryReferenceId = item?.ref_id;
            }
            const child = this.getNestedPath(item?.childrens, id);
            if (child) {
              return `/${JSON.stringify({ label: item?.name, url: item?._id })}${child}`;
            }
          }
        }
      }
    } catch (error) {}
  };

  /**
   * Recursively searches for an item with a matching reference ID in a nested structure.
   *
   * The function traverses through the array and its children to find the item whose `ref_id`
   * matches the provided ID. Once found, the function returns the `_id` of that item.
   *
   * @param {Array} arr - The array to search within.
   * @param {string} id - The reference ID to search for.
   * @returns {string | null} - The `_id` of the item with the matching `ref_id`, or `null` if not found.
   */
  getBreadCrumbId = (arr, id) => {
    let breadRefId = null; // Initialize the reference ID to null

    // Iterate through each item in the array
    arr?.forEach(x => {
      // Check if the reference ID matches the current item
      if (x?.ref_id == id) {
        breadRefId = x?._id; // Assign the _id of the matching item
      } else {
        // If no match, check the children's items recursively
        x?.childrens?.forEach(y => {
          if (y?.ref_id == id) {
            breadRefId = y?._id; // Assign the _id of the matching child item
          } else {
            // Continue searching deeper if no match is found
            y?.childrens?.forEach(z => {
              if (z?.ref_id == id) {
                breadRefId = z?._id; // Assign the _id of the matching grandchild item
              } else {
                // Continue searching further down the hierarchy if needed
                z?.childrens?.forEach(a => {
                  if (a?.ref_id == id) {
                    breadRefId = a?._id; // Assign the _id of the matching great-grandchild item
                  }
                });
              }
            });
          }
        });
      }
    });

    // Return the found reference ID or null if not found
    return breadRefId;
  };

  /**
   * Parses the extracted path string to generate navigation menu items (breadcrumb items).
   * The function processes the path string, splits it into individual breadcrumb elements,
   * and updates the `breadcrumbItems` property accordingly.
   *
   * @param {any} extractedPathString - The path string to extract breadcrumb data from.
   */
  getNavigationMenu(extractedPathString: any) {
    var navigationItems: any = []; // Initialize an array to hold the parsed breadcrumb items

    // Check if the extractedPathString is not undefined, null, or empty
    if (extractedPathString !== undefined && extractedPathString != null && extractedPathString?.length > 0) {
      // Regex to split the path string at each '/' not inside curly braces
      const regex = /\/(?![^{}]*\})/g;
      extractedPathString = extractedPathString?.split(regex); // Split the string based on the regex

      // Ensure that extractedPathString is valid and not empty
      if (extractedPathString !== undefined && extractedPathString != null && extractedPathString?.length > 0) {
        // Loop through the extracted path string array
        extractedPathString?.forEach(element => {
          // If element is valid, try to parse it as JSON and push to navigationItems
          if (element !== undefined && element != null && element?.length > 0)
            try {
              navigationItems?.push(JSON.parse(element));
            } catch (error) {}
        });

        // Update breadcrumbItems with the parsed navigationItems
        this.breadcrumbItems = navigationItems;
        this.updateMenu();

        // If propertyId is available, modify breadcrumbItems based on the property
        if (this.propertyId?.length > 0) {
          // Get the breadcrumb reference ID based on the propertyId
          let breadRefId = this.getBreadCrumbId(this.allDataLibrary, this.propertyId);

          // Find the matching breadcrumb item and adjust the array accordingly
          let matchingIndex = navigationItems.findIndex(item => item.url === breadRefId);
          if (matchingIndex !== -1) {
            navigationItems.splice(0, matchingIndex); // Remove items before the matching one
          }
          this.breadcrumbItems = navigationItems;

          // A locked library starts its breadcrumb at the locked folder, so nothing above it can be clicked.
          if (this.lockToFolder) {
            let lockedIndex = navigationItems.findIndex(item => item?.label?.toLowerCase() == this.lockToFolder.toLowerCase());
            if (lockedIndex !== -1) {
              navigationItems.splice(0, lockedIndex);
            }
            this.breadcrumbItems = navigationItems;
          }

          // If the default open state is 'images', filter the breadcrumb items
          if (this.defaultOpen == 'images') {
            let matchingIndex = navigationItems.findIndex(item => item.label == 'Property Images');
            if (matchingIndex !== -1) {
              navigationItems.splice(0, matchingIndex); // Remove items before 'Property Images'
            }
            this.breadcrumbItems = navigationItems;
          }
        } else {
          // If no propertyId, just use the navigationItems as breadcrumbItems
          this.breadcrumbItems = navigationItems;
        }
      }
    } else {
      // If extractedPathString is invalid or empty, set breadcrumbItems to an empty array
      this.breadcrumbItems = [];
    }
  }

  updateMenu = () => {
    let isFolder =
      this.breadcrumbItems[this.breadcrumbItems.length - 1].label === 'Interior' ||
      this.breadcrumbItems[this.breadcrumbItems.length - 1].label === 'Amenities';
    let isSubFolder =
      this.breadcrumbItems[this.breadcrumbItems.length - 2].label === 'Interior' ||
      this.breadcrumbItems[this.breadcrumbItems.length - 2].label === 'Amenities';

    this.message.sendMessage({
      isShowFolder: isFolder,
      isHideFolder: isSubFolder,
    });
  };

  /**
   * Generates an avatar label based on the full name or name of an item.
   * It extracts the first character of the first three words in the name
   * and returns the concatenated string as the avatar label.
   *
   * @param {any} item - The item from which to generate the avatar label.
   * @returns {string | undefined} - The concatenated initials from the full name or name, or undefined if no valid name is found.
   */
  getAvatarLabel(item) {
    // Check if the item is defined and not null
    if (item !== undefined && item != null) {
      let splittedName = []; // Array to hold the split name parts
      let specifiedName = ''; // String to accumulate the initials

      // Check if the full_name is available and not empty
      if (item?.full_name?.trim()?.length > 0) {
        // Split the full_name by space into an array
        splittedName = item?.full_name?.trim()?.split(' ');
      }
      // If full_name is not available, check for 'name' and 'office' properties
      else if (item?.name?.trim()?.length > 0 && item?.office) {
        // Split the name by space into an array
        splittedName = item?.name?.trim()?.split(' ');
      }

      // If the splittedName array contains values, process it
      if (splittedName?.length > 0) {
        // Loop through the first 3 parts of the name (if available)
        for (let index = 0; index < splittedName.length; index++) {
          // Only add initials from the first 3 parts of the name
          if (index < 3) {
            specifiedName += splittedName?.[index]?.charAt(0); // Append the first character of each word
          }
        }
      }

      // Return the concatenated initials as the avatar label
      return specifiedName;
    }
  }

  imgNotFoundList: any[] = [];
  /**
   * Handles the image load error event. If an image fails to load, it attempts
   * to set a fallback image or retrieves the thumbPath if available. It also
   * manages a list of images that couldn't be loaded and emits an event with
   * the names of those images.
   *
   * @param {Event} event - The image error event.
   * @param {any} item - The item containing image data, such as 'thumbPath' and 'name'.
   */
  LoadImageonError(event, item) {
    // Check if the item has a valid thumbPath
    if (item?.thumbPath) {
      // If a thumbPath exists, attempt to load the image after a 1-second delay
      setTimeout(() => {
        // Set the source of the image to the thumbPath from the item
        event.target.src = this.S3Path + item?.thumbPath;
      }, 1000); // Delay of 1000ms (1 second)
    }

    // Add the item name to the list of images that could not be loaded
    this.imgNotFoundList.push(item?.name);

    // Remove duplicate entries from the list using a Set
    this.imgNotFoundList = [...new Set(this.imgNotFoundList)];

    // Emit an event with the updated list of image names that couldn't be loaded
    this.imageUploadedError.emit(this.imgNotFoundList);

    // Set a fallback image (placeholder) for the broken image
    event.target.src = this.common_images?.image_not_found;
  }

  /**
   * Handles the selection of a directory based on the event's value.
   * Depending on the selected directory, it calls the appropriate method
   * to fetch the corresponding data.
   *
   * @param {Event} event - The event object that contains the selected directory value.
   */
  getSelectedDirectory(event) {
    // Switch statement to check the selected directory value
    switch (event?.value) {
      // If 'myfiles' is selected, call the method to get all data
      case 'myfiles':
        this.getAllData();
        break;

      // If 'recentfiles' is selected, call the method to get recent files
      case 'recentfiles':
        this.getAllRecent();
        break;

      // If 'sharedwithme' is selected, call the method to get files shared with the user
      case 'sharedwithme':
        this.getSharedWithMe();
        break;

      // If 'myoffice' is selected, call the method to get private office folders
      case 'myoffice':
        this.getPrivateOfficeFolders();
        break;

      // Default case if none of the above options are selected
      default:
        // Clear the directory list data if an unrecognized value is selected
        this.directoryListData = [];
        break;
    }
  }

  // fetches data from an API endpoint related to a
  // user's private office folders and processes
  // the response to update various component properties
  getPrivateOfficeFolders(updated_record: any = null) {
    // `propertyId` carries a project id on a project and a listing id on a listing, so which
    // parameter it goes in is decided by `is_project` — a listing was previously sending neither.
    let param = {
      userId: this.authUserID,
      contract_id: this.contract_Id ? this.contract_Id : null,
      project_id: this.is_project ? this.propertyId : null,
      listing_id: !this.is_project && this.propertyId ? this.propertyId : null,
    };
    this.loading = true;
    this.loadingService.show();
    // An add already returns the whole tree, and it is what gets rendered — refetching it
    // (~4.5 MB) only to discard the response was pure cost. Callers pass it only after a
    // successful add, hence the synthesized status.
    const source$: Observable<any> =
      updated_record && Object.keys(updated_record)?.length > 0
        ? of({ status: true, data: null })
        : this.Api.get(`/library/office-library/${this.Api.getOfficeId()}`, param);
    source$.subscribe({
      next: response => {
        if (response?.status !== undefined && response?.status != null && response?.status == true) {
          this.loadingService.hide();
          let result = updated_record && Object.keys(updated_record)?.length > 0 ? updated_record?.childrens : response?.data?.childrens;
          let theresult = updated_record && Object.keys(updated_record)?.length > 0 ? [...updated_record?.childrens] : [...response?.data?.childrens];
          if (result !== undefined && result != null && result?.length > 0) {
            this.allDataLibrary = result;
            console.log('Office Library Folders:', this.allDataLibrary);
            this.ngZone.run(() => {
              if (this.page_title == 'My Workspace') {
                this.directoryListData = this.getDirectoryListing(this.allDataLibrary);
              } else {
                this.libraryData = [];
                this.libraryDataCopy = [];
                // filter the data that is not deleted and store it
                this.libraryDataCopy = this.libraryData = this.allDataLibrary?.filter(folder => folder?.is_deleted == false);
                // filter the data that have only files not folders
                this.galItems = this.allDataLibrary.filter(item => {
                  return (
                    (item.type !== 'folder' && item.file_type === 'image/jpeg') || item.file_type === 'image/png' || item.file_type === 'image/jpeg'
                  );
                });
                if (!this.searchedResultId) {
                  this.galItems = [];
                  this.portalImages = [];
                  // Check if the data has the 'is_offline' field & assign false if missing
                  const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));
                  if (!hasIsOfflineField) {
                    this.libraryData.forEach(item => {
                      if (!item.hasOwnProperty('is_offline')) {
                        item.is_offline = false;
                      }
                    });
                  }
                  this.libraryData.forEach(item => {
                    if (
                      item.type !== 'folder' &&
                      (item.file_type === 'image/jpeg' || item.file_type === 'image/png' || item.file_type === 'image/jpeg')
                    ) {
                      if (item.is_offline === false) {
                        this.galItems.push(item);
                      } else if (item.is_offline === true) {
                        this.portalImages.push(item);
                      }
                    }
                    if (item.type == 'folder' && item.name == 'Floorplans') {
                      if (!this.galItems.some(galItem => galItem._id === item._id)) {
                        this.galItems.push(item);
                      }
                    }
                  });
                }
                this.galItems.forEach(n => {
                  if (n.type !== 'folder' && (n.file_type === 'image/jpeg' || n.file_type === 'image/png' || n.file_type === 'image/jpeg')) {
                    n.info_div = {
                      uploadedby: this.getUserName(n?.user_id),
                      modified: moment(n?.updated_at)?.format('DD MMM YYYY'),
                      created: moment(n?.created_at)?.format('DD MMM YYYY'),
                      dimentions: this.getImageDimenssion(this.getLargeImageByPath(n)),
                    };
                  }
                });
                // Iterate through the project folder and filter the floorplan file from it
                if (this.floorPlan_Name) {
                  this.libraryData?.forEach(ele => {
                    if (ele?.name === 'Projects') {
                      if (ele?.childrens?.length > 0) {
                        ele?.childrens?.forEach(el => {
                          if (el?.ref_id === this.propertyId) {
                            if (el?.childrens?.length > 0) {
                              el?.childrens?.forEach(elx => {
                                if (elx?.name?.toLowerCase() === 'project documents') {
                                  if (elx?.childrens?.length > 0) {
                                    elx?.childrens?.forEach(elem => {
                                      if (elem?.name?.toLowerCase() === 'floorplans') {
                                        elem['childrens'] = elem?.childrens?.filter(x => x?.name === this.floorPlan_Name + '.pdf');
                                      }
                                    });
                                  }
                                }
                              });
                            }
                          }
                        });
                      }
                    }
                  });
                }
                // Get the query params and check if there is a 'Id' or 'id' parameter and open the selected folder.
                // take(1): ngOnInit's subscription already applies the same assignment on later changes.
                this.route.queryParams.pipe(take(1)).subscribe({
                  next: params => {
                    if (params['Id']?.toString() || params['id']?.toString()) {
                      if (!this.propertyId && !this.contract_Id) {
                        this.searchedResultId = params['Id']?.toString() ? params['Id']?.toString() : params['id']?.toString();
                      }
                    }
                  },
                });
                this.LibraryOutputData.emit(this.libraryData);
                if (this.searchedResultId?.length > 0) {
                  this.selectFolders(this.searchedResultId, false);
                  var extractedPathString = this.getNestedPath(this.libraryData, this.searchedResultId);
                  this.getNavigationMenu(extractedPathString);
                } else if (this.propertyId?.length > 0) {
                  this.selectFolders(this.propertyId, true);
                  var extractedPathString = this.getNestedPath(this.libraryData, this.propertyId);
                  this.getNavigationMenu(extractedPathString);
                } else {
                  if (this.eoiData) {
                    const mainlib = theresult?.filter(folder => folder?.is_deleted == false);
                    const project_folder_name = this.eoiData?.projectid; // it have project name
                    const eoifolder_name = `${this.eoiData?.unit_id} (${this.eoiData?.client_first_name} ${this.eoiData?.client_last_name})`;
                    const mainFolder = mainlib.filter(n => {
                      return n.name == 'Projects';
                    });

                    const projectFolder = mainFolder[0].childrens.filter(n => {
                      return n.name == project_folder_name;
                    });
                    const eoisFolder = projectFolder[0].childrens.filter(n => {
                      return n.name == 'EOI';
                    });
                    const eoiFolder = eoisFolder[0].childrens.filter(n => {
                      return n.name == eoifolder_name;
                    });

                    if (eoiFolder[0]?._id) {
                      this.propertyId = eoiFolder[0]?._id;
                    }

                    if (this.propertyId?.length > 0) {
                      window.setTimeout(() => {
                        this.selectFolders(this.propertyId, false);
                        var extractedPathString = this.getNestedPath(this.libraryData, this.propertyId);
                        this.getNavigationMenu(extractedPathString);
                      });
                    } else {
                      this.breadcrumbItems = [];
                    }
                  } else {
                    this.breadcrumbItems = [];
                  }
                }

                this.allDataLibrary.forEach(f => {
                  if (f?.name === this.defaultOpen) {
                    this.selectFolders(f);
                  }
                });
              }
            });
          }
        }
        this.loading = false;
      },
      error: err => {
        this.toastr.error(err?.error?.message ? err?.error?.message : 'Something went Wrong');
        this.loading = false;
      },
    });
  }

  /**
   * Handles the click event for adding a folder.
   * Validates the folder name input and triggers the appropriate action.
   */
  onAddFolderClick() {
    // Check if the folder name is empty (after trimming whitespace)
    if (
      this.folderName?.nativeElement?.value !== undefined &&
      this.folderName?.nativeElement?.value != null &&
      this.folderName?.nativeElement?.value?.trim() == ''
    ) {
      // If the folder name is empty, stop loading and display an error message
      this.loading = false;
      this.error = 'Name is required!'; // Error message indicating folder name is required
    } else {
      // If the folder name is valid, call the function to add the folder
      this.addNewFileFolderPrivateFolder('folder');

      // Set loading to true to disable the button and indicate ongoing process
      this.loading = true;
    }
  }

  filesUploadProgressStatus: { id: number; name: string; percentage: number }[] = [];
  officeLibraryReferenceId: String = '';
  // takes two parameters:
  // folderOrFileType (defaulting to 'folder') and _isEmbedUrl (optional).
  // The _isEmbedUrl parameter is used to indicate whether the file being added is an embedded URL or not.
  async addNewFileFolderPrivateFolder(folderOrFileType = 'folder', _isEmbedUrl?: boolean) {
    this.loading = true;
    let id = this.selectedSidebarLink != null && this.selectedSidebarLink?.length !== undefined ? this.selectedSidebarLink : '';
    let extractedPathString = this.getNestedPath(this.allDataLibrary, id);
    if (extractedPathString && !this.isContractLibrary) {
      let segments = extractedPathString.split('/').filter(s => s); // Remove empty segments
      let lastSegment = null;
      try {
        lastSegment = segments[segments.length - 1];
        // Ensure lastSegment is a valid JSON string before parsing
        if (lastSegment.startsWith('{') && lastSegment.endsWith('}')) {
          let parsedSegment = JSON.parse(lastSegment);
          if (parsedSegment.label === this.defaultOpen) {
            // id = this.propertyId;
          }
        } else {
          console.error('Invalid JSON format:', lastSegment);
        }
      } catch (error) {
        console.error('JSON Parsing Error:', error, 'Segment:', lastSegment);
      }
    }

    if (this.isContractLibrary && this.contractRootId) {
      id = this.contractRootId;
    }
    if (this.isListingLibrary && this.listingRootId) {
      id = this.listingRootId;
    }
    // If the folderOrFileType parameter is 'folder', it indicates that below code is for adding a new folder.
    if (folderOrFileType === 'folder') {
      let param = {
        user_id: this.authUserID,
        office_id: this.Api.getOfficeId(),
        propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId,
        library_type: 'office',
        parentId: id,
        contractId: this.contract_Id ? this.contract_Id : null,
        item_category: 'useroffice',
      };
      if (folderOrFileType == 'folder') {
        param['type'] = 'folder';
        param['name'] = this.folderName?.nativeElement?.value?.trim();
        if (
          this.folderName?.nativeElement?.value !== undefined &&
          this.folderName?.nativeElement?.value != null &&
          this.folderName?.nativeElement?.value?.trim() == ''
        ) {
          this.error = 'Name is required!';
          this.loading = false;
          return;
        }
      }
      if (_isEmbedUrl) {
        param['is_url'] = true;
      }
      this.Api.post(`/library/office-library/add-folder-file`, param).subscribe({
        next: response => {
          const { status, data } = response;
          if (status) {
            this.userRoleId = Crypto.decrypt(this.localStorageService.GetItem('roleid'));
            this.page_title = 'User Office';
            this.selectedSidebarLink = 6;
            this.isDraggableFeature = true;
            this.toastr.success('Folder added successfully');
            // Last: with `data` this now renders synchronously, and it reads page_title, which
            // it used to see only after the lines above had run.
            this.getPrivateOfficeFolders(data);
          } else {
            this.toastr.error('Something went wrong');
          }
        },
        error: () => {
          this.toastr.error('Something went wrong');
          this.loading = false;
        },
        complete: () => {
          this.fileUploadingLoader = this.addFolderModal = this.isWorkspace = this.loading = false;
        },
      });
    } else {
      // If the folderOrFileType parameter is not 'folder', it indicates that below code is for adding a new file.
      this.percentageLoading = 100 / this.readyToUploadFiles?.length;
      this.filesUploadProgressStatus = this.readyToUploadFiles?.map((record: any, index: number) => ({
        id: index,
        name: record?.name || '',
        percentage: 0,
        drag: false,
      }));
      this.filesUploadingStatus.next(this.filesUploadProgressStatus);
      let number = 0;
      // Iterates through an array to upload multiple files
      for (let [index, x] of this.readyToUploadFiles.entries()) {
        try {
          let param = {
            user_id: this.authUserID,
            office_id: this.Api.getOfficeId(),
            propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId,
            library_type: 'office',
            parentId: id,
            contractId: this.contract_Id ? this.contract_Id : null,
            private_file_access: this.file_type_nature === 'private' ? true : false,
            item_category: 'useroffice',
          };
          if (param.propertyId == param.parentId) {
            param.parentId = '';
          }
          if (folderOrFileType == 'folder') {
            param['type'] = 'folder';
            param['name'] = this.folderName?.nativeElement?.value?.trim();
            if (
              this.folderName?.nativeElement?.value !== undefined &&
              this.folderName?.nativeElement?.value != null &&
              this.folderName?.nativeElement?.value?.trim() == ''
            ) {
              this.error = 'Name is required!';
              this.loading = false;
              return;
            }
          } else {
            param['type'] = 'file';
            param['file'] = [x];
            x = { ...x, item_category: 'useroffice' };
            this.fileUploadingLoader = this.loading = true;
            if (!this.readyToUploadFiles) return;
          }
          if (_isEmbedUrl) {
            param['is_url'] = true;
          }
          this.eoi_Id && (param['eoi_id'] = this.eoi_Id);
          if (!this.modifiedArray.includes(x?.name)) {
            await this.uploadFileAsync(param, number);
            let file = param['file']?.map(el => el?.name);
            let existFloorplansFolder = this.breadcrumbItems?.find(folder => folder?.label?.toLowerCase() == 'floorplans');
            if (this.innerDefault?.toLowerCase() == 'floorplans' || existFloorplansFolder) {
              this.lmService.planUpload({ status: true, file: file });
            }

            let isSP = this.breadcrumbItems?.find(folder => folder?.label === 'Admin Sale Presentation');
            // Once per batch, not once per file — saveSP() re-reads the whole folder listing, so
            // uploading N files here used to re-fetch it N times in a row (see
            // FRONTEND-DUPLICATE-API-CALLS-2026-09-17.md §4, "3 times in 9 seconds").
            if ((this.innerDefault == 'Admin Sale Presentation' || isSP) && index === this.readyToUploadFiles?.length - 1) {
              this.sp.saveSP(this.propertyId);
            }
            this.toastr.success('Added successfully');
            this.addFolderModal = false;
            if (index === this.readyToUploadFiles?.length - 1) {
              this.sideBarLev1(null);
            }
          }
          if (index === this.readyToUploadFiles?.length - 1) {
            this.sideBarLev1(null);
          }
          number++;
          this.loaderPercentage.next(Math.round(this.percentageLoading * number));
        } catch (err) {
          this.loading = false;
          this.toastr.error(err?.error?.message ? err?.error?.message : 'Something went wrong');
          this.fileUploadingLoader = this.addFolderModal = this.isWorkspace = this.loading = false;
        }
      }
    }
    this.loading = false;
    this.modifiedArray = [];
  }
  filesUploadingStatus: Subject<any> = new Subject<any>();
  /**
   * Asynchronously uploads a file to the server and tracks the upload progress.
   * @param param - The file and related data to be uploaded.
   * @param indexer - An identifier used to track the progress of the specific file upload.
   * @returns A Promise that resolves when the upload is complete or rejects if there is an error.
   */
  uploadFileAsync(param: any, indexer: number): Promise<any> {
    return new Promise((resolve, reject) => {
      // Send an HTTP POST request to upload the file to the server
      this.http
        .post(`${this.Api.baseUrl}/library/office-library/add-folder-file`, param, {
          headers: {
            Authorization: 'Bearer ' + this.tokenService.getToken(), // Authorization header with token
          },
          reportProgress: true, // Enable progress reporting
          observe: 'events', // Observe the entire HTTP event stream
        })
        .subscribe({
          // Handling each response event
          next: (response: any) => {
            // Extract relevant information from the response
            const { type, loaded = 0, total = 0, body } = response || { type: null, loaded: 0, total: 0, body: null };

            if (type === HttpEventType.UploadProgress) {
              // Calculate the progress percentage of the upload
              let progress = Math.round((100 * loaded) / total);

              // Update the progress status for the specific file (indexer)
              this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                if (record?.id === indexer) {
                  record = { ...record, percentage: progress || -1 };
                }
                return record;
              });

              // Notify the subscribers with the updated upload progress status
              this.filesUploadingStatus.next(this.filesUploadProgressStatus);
            } else if (type === HttpEventType.Response) {
              // Handle the final response after the upload is complete
              const { status } = body;
              if (status) {
                // Successfully uploaded, set progress to 100%
                this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                  if (record?.id === indexer) {
                    record = { ...record, percentage: 100 };
                  }
                  return record;
                });

                // Notify subscribers with the final status
                this.filesUploadingStatus.next(this.filesUploadProgressStatus);
                resolve(response); // Resolve the Promise with the response
              } else {
                // Upload failed, set progress to -1 (error state)
                this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                  if (record?.id === indexer) {
                    record = { ...record, percentage: -1 };
                  }
                  return record;
                });

                // Notify subscribers about the failure
                this.filesUploadingStatus.next(this.filesUploadProgressStatus);
                reject(response); // Reject the Promise with the response
              }
            }
          },
          // Handling errors during the HTTP request
          error: err => {
            reject(err); // Reject the Promise with the error
            this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
              if (record?.id === indexer) {
                record = { ...record, percentage: -1 }; // Set progress to -1 (error state)
              }
              return record;
            });

            // Notify subscribers about the error state
            this.filesUploadingStatus.next(this.filesUploadProgressStatus);
          },
        });
    });
  }

  modifiedArray: any[] = [];
  // Function to cancel the upload of a file
  cancelFile(e) {
    this.modifiedArray.push(e);
    this.readyToUploadFiles = this.readyToUploadFiles?.filter(x => x?.name !== e?.name);
  }
  /**
   * Renames a file or folder in the office library.
   * Performs validation and sends a PUT request to rename the file/folder.
   */
  renameOfficeLibraryFileFolders() {
    // Check if the folder/file name is not undefined, null, or empty
    if (this.fileFolderRename !== undefined && this.fileFolderRename != null && this.fileFolderRename?.trim() != '') {
      // Validate that the name contains only alphanumeric characters
      if (!this.hasAlphanumeric(this.fileFolderRename?.trim())) {
        this.error = 'Name should be alpha numeric characters'; // Set error if validation fails
        return;
      }

      // Prepare the parameters for the API request
      let param = {
        office_id: this.Api.getOfficeId(), // Get office ID from localStorage
        user_id: this.authUserID, // Get the user ID
        propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId, // Set property ID (either from propertyId or officeLibraryReferenceId)
        id: this.selectedFileFolderID, // The ID of the file/folder to rename
        name: this.fileFolderRename?.trim(), // The new name for the file/folder
      };

      // Make the PUT request to rename the file/folder
      this.Api.put(`/office-library/rename-folder-file`, param).subscribe({
        next: response => {
          // If the response status is true, the renaming was successful
          if (response?.status !== undefined && response?.status != null && response?.status == true) {
            this.sideBarLev1(null); // Refresh the sidebar (or perform any necessary updates)

            let isSP = this.breadcrumbItems?.find(folder => folder?.label === 'Admin Sale Presentation');
            if (this.innerDefault == 'Admin Sale Presentation' || isSP) {
              this.sp.saveSP(this.propertyId);
            }

            let existFloorplansFolder = this.breadcrumbItems?.find(folder => folder?.label?.toLowerCase() == 'floorplans');
            if (this.innerDefault?.toLowerCase() == 'floorplans' || existFloorplansFolder) {
              this.lmService.planUpload({ status: true, file: param.name });
            }

            // Clear the input field and close the modal after successful renaming
            this.filefolderRename.nativeElement.value = '';
            this.modalRenameFolderFile = false;
            this.toastr.success('Name change successfully'); // Show success message
          } else {
            this.toastr.error(response.message); // Show error message if renaming fails
          }
        },
        error: error => {
          // Handle any errors from the API request
          this.toastr.error(error?.error?.message ? error?.error?.message : 'Something went Wrong'); // Show error message
        },
      });
    } else {
      // If the name is empty or undefined, show an error message
      this.error = 'Name is required!'; // Set the error message for the missing name
    }
  }

  /**
   * Removes selected file/folder items from the office library.
   * Sends a DELETE request to remove the files/folders if they can be deleted.
   * @param Items The files or folders to be deleted.
   */
  removeOfficeLibraryFileFolders(Items: any) {
    let ids: any = []; // Array to store the IDs of items to be deleted

    // If Items is an array, check each item for its _id and can_delete property
    if (Items?.length) {
      Items.forEach(f => {
        // Only include items that have a valid _id and can be deleted
        if (f?._id !== undefined && f._id != null && f?.can_delete == true) ids.push(f._id); // Add the item ID to the ids array
      });
    } else {
      // If Items is a single object, check if it can be deleted
      if (Items._id !== undefined && Items._id != null && Items?.can_delete == true) ids.push(Items._id); // Add the item ID to the ids array
    }

    // If there are valid item IDs to delete, proceed with the deletion
    if (ids?.length > 0) {
      this.remmiConfirm
        .delete({
          title: 'Delete Permanently?',
          message: 'Office library items are deleted permanently, not moved to Trash.',
          subject: ids.length === 1 ? (Items?.length ? Items[0]?.name : Items?.name) : `${ids.length} items selected`,
          confirmLabel: 'Delete Permanently',
        })
        .subscribe(isConfirmed => {
          if (!isConfirmed) {
            return;
          }
          this.dragLoading = true; // Set loading state to true while the request is in progress

          // Prepare parameters for the DELETE request
          let param = {
            office_id: this.Api.getOfficeId(), // Office ID from localStorage
            id: ids, // IDs of the items to be deleted
            propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId, // Property ID (either from propertyId or officeLibraryReferenceId)
            user_id: this.authUserID, // User ID
          };

          // If the Items type is "reports", include additional parameters
          if (Items?.type && Items?.type === 'reports') {
            param['type'] = Items?.type ? Items?.type : null;
            param['report_id'] = Items?.ref_id ? Items?.ref_id : null;
          }

          let existFloorplansFolder = this.breadcrumbItems?.find(folder => folder?.label?.toLowerCase() == 'floorplans');
          if (this.innerDefault?.toLowerCase() == 'floorplans' || existFloorplansFolder) {
            this.lmService.planUpload({ status: true, file: Items?.map(ele => ele?.name), isRemoved: true });
          }

          // Make the DELETE request to remove the items
          this.Api.delete(`/office-library/delete-folder-file`, param).subscribe({
            next: response => {
              // If the response status is true, the deletion was successful
              if (response?.status !== undefined && response?.status != null && response?.status == true) {
                this.toastr.success('Deleted successfully'); // Show success message
                this.onRemove.emit(true);
                this.sideBarLev1(null); // Refresh the sidebar (or perform any necessary updates)
                this.resetSelectedItems(); // Reset the selected items after deletion
                this.dragLoading = false; // Set loading state to false

                let isSP = this.breadcrumbItems?.find(folder => folder?.label === 'Admin Sale Presentation');
                if (this.innerDefault == 'Admin Sale Presentation' || isSP) {
                  this.sp.saveSP(this.propertyId);
                }
              } else {
                this.toastr.error(`${response?.message}`); // Show error message if deletion fails
                this.dragLoading = false; // Set loading state to false
              }
            },
            error: error => {
              // Handle any errors from the DELETE request
              this.dragLoading = false; // Set loading state to false
              this.toastr.error(error?.error?.message ? error?.error?.message : 'Something went wrong'); // Show error message
            },
          });
        });
    } else {
      // If no items can be deleted (e.g., viewer access only), show an error message
      this.toastr.error(`Viewer access only`); // Show error message for restricted access
    }
  }

  isPending = false;
  /**
   * Shares a file or folder from the office library with selected users or teams.
   * Prepares the necessary parameters and sends a PUT request to share the item.
   */
  shareOfficeLibraryFolderFile() {
    let shareWithUser: any = []; // Array to store the users to share with

    // Loop through selected users to share the item
    this.selectedUsersToShare.forEach(f => {
      // If the user is from a team, check for user members and add their IDs
      if (f?.category == 'team') {
        if (f?.user_members !== undefined && f?.user_members != null && f?.user_members?.length > 0) {
          f?.user_members?.forEach(element => {
            shareWithUser.push(element?._id); // Add user member's ID to the share list
          });
        }
      } else {
        // If not a team, add the user's ID directly to the share list
        shareWithUser.push(f?._id);
      }
    });

    this.isPending = true; // Set the pending state to true while processing

    // If there are users to share with, proceed with the sharing operation
    if (shareWithUser) {
      let createdLink = ''; // Variable to store the generated link
      // Prepare parameters for the PUT request
      let param = {
        office_id: this.Api.getOfficeId(), // Office ID from localStorage
        user_id: this.authUserID, // User ID of the person sharing the file/folder
        propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId, // Property ID (either from propertyId or officeLibraryReferenceId)
        file_type: this.file_type, // File type
        id: this.selectedFileFolderID, // ID of the selected file or folder
        view_only_with: shareWithUser, // List of users to share the file/folder with
      };

      // Check if the URL contains "Id=" or "id=" to append the selectedFileFolderID to the link
      if (this.router.url?.split('Id=').length > 0) {
        createdLink = this.router.url?.split('Id=').slice(0, -1) + `Id=${this.selectedFileFolderID}`;
      } else if (this.router.url?.split('id=').length > 0) {
        createdLink = this.router.url?.split('id=').slice(0, -1) + `Id=${this.selectedFileFolderID}`;
      }

      // If a valid link is generated, add it to the parameters
      if (createdLink?.length > 0) {
        param['link'] = this.router.url + '?' + createdLink;
      } else {
        // If no link is generated, just use the current URL
        param['link'] = this.router.url;
      }

      // Make the PUT request to share the file/folder
      this.Api.put(`/office-library/folder-file-view-only-with`, param).subscribe({
        next: response => {
          // If the response status is true, the share operation was successful
          if (response?.status !== undefined && response?.status != null && response?.status == true) {
            this.toastr.success('Data shared successfully'); // Show success message
            this.sideBarLev1(null); // Refresh the sidebar (or perform any necessary updates)
            this.resetSelectedItems(); // Reset the selected items after sharing
            this.isPending = this.modalShare = false; // Reset the loading state and close the modal
            this.selectedUsersToShare = []; // Clear the selected users
          } else {
            // If the response status is false, show an error message
            this.toastr.error(`Shared successfully!`);
          }
        },
        error: error => {
          // Handle any errors from the PUT request
          this.toastr.error(error?.error?.message ? error?.error?.message : 'Something went Wrong'); // Show error message
        },
      });
    }
  }

  /**
   * Creates a copy of the specified library folder or file.
   * Checks if the item can be copied and sends a POST request to copy the item.
   */
  makeACopyLibraryFolderFile(item: any) {
    // If officeLibraryReferenceId is empty or the item can't be deleted, show an error and exit
    if (this.officeLibraryReferenceId == '' || item?.can_delete == false) {
      this.toastr.error("Can't Create Copy"); // Show error message
      return;
    }

    // Prepare parameters for the POST request
    let param = {
      office_id: this.Api.getOfficeId(), // Office ID from localStorage
      user_id: this.authUserID, // User ID of the person making the copy
      propertyId: this.propertyId ? this.propertyId : this.officeLibraryReferenceId, // Property ID (either from propertyId or officeLibraryReferenceId)
      id: item?._id, // ID of the item to be copied
    };

    // Send POST request to create a copy of the folder or file
    this.Api.post(`/office-library/copy-folder-file`, param).subscribe({
      next: response => {
        // If the response status is true, the copy operation was successful
        if (response?.status !== undefined && response?.status != null && response?.status == true) {
          this.sideBarLev1(null); // Refresh the sidebar or perform any necessary updates
          this.resetSelectedItems(); // Reset the selected items after the copy operation
          this.toastr.success('Copied successfully'); // Show success message
        } else {
          // If the response status is false, show an error message
          this.toastr.error(response?.message ? `${response?.message}` : 'Unable to Copy'); // Show error message
        }
      },
      error: error => {
        // Handle any errors from the POST request
        this.toastr.error(error?.error?.message ? error?.error?.message : 'Something went Wrong'); // Show error message
      },
    });
  }

  /**
   * Checks if the current user is included in the list of users with 'view-only' access to the folder/file.
   * @param item The folder or file item to check.
   * @returns {boolean} Returns true if the current user has 'view-only' access; otherwise, false.
   */
  shareFolderFileWithUsers(item) {
    // If no item is passed, return false
    if (!item) {
      return false;
    } else {
      // If the item has 'view_only_with' users
      if (item?.view_only_with?.length > 0) {
        let sharedUsers = item?.view_only_with;

        // Check if the current user is in the 'view_only_with' list
        if (sharedUsers?.filter(userId => userId == this.authUserID)?.[0]) {
          return true; // User is in the list, return true
        }
      }
    }

    // Default return value if user is not in the 'view_only_with' list
    return false;
  }

  /**
   * Retrieves and processes a list of users who have 'view-only' access to the shared file/folder.
   * Populates the `FileSharedUsersList` and `selectedUsersToShare` with user data.
   * @param item The folder/file item containing the shared users.
   */
  getAllUserListFileSharedPrivateLibrary(item) {
    // Clear the current FileSharedUsersList
    this.FileSharedUsersList = [];

    // Assign the response data from the item
    let response = item;

    // If 'view_only_with' exists and has users
    if (response?.view_only_with !== undefined && response?.view_only_with != null && response?.view_only_with?.length > 0) {
      // Loop through each user ID in the 'view_only_with' list
      response?.view_only_with?.forEach(element => {
        // If the element (user ID) is valid
        if (element !== undefined && element != null) {
          // Find the user record from allUsers list by matching user ID
          let userrecord = this.allUsers.filter(user => user?._id == element);

          // If user record is found, push it to FileSharedUsersList with 'view' permission
          if (userrecord !== undefined && userrecord != null) this.FileSharedUsersList?.push({ ...userrecord?.[0], manage: 'view' });
        }
      });
    }

    // Set the selected users to share based on the FileSharedUsersList
    this.selectedUsersToShare = this.FileSharedUsersList;
  }

  isDragDropSorting: Boolean = false;
  /**
   * Handles the drag-and-drop event for reordering folder or file items.
   * @param event The drag-and-drop event triggered by CdkDragDrop.
   */
  dropFolderFile(event: CdkDragDrop<any>) {
    // Check if the user has the required role or permission to reorder items
    if (!(this.userRole == 'master admin' || this.userRole == 'operations manager' || this.userPermission.includes('reorder_images.update'))) {
      this.toastr.error("You don't have permission to reorder"); // Show error if user lacks permission
      return;
    }

    // Retrieve the dragged image from the event's previous container
    const draggedImage = event?.previousContainer?.data['itm'];

    // If the dragged image's name is not 'Floorplans'
    if (draggedImage?.name !== 'Floorplans') {
      // If searchedResultId is not set, assign it a temporary ID
      if (!this.searchedResultId) {
        this.searchedResultId = this.temp_id;
      }

      // If propertyId or searchedResultId is not set, try to retrieve it from query parameters
      if (!this.propertyId || !this.searchedResultId) {
        this.lifetimeSubs.add(
          this.route.queryParams.subscribe({
            next: params => {
              if (params['Id']?.toString() || params['id']?.toString()) {
                // Set searchedResultId to the value found in the query parameters
                this.searchedResultId = params['Id']?.toString() ? params['Id']?.toString() : params['id']?.toString();
              }
            },
          })
        );
      }

      // If either searchedResultId or propertyId is set, proceed with reordering
      if (this.searchedResultId || this.propertyId) {
        // Move the dragged item within the data array
        this.array_move(this.libraryData, event.previousContainer.data.index, event.container.data.index);

        // Save the new order after the item has been moved
        this.saveOrder();
      } else {
        // Show error if neither searchedResultId nor propertyId is available
        this.toastr.error('Unable to drag image');
      }
    }
  }

  /**
   * Saves the new order of items after reordering in the library.
   */
  saveOrder() {
    // Check if the user has the necessary role or permission to reorder items
    if (!(this.userRole == 'master admin' || this.userRole == 'operations manager' || this.userPermission.includes('reorder_images.update'))) {
      this.toastr.error("You don't have permission to reorder"); // Show error if the user lacks permission
      return;
    }

    // Create a copy of the library data to work with
    let newArray = [...this.libraryData];

    // Filter out the items that already exist in newArray, using their _id to compare
    let originalArray = this.libraryDataCopy.filter(item => !newArray.some(newItem => newItem._id === item._id));

    // If there are items that are not yet in newArray, add them to the end of newArray
    if (originalArray?.length > 0) {
      newArray = [...newArray, ...originalArray].map(ele => {
        return (ele = { ...ele, isSort: true });
      });
    }

    // Send the updated order to the API
    this.Api.put(
      `/library/swap-file/${this.searchedResultId ? this.searchedResultId : this.propertyId}/${this.activeOfficeId}?library_type=${this.library_type}&user_id=${this.authUserID}`,
      newArray
    ).subscribe({
      next: _ => {
        // On success, update the libraryData and reset the selected items
        this.libraryData = [...this.libraryData];
        this.selectedGallaryItem = [];
        this.toastr.success('Updated successfully');

        // If there's no propertyId, reset the searchedResultId
        if (!this.propertyId) {
          this.searchedResultId = null;
        }
      },
      error: error => {
        // On error, show the error message
        this.toastr.error(error.error.message);
      },
    });
  }

  /**
   * Returns the status of the drag-and-drop sorting feature.
   * @returns {boolean} - The value of `isDragDropSorting` indicating whether drag-drop sorting is enabled.
   */
  noReturnPredicate() {
    return this.isDragDropSorting; // Returns the value of the drag-and-drop sorting status
  }

  /**
   * Filters the list of folders and files to return only those shared with the user.
   * @param {any[]} data - An array of items to be filtered.
   * @returns {any[]} - A filtered array containing only files that are shared with the user.
   */
  getFilteredFolderFileIfShared(data: any[] = []): any[] {
    if (data) {
      let fileData = data || []; // Default to an empty array if no data is provided
      let dataset: any[] = []; // Array to store the filtered results

      // Iterate through each item in the file data
      fileData?.forEach((result: any) => {
        // Check if the folder/file is shared with the user
        if (this.isFolderSharedWithUser(result)) {
          // If it's a file, add it to the dataset
          if (result?.type == 'file') {
            dataset.push(result); // Add file to the dataset
          }
        }
      });

      return dataset; // Return the filtered dataset of shared files
    } else {
      return null; // Return null if no data is provided
    }
  }

  /**
   * Checks whether the folder is shared with the user based on several conditions.
   * @param {any} item - The folder/item to check if it's shared with the user.
   * @returns {boolean} - Returns true if the folder is shared with the user, otherwise false.
   */
  isFolderSharedWithUser(item): boolean {
    // Check if the category is 'useroffice'
    if (this.category == 'useroffice') {
      // No-op statement (empty string to lowercase, does nothing)
      ''.toLowerCase();

      // If the item is private, only the operation manager role has access
      if (item?.is_private) {
        return this.userRoleId == this.operationManagerRoleId;
      }
      // If the user is a 'master admin' or 'operations manager', grant access
      else if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
        return true; // Admins have access
      }
      // If the item is shared with specific users, check if the user is included
      else if (item?.view_only_with?.length > 0) {
        return this.shareFolderFileWithUsers(item); // Check using the shareFolderFileWithUsers function
      }
      // If the item has access permissions, check if the user's permissions match
      else if (item?.access_permission?.length > 0) {
        let permission: string[] = item?.access_permission?.map(value => value?.visible_to)?.flat(); // Flatten visible_to permissions
        let user_teams: string[] = JSON.parse(this.user_team_ids); // Parse user team IDs
        // Check if the current user or their team has permission
        return permission?.includes(this.Api.getUserId()) || user_teams?.some((value: string) => permission?.includes(value));
      }
      // If no special condition, assume the folder is shared
      else {
        return true;
      }
    } else {
      // For other categories, handle similarly
      if (this.userRole?.toLowerCase() === 'master admin' || this.userRole?.toLowerCase() === 'operations manager') {
        return true; // Admins have access
      }
      // If the item is shared with specific users, check if the user is included
      else if (item?.view_only_with?.length > 0) {
        return this.shareFolderFileWithUsers(item); // Check using the shareFolderFileWithUsers function
      }
      // If the item has access permissions, check if the user's permissions match
      else if (item?.access_permission?.length > 0) {
        let permission: string[] = item?.access_permission?.map(value => value?.visible_to)?.flat(); // Flatten visible_to permissions
        let user_teams: string[] = JSON.parse(this.user_team_ids); // Parse user team IDs
        // Check if the current user or their team has permission
        return permission?.includes(this.Api.getUserId()) || user_teams?.some((value: string) => permission?.includes(value));
      }
      // If no special condition, assume the folder is shared
      else {
        return true;
      }
    }
  }

  /**
   * Reorders items in the library and sends an update request to the server.
   * @param {any[]} libraryListItem - List of library items to reorder.
   */
  librarySwappingReorder(libraryListItem = []) {
    // If no items are provided in the list, exit the function early
    if (!libraryListItem?.length) {
      return;
    }

    // Check if the user has permission to reorder items (admin or permissions check)
    if (!(this.userRole == 'master admin' || this.userRole == 'operations manager' || this.userPermission.includes('reorder_images.update'))) {
      this.toastr.error("You don't have permission to reorder");
      return;
    }

    // Indicate that the process is loading
    this.loading = true;

    // Determine the library type based on the current URL
    let url = this.router.url.split('?')[0];
    if (url == '/library/private') {
      this.library_type = 'private'; // If the URL matches '/library/private', set library type to 'private'
    } else {
      this.library_type = 'office'; // Otherwise, set library type to 'office'
    }

    // Ensure the `searchedResultId` is set, using `temp_id` if not defined
    if (!this.searchedResultId) {
      this.searchedResultId = this.temp_id;
    }

    // Make an API request to reorder the library items, sending the updated order
    this.Api.put(
      `/library/swap-file/${this.searchedResultId ? this.searchedResultId : this.propertyId}/${this.activeOfficeId}?library_type=${this.library_type}`,
      libraryListItem
    ).subscribe({
      // Handle successful response
      next: response => {
        if (response.status == true) {
          // If the reorder is successful, reset sidebar and show a success message
          this.sideBarLev1(null);
          this.toastr.success('Reorder successfully');
          this.loading = false; // Hide loading spinner
          this.searchedResultId = null; // Clear the `searchedResultId` after the operation
        } else {
          // If the response indicates failure, show an error message
          this.loading = false; // Hide loading spinner
          this.toastr.error(response.message);
        }
      },
      // Handle error response
      error: () => {
        this.loading = false; // Hide loading spinner
        this.toastr.error('Something went wrong'); // Show error message if the request fails
      },
    });
  }

  /**
   * Updates the folder structure sequence based on the provided event.
   * @param {any} event - The event containing the current order of items.
   */
  updateFolderStructureSequences(event) {
    // Destructure `currentOrder` from the event object
    const { currentOrder } = event;

    // If no current order is provided, exit the function
    if (!currentOrder) {
      return;
    }

    // Call the `librarySwappingReorder` function to update the order of the items
    this.librarySwappingReorder(currentOrder);
  }

  /**
   * Emits the video URL and tour links.
   * This function collects the video URL and tour URLs and sends them out using an event emitter.
   */
  addEmbeddedUrlVideo() {
    // Get the values for the video URL and online tours
    let videoURL = this.embedVideoURL;
    let onlineTour1 = this.onlineTour1;
    let onlineTour2 = this.onlineTour2;

    // Emit the collected data (video and tour URLs) using an event emitter
    this.videoLinks.emit({ video: videoURL, tour1: onlineTour1, tour2: onlineTour2 });
  }

  /**
   * Extracts an iframe tag from the provided inner HTML string.
   * @param {string} innerHtml - The HTML string that may contain an iframe tag.
   * @returns {string} - The extracted iframe tag with necessary modifications.
   */
  extractIframeTagFromInnerHtml(innerHtml: string = ''): string {
    try {
      // Check if the inner HTML starts with an iframe tag
      if (innerHtml.startsWith('<iframe')) {
        // Create a new DOMParser to parse the inner HTML into a DOM object
        var parser = new DOMParser();
        var htmlDoc = parser?.parseFromString(innerHtml, 'text/html');

        // Get all iframe elements from the parsed document
        let iframeList = htmlDoc.getElementsByTagName('iframe');

        // Modify the first iframe element (if it exists)
        iframeList[0].id = 'thirdpartyembed'; // Set the iframe ID
        iframeList[0].style.height = '100%'; // Set height to 100%
        iframeList[0].style.width = '100%'; // Set width to 100%

        // Return the outer HTML of the modified iframe, or an empty string if not found
        return iframeList?.[0]?.outerHTML || '';
      }

      // Return an empty string if the inner HTML does not start with an iframe
      return '';
    } catch (error) {
      // Return an empty string if any error occurs during the extraction process
      return '';
    }
  }

  /**
   * Retrieves the root ID based on the selected sidebar link and the "Properties" category.
   * @returns {string | null} - The root ID if found, otherwise null.
   */
  getRootId() {
    // Check if `allDataLibrary` is defined and not null
    if (this.allDataLibrary) {
      let root_id = null; // Initialize the variable to store the root ID

      // Iterate through the `allDataLibrary` array to find the "Properties" category
      this.allDataLibrary.forEach(x => {
        if (x?.name == 'Properties') {
          // Check if the current item has the name 'Properties'
          // Filter the children of the 'Properties' category based on the selected sidebar link
          let property = x?.childrens.filter(x => x?.ref_id == this.selectedSidebarLink);

          // Assign the root ID from the first matched property (if any)
          root_id = property[0]?._id;
        }
      });

      // Return the root ID (either found or null)
      return root_id;
    }
  }

  libEdit: boolean = false;
  galItems: any = [];
  editorBackBtn = false;
  @ViewChild('dropListContainer') dropListContainer?: ElementRef;
  /**
   * Opens the modal to move a folder.
   * params: value - boolean value to open or close the modal
   * Check if the every file has the 'is_offline' field and assign false if missing
   */
  showLibedit(value: boolean = false) {
    if (!this.isNotSharedPage || this.isUserOffice) {
      this.toastr.error('You can not edit these images');
      return;
    }
    if (this.dragLoading) return;
    this.selectedGalItems = [];
    this.galItems = [];
    this.portalImages = [];
    const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));
    if (!hasIsOfflineField) {
      this.libraryData.forEach(item => {
        if (!item.hasOwnProperty('is_offline')) {
          item['is_offline'] = false;
        }
      });
    }
    this.portalImages = [];
    this.galItems = [];
    this.libraryData.forEach(item => {
      if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png' || item.file_type === 'image/jpeg')) {
        if (item.is_offline === false) {
          this.galItems.push(item);
        } else if (item.is_offline === true) {
          this.portalImages.push(item);
        }
      }
      if (item.type == 'folder' && item.name == 'Floorplans') {
        if (!this.galItems.some(galItem => galItem._id === item._id)) {
          this.galItems.push(item);
        }
        this.editorBackBtn = true;
      }
    });
    this.galItems.sort((a, b) => {
      if (a.type === 'folder' && a.name === 'Floorplans') return 1;
      if (b.type === 'folder' && b.name === 'Floorplans') return -1;
      return 0;
    });
    this.galItems.forEach(n => {
      if (n.type !== 'folder' && (n.file_type === 'image/jpeg' || n.file_type === 'image/png' || n.file_type === 'image/jpeg')) {
        n.info_div = {
          uploadedby: this.getUserName(n?.user_id),
          modified: moment(n?.updated_at)?.format('DD MMM YYYY'),
          created: moment(n?.created_at)?.format('DD MMM YYYY'),
          dimentions: this.getImageDimenssion(this.getLargeImageByPath(n)),
        };
      }
    });
    this.portalImages.forEach(n => {
      n.info_div = {
        uploadedby: this.getUserName(n?.user_id),
        modified: moment(n?.updated_at)?.format('DD MMM YYYY'),
        created: moment(n?.created_at)?.format('DD MMM YYYY'),
        dimentions: this.getImageDimenssion(this.getLargeImageByPath(n)),
      };
    });
    this.libEdit = value;
    if (value) {
      this.document.getElementsByClassName('siteTopBar')[0].setAttribute('style', 'z-index: auto');
      this.document.getElementsByClassName('sidebar-menu')[0].setAttribute('style', 'z-index: auto');
    } else {
      this.document.getElementsByClassName('siteTopBar')[0].setAttribute('style', 'z-index: initial');
      this.document.getElementsByClassName('sidebar-menu')[0].setAttribute('style', 'z-index: initial');
      this.document.getElementsByClassName('siteTopBar')[0].removeAttribute('style');
      this.document.getElementsByClassName('sidebar-menu')[0].removeAttribute('style');
    }

    window.setTimeout(() => {
      const previewElement = document.getElementById('preview');
      if (previewElement) {
        previewElement.style.display = 'none';
      }
    }, 300);
    if (this.defaultOpen == 'images') {
      this.libraryData.sort((a, b) => {
        if (a.type === 'file' && b.type === 'folder') {
          return -1;
        }
        if (a.type === 'folder' && b.type === 'file') {
          return 1;
        }
        return 0;
      });
    }
  }

  showWaterMarking: boolean = false;
  scale = 1;
  gridpercentage: any = 45;
  selectedImage_scale: any = 1;
  selectedImage_displayscale: any = 100;

  selectedGallaryItem: any = null;
  selectedGallaryItemPath: any = null;

  gridthumbwidth: number = 4.8;
  gridthumbheight: number = 3.68;

  overIt: any = null;
  /**
   * Retrieves the dimensions (width x height) of an image by loading it from the provided URL.
   * @param {string} imgUrl - The URL of the image whose dimensions are to be retrieved.
   * @returns {Promise<string>} - A promise that resolves with the dimensions of the image in "width x height" format.
   */
  getImageDimenssion(imgUrl) {
    // Return a promise to handle asynchronous image loading
    return new Promise(resolve => {
      let img = new Image(); // Create a new image element
      img.src = imgUrl; // Set the source of the image to the provided URL

      // When the image is loaded, execute the following function
      img.onload = function (event) {
        let loadedImage: any = event.currentTarget; // Get the loaded image from the event
        let width = loadedImage.width; // Get the width of the image
        let height = loadedImage.height; // Get the height of the image
        return resolve(`${width} x ${height}`); // Resolve the promise with the dimensions in "width x height" format
      };
    });
  }

  /**
   * Handles hover interaction for an item by displaying a preview and retrieving its image dimensions.
   * @param {any} item - The item being hovered over, which contains an image path.
   */
  async hoverovered(item) {
    // Display the preview element (assuming it is initially hidden)
    this.document.getElementById('preview').style.display = 'block';

    // Assign the hovered item to the `overIt` variable
    this.overIt = item;

    // Wait for the image dimensions to be retrieved and store them in `dimentions` property
    this.overIt.dimentions = await this.getImageDimenssion(this.getLargeImageByPath(item));
  }

  /**
   * Restores the original image from the library and updates the gallery data.
   * @returns {void}
   */
  restoreToOrignalImage() {
    // Sending a POST request to restore the original image to the server
    this.Api.post(`/library/restore-orignal-image`, {
      user_id: this.authUserID, // The user ID of the current authenticated user
      library_type: this.library_type || 'private', // The type of the library, default is 'private'
      office_id: this.activeOfficeId, // The ID of the active office
      folderId: this.searchedResultId ? this.searchedResultId : this.propertyId, // Folder ID (either searched result or property ID)
      image_id: this.selectedGallaryItem._id, // The ID of the selected gallery item (image)
    }).subscribe({
      next: response => {
        // Filter out deleted items from the response folder
        let tmp = response.folder.filter(nn => nn?.is_deleted != true);
        this.libraryData = [...tmp]; // Update the library data with filtered items
        this.galItems = []; // Reset the gallery items
        this.portalImages = []; // Reset the portal images

        // Check if all items in the library data have the 'is_offline' property
        const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));
        if (!hasIsOfflineField) {
          // If the 'is_offline' field is missing, add it with a default value of 'false'
          this.libraryData.forEach(item => {
            if (!item.hasOwnProperty('is_offline')) {
              item.is_offline = false;
            }
          });
        }

        // Sorting the library data into two categories: gallery items and portal images
        this.libraryData.forEach(item => {
          if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png' || item.file_type === 'image/jpeg')) {
            if (item.is_offline === false) {
              this.galItems.push(item); // Add to gallery items if not offline
            } else if (item.is_offline === true) {
              this.portalImages.push(item); // Add to portal images if offline
            }
          }
          // If the item is a 'folder' and the name is 'Floorplans', add it to gallery items if not already present
          if (item.type == 'folder' && item.name == 'Floorplans') {
            if (!this.galItems.some(galItem => galItem._id === item._id)) {
              this.galItems.push(item);
            }
          }
        });

        // Sort gallery items to ensure 'Floorplans' folder appears last
        this.galItems.sort((a, b) => {
          if (a.type === 'folder' && a.name === 'Floorplans') return 1;
          if (b.type === 'folder' && b.name === 'Floorplans') return -1;
          return 0;
        });

        // Display success message after successfully restoring the image
        this.toastr.success(response.message);
      },
    });

    // Hide watermarking
    this.showWaterMarking = false;

    // Select the original image from the gallery and preview it
    this.iselectGallaryItem(this.selectedGallaryItem, this.getOriginalLargeImageByPath(this.selectedGallaryItem));
  }

  // Returns the tooltip text
  restoreTip() {
    return '<p>Restore original image</p>';
  }
  workspaceImgCopyId = null;
  /**
   * Duplicates the selected files by copying them to a new location in the library.
   * @returns {void}
   */
  duplicateFiles() {
    // Initialize an empty array to hold the IDs of selected items
    let ids = [];
    this.selectedGalItems.forEach(n => {
      ids.push(n._id); // Collect the _id of each selected gallery item
    });

    // Set loading state to true to indicate ongoing operation
    this.dragEditLoading = true;

    // Check if no items are selected, and show an error if that's the case
    if (ids?.length == 0) {
      this.toastr.error('Please select an image');
      this.dragEditLoading = false;
      return; // Exit the function if no items are selected
    }

    // Determine the root ID based on the library type and available root IDs
    let rootId;
    if (this.isContractLibrary && this.contractRootId) {
      rootId = this.contractRootId; // Use contract root ID if in contract library
    } else if (this.isListingLibrary && this.listingRootId) {
      rootId = this.listingRootId; // Use listing root ID if in listing library
    } else {
      rootId = this.getRootId(); // Default to the root ID obtained from getRootId() function
    }

    // Make a POST request to the server to copy the selected files
    this.Api.post(`/library/copy-folder-file`, {
      id: ids, // Pass the array of selected IDs
      office_id: this.activeOfficeId, // The active office ID
      folderId: rootId ? rootId : this.searchedResultId ? this.searchedResultId : this.propertyId, // The folder ID to copy to
      user_id: this.authUserID, // The authenticated user ID
      library_type: this.library_type, // The type of the library (e.g., private or office)
    }).subscribe({
      next: response => {
        this.workspaceImgCopyId = null; // Clear workspace image copy ID

        // Handle success for specific categories (shared, favourite, workspace)
        if (this.category == 'shared' || this.category == 'favourite' || this.category == 'workspace') {
          this.sideBarLev1(null); // Close the sidebar
          this.toastr.success('Copy successfully'); // Show success message
          return;
        }

        // Clear the selected gallery item array
        this.selectedGallaryItem = [];

        // Filter out deleted items from the response and update the library data
        let tmp = response.folder.filter(nn => nn?.is_deleted != true);
        this.libraryData = this.libraryDataCopy = [...tmp]; // Update both library data and library data copy
        this.galItems = []; // Reset gallery items
        this.portalImages = []; // Reset portal images

        // Check if all items in the library data have the 'is_offline' property
        const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));
        if (!hasIsOfflineField) {
          // If the 'is_offline' field is missing, add it with a default value of 'false'
          this.libraryData.forEach(item => {
            if (!item.hasOwnProperty('is_offline')) {
              item.is_offline = false;
            }
          });
        }

        // Categorize the library items into gallery items and portal images
        this.libraryData.forEach(item => {
          if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png' || item.file_type === 'image/jpeg')) {
            if (item.is_offline === false) {
              this.galItems.push(item); // Add to gallery items if not offline
            } else if (item.is_offline === true) {
              this.portalImages.push(item); // Add to portal images if offline
            }
          }
          // If the item is a folder with the name 'Floorplans', always add it to gallery items if not already present
          if (item.type == 'folder' && item.name == 'Floorplans') {
            if (!this.galItems.some(galItem => galItem._id === item._id)) {
              this.galItems.push(item);
            }
          }
        });

        // Sort gallery items to ensure 'Floorplans' folder appears last
        this.galItems.sort((a, b) => {
          if (a.type === 'folder' && a.name === 'Floorplans') return 1;
          if (b.type === 'folder' && b.name === 'Floorplans') return -1;
          return 0;
        });

        // If the library data and gallery items are both empty, close the sidebar
        if (this.libraryData?.length === 0 && this.galItems?.length === 0) {
          this.sideBarLev1(null);
        }

        // Set loading state to false after the operation is complete
        this.dragEditLoading = false;

        // Show success message after copying the files
        this.toastr.success('Copy successfully');
      },
    });
  }

  /**
   * Saves the sorting order of images by updating their position in the library.
   * @param {any} item - The image item to be reordered (optional).
   * @param {number} index - The index at which to insert the item (optional).
   * @returns {void}
   */
  saveSort(item: any = null, index: number = null) {
    // Check if the user has the necessary permissions to reorder images
    if (!(this.userRole == 'master admin' || this.userRole == 'operations manager' || this.userPermission.includes('reorder_images.update'))) {
      this.toastr.error("You don't have permission to reorder"); // Show error if no permission
      return; // Exit the function if the user doesn't have permission
    }

    // Merge gallery items and portal images into a new array
    let newArray = [...this.galItems, ...this.portalImages];

    // Create a new array by filtering out the items that are already in newArray
    let originalArray = this.libraryDataCopy.filter(
      item => !newArray.some(newItem => newItem._id === item._id) // Filter items that are not already present
    );

    // If the originalArray has any items, merge it into newArray
    if (originalArray?.length > 0) {
      newArray = [...newArray, ...originalArray];
    }

    // Remove any null items from the newArray
    newArray = newArray.filter(item => item !== null);

    // Subscribe to query parameters to extract property ID if available
    this.lifetimeSubs.add(
      this.route.queryParams.subscribe({
        next: params => {
          if (!this.propertyId && (params['Id']?.toString() || params['id']?.toString())) {
            this.searchedResultId = params['Id']?.toString() ? params['Id']?.toString() : params['id']?.toString(); // Set searchedResultId from query params
          }
        },
      })
    );

    // If searchedResultId is not set, fall back to a temporary ID
    if (!this.searchedResultId) {
      this.searchedResultId = this.temp_id;
    }

    // Make a PUT request to the server to update the sorting order
    this.Api.put(
      `/library/swap-file/${this.searchedResultId ? this.searchedResultId : this.propertyId}/${this.activeOfficeId}?library_type=${this.library_type}&user_id=${this.authUserID}`,
      newArray
    ).subscribe({
      next: () => {
        // If a propertyId exists, update the library data
        if (this.propertyId) this.libraryData = [...newArray];

        // Sort the gallery items so that 'Floorplans' appears at the end
        this.galItems.sort((a, b) => {
          if (a.type === 'folder' && a.name === 'Floorplans') return 1; // Move 'Floorplans' to the end
          if (b.type === 'folder' && b.name === 'Floorplans') return -1;
          return 0; // Maintain other sorting order
        });

        // If a search keyword is provided, filter the gallery items based on the keyword
        if (this.searchKeyword && !this.propertyId) {
          this.galItems = this.galItems.filter(val => val.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
          if (this.galItems?.length == 0) this.searchKeyword = ''; // Clear search keyword if no items match
        }

        // Clear selected gallery item
        this.selectedGallaryItem = [];

        // Show a success toast message
        this.toastr.success('Updated successfully', '', {
          positionClass: 'custom-toast-position',
        });

        // If there's no propertyId, reset searchedResultId and close the sidebar
        if (!this.propertyId) {
          this.searchedResultId = null;
          this.sideBarLev1(null);
        } else {
          // Otherwise, load the private office folders
          this.getPrivateOfficeFolders();
        }
      },
      error: error => {
        // If an error occurs, handle it by updating portal images and gallery items accordingly
        this.portalImages = this.portalImages?.filter(x => x?._id !== item?._id); // Remove the item from portalImages
        this.galItems.splice(index, 0, item); // Reinsert the item at the original index

        // Show an error toast message with the error details
        this.toastr.error(error.error.message, '', {
          positionClass: 'custom-toast-position',
        });
      },
    });
  }

  /**
   * Saves the edited image after modification and updates the gallery data.
   * @returns {void}
   */
  editedImageSave() {
    // Make a POST request to save the edited image data
    this.Api.post(`/library/edited-image-save`, {
      user_id: this.authUserID, // The user ID of the current user
      library_type: this.library_type || 'private', // The type of library, defaulting to 'private'
      office_id: this.activeOfficeId, // The active office ID
      folderId: this.searchedResultId ? this.searchedResultId : this.propertyId, // The folder ID, either from searchedResultId or propertyId
      image_id: this.selectedGallaryItem._id, // The ID of the selected gallery item (image)
      fileSrc: this.libImageEditor._tuiImageEditor.toDataURL({ quality: 0.5 }), // The edited image as a Data URL with reduced quality (0.5)
    }).subscribe({
      next: response => {
        // Once the request is successful, clear the selected gallery item
        this.selectedGallaryItem = null;

        // Filter out deleted items and store the response data in libraryData
        let tmp = response.folder.filter(nn => nn?.is_deleted != true);
        this.libraryData = [...tmp]; // Update libraryData with the filtered items

        // Initialize empty arrays for gallery items and portal images
        this.galItems = [];
        this.portalImages = [];

        // Check if 'is_offline' property exists in all items, and set default value if not
        const hasIsOfflineField = this.libraryData.every(item => item.hasOwnProperty('is_offline'));
        if (!hasIsOfflineField) {
          this.libraryData.forEach(item => {
            if (!item.hasOwnProperty('is_offline')) {
              item.is_offline = false; // Set 'is_offline' to false if not already set
            }
          });
        }

        // Classify items into gallery items and portal images based on their 'is_offline' status
        this.libraryData.forEach(item => {
          if (item.type !== 'folder' && (item.file_type === 'image/jpeg' || item.file_type === 'image/png' || item.file_type === 'image/jpeg')) {
            if (item.is_offline === false) {
              this.galItems.push(item); // Add to gallery items if not offline
            } else if (item.is_offline === true) {
              this.portalImages.push(item); // Add to portal images if offline
            }
          }
          // Special handling for 'Floorplans' folder
          if (item.type == 'folder' && item.name == 'Floorplans') {
            if (!this.galItems.some(galItem => galItem._id === item._id)) {
              this.galItems.push(item); // Add the 'Floorplans' folder to gallery items if not already present
            }
          }
        });

        // Sort gallery items to ensure 'Floorplans' appears at the end
        this.galItems.sort((a, b) => {
          if (a.type === 'folder' && a.name === 'Floorplans') return 1; // Move 'Floorplans' folder to the end
          if (b.type === 'folder' && b.name === 'Floorplans') return -1;
          return 0; // Maintain other sorting order
        });

        // Set display flag to true after saving the image
        this.display = true;

        // Show a success toast message with the response message
        this.toastr.success(response.message, '', {
          positionClass: 'custom-toast-position', // Custom position for the toast message
        });
      },
    });
  }

  /**
   * Converts an image at the given path to a Base64-encoded PNG format.
   * @param {string} path - The URL or path to the image that needs to be converted to Base64.
   * @returns {string} - The Base64-encoded PNG image data URL.
   */
  getBase64Image(path) {
    // Create a new image element
    var img = new Image();

    // Set the 'crossOrigin' property to 'anonymous' to handle CORS (Cross-Origin Resource Sharing)
    img.crossOrigin = 'anonymous';

    // Define the function to execute once the image is loaded
    img.onload = function () {
      // Set the canvas dimensions to match the loaded image
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw the loaded image onto the canvas at the specified position (0,0)
      ctx.drawImage(img, 0, 0); // Or at whatever offset you like
    };

    // Set the source of the image to the provided path
    img.src = path;

    // Create a new canvas element
    var canvas = document.createElement('canvas');

    // Set the canvas width and height to match the loaded image's dimensions
    canvas.width = img.width;
    canvas.height = img.height;

    // Get the 2D drawing context of the canvas
    var ctx = canvas.getContext('2d');

    // Draw the image onto the canvas (this line may not be executed until the image is loaded)
    ctx.drawImage(img, 0, 0);

    // Convert the canvas image to a Base64-encoded PNG data URL
    var dataURL = canvas.toDataURL('image/png');

    // Return the Base64-encoded PNG data URL
    return dataURL;
  }

  /**
   * HostListener for the 'keydown' event, which listens for keyboard input on the document.
   * Specifically handles the 'Escape' key (keyCode 27) to close the image editor and clear selected gallery items.
   * @param {KeyboardEvent} e - The keyboard event that is triggered when a key is pressed.
   */
  @HostListener('keydown', ['$event']) onKeyDown(e) {
    // Check if the pressed key is the 'Escape' key (keyCode 27)
    if (e.keyCode == 27) {
      // Close the image editor by setting openEditorImage to false
      this.openEditorImage = false;

      // Destroy the image editor instance to release resources (if applicable)
      this.libImageEditor?._distroyImageEditor();

      // Ensure the image editor is closed by setting openEditorImage to false again
      this.openEditorImage = false;

      // Clear the currently selected gallery item and its path
      this.selectedGallaryItem = null;
      this.selectedGallaryItemPath = null;

      // Reset the selected gallery items array and their ids
      this.selectedGalItems = [];
      this.selectedGalItems_ids = [];
    }
  }

  openEditorImage: boolean = false;
  imgLoad = true;
  /**
   * Handles the selection of a gallery item.
   * If an image is loaded, it processes the selection, updates the state, and resets certain properties.
   * @param {any} item - The gallery item that was clicked or selected.
   * @param {string} path - The path of the selected image.
   * @param {Event} e - The event that triggered the selection, used to check if the ctrl key was pressed.
   */
  selectGallaryItem(item, path, e) {
    // Check if the image is loaded before proceeding
    if (this.imgLoad) {
      // Set display to true and imgLoad to false to indicate image loading is in progress
      this.display = true;
      this.imgLoad = false;

      // Check if the ctrl key was pressed (used for multi-selection)
      let ctrlKey: any = (e as KeyboardEvent)?.ctrlKey;
      if (ctrlKey) return; // If ctrl is pressed, return early (to allow multi-selection)

      // Check if the item is already selected by looking for its id in the selectedGalItems_ids array
      let isexist = this.selectedGalItems_ids.filter(n => n == item._id);
      if (isexist.length > 1) return; // If item is already in the selected items, do nothing

      // Clear previous selections if the item is not already selected
      this.selectedGalItems = [];
      this.selectedGalItems_ids = [];

      // Add the selected item and its id to the arrays
      this.selectedGalItems.push(item);
      this.selectedGalItems_ids.push(item._id);

      // Hide watermarking UI element
      this.showWaterMarking = false;

      // Clear selected gallery item and its path
      this.selectedGallaryItem = null;
      this.selectedGallaryItemPath = null;

      // Set default image scale values
      this.selectedImage_scale = 1;
      this.selectedImage_displayscale = Math.round(this.selectedImage_scale * 100);

      // After a brief delay (200ms), set the selected gallery item and its path
      window.setTimeout(() => {
        this.selectedGallaryItem = item;
        this.selectedGallaryItemPath = path;

        // Reset image scale values again after setting the gallery item
        this.selectedImage_scale = 1;
        this.selectedImage_displayscale = Math.round(this.selectedImage_scale * 100);
      }, 200);
    }

    // After 1 second (1000ms), set imgLoad to true, indicating image is fully loaded
    setTimeout(() => {
      this.imgLoad = true;
    }, 1000);
  }

  /**
   * Handles the selection of a gallery item. If more than one item is selected, the function exits.
   * It updates the selected gallery item, resets certain UI elements, and opens the image editor.
   * @param {any} item - The gallery item that was clicked or selected.
   * @param {string} path - The path of the selected image.
   */
  iselectGallaryItem(item, path) {
    // If more than one item is selected, do nothing and return early
    if (this.selectedGalItems_ids.length > 1) return;

    // Reset the watermarking UI element
    this.showWaterMarking = false;

    // Clear previously selected gallery item and its path
    this.selectedGallaryItem = null;
    this.selectedGallaryItemPath = null;

    // Close the image editor
    this.openEditorImage = false;

    // Reset the image scale to the default value (1)
    this.selectedImage_scale = 1;
    this.selectedImage_displayscale = Math.round(this.selectedImage_scale * 100);

    // After a brief delay (200ms), update the selected gallery item and open the editor
    window.setTimeout(() => {
      this.selectedGallaryItem = item;
      this.selectedGallaryItemPath = path;

      // Reset the image scale values again after setting the gallery item
      this.selectedImage_scale = 1;
      this.selectedImage_displayscale = Math.round(this.selectedImage_scale * 100);

      // Open the image editor
      this.openEditorImage = true;
    }, 200);
  }

  /**
   * Updates the grid thumbnail dimensions based on the grid percentage.
   */
  gridSliderUpdated() {
    // Calculate the new thumbnail width based on the grid percentage and a multiplier (4.8)
    this.gridthumbwidth = this.gridpercentage * 4.8;

    // Calculate the new thumbnail height based on the grid percentage and a multiplier (3.68)
    this.gridthumbheight = this.gridpercentage * 3.68;
  }

  /**
   * Adds a new item to the `galItems` array.
   * The new item is simply the next number in the sequence, calculated as the length of the array + 1.
   */
  add() {
    this.galItems.push(this.galItems.length + 1);
  }

  /**
   * Moves an element in an array from one index to another.
   * If the `new_index` is beyond the current length of the array, undefined elements will be added in between.
   * This operation modifies the original array.
   *
   * @param {any[]} arr - The array in which the element will be moved.
   * @param {number} old_index - The current index of the element to be moved.
   * @param {number} new_index - The target index where the element will be moved.
   * @returns {any[]} - The updated array after the element is moved.
   */
  array_move(arr, old_index, new_index) {
    // If the new index is greater than or equal to the array length, add `undefined` elements
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }

    // Move the element from `old_index` to `new_index`
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);

    // Return the updated array
    return arr;
  }

  /**
   * Handles the drag-and-drop event for sorting gallery items.
   * This function determines whether multiple items are selected and adjusts their positions within the array.
   * If only one item is selected, it moves the item to a new position based on the drop event.
   *
   * @param {CdkDragDrop<any>} event - The drag-and-drop event containing information about the drag action.
   */
  spDrop(event: CdkDragDrop<any>) {
    // Check if more than one item is selected
    if (this.selectedGalItems.length > 1) {
      // Filter out the unselected and selected items from `galItems`
      let unselected = this.galItems.filter(n => !this.selectedGalItems_ids.includes(n._id));
      let selected = this.galItems.filter(n => this.selectedGalItems_ids.includes(n._id));

      // Variable to store the index of the dropped item
      let indexOfdropIndexItem = null;

      // Find the index of the dropped item in the unselected array
      unselected.map((n, idx) => {
        if (n._id === event.container.data.itm._id) {
          indexOfdropIndexItem = idx;
        }
      });

      // Check if the drop is on the last item in the grid
      if (event.container.data.index == this.galItems.length - 1) {
        // If dropped on the last item, append selected items to the end
        selected.forEach((_nThItem, nIdx) => {
          unselected.push(selected[nIdx]);
        });
      } else {
        // Otherwise, insert the selected items at the appropriate index
        selected.forEach((_nThItem: any, nIdx: number) => {
          unselected.splice(indexOfdropIndexItem + nIdx, 0, selected[nIdx]);
        });
      }

      // Update the `galItems` array with the new order of items
      this.galItems = unselected;
      // Reset selected items and their IDs
      this.selectedGalItems_ids = [];
      this.selectedGalItems = [];
    } else {
      // If only one item is selected, move the item to the new index using `array_move`
      this.array_move(this.galItems, event.previousContainer.data.index, event.container.data.index);
    }

    // Save the new order of items (presumably with `saveSort()`)
    this.saveSort();

    // Reset the current index and selected items
    event.currentIndex = 0;
    this.selectedGalItems = [];
    this.selectedGalItems_ids = [];
  }

  /**
   * Handles the error that occurs during the image editor loading process.
   * When an error occurs, it resets the selected gallery item and attempts to re-select the first item from the selected items.
   *
   * @param {any} e - The error event or object passed during the error handling.
   */
  editorLoadingError() {
    // Set a timeout of 1000ms before attempting to re-select the gallery item
    setTimeout(() => {
      // Create a shallow copy of the first selected gallery item
      const tmpItem = { ...this.selectedGalItems[0] };

      // Call `selectGallaryItem` to reselect the item and reset the editor state
      this.selectGallaryItem(tmpItem, this.getLargeImageByPath(tmpItem), {});
    }, 1000);

    // Clear the selected gallery item and reset related state variables
    this.selectedGallaryItem = null;
    this.selectedGallaryItemPath = null;
    this.selectedGalItems = [];
    this.selectedGalItems_ids = [];
  }

  selectedGalItems_ids: any = [];
  selectedGalItems: any = [];
  /**
   * Handles the mouse down event when an item is selected or deselected in the gallery.
   * It updates the selected gallery items based on whether the `Ctrl` key is pressed.
   *
   * @param {Event} e - The mouse down event, including information on key modifiers like `Ctrl`.
   * @param {any} item - The item that is being selected or deselected.
   */
  __mouseDown(e, item) {
    // Check if the `Ctrl` key is pressed during the mouse down event
    let ctrlKey = (e as KeyboardEvent).ctrlKey;

    // If the `Ctrl` key is NOT pressed and fewer than 2 items are selected, select the current item
    if (!ctrlKey && this.selectedGalItems.length < 2) {
      // Clear previously selected items
      this.selectedGalItems = [];
      this.selectedGalItems_ids = [];

      // Add the current item to the selected list
      this.selectedGalItems.push(item);
      this.selectedGalItems_ids.push(item._id);
    } else {
      // If no items are selected, reset the selected items array
      if (this.selectedGalItems.length < 1) {
        this.selectedGalItems = [];
        this.selectedGalItems_ids = [];
      }

      // Check if the item is already in the selected items list
      let isexist = this.selectedGalItems_ids.filter(n => n == item._id);

      // If the item is not in the list and the `Ctrl` key is pressed, add it to the selection
      if (isexist.length < 1 && ctrlKey) {
        this.selectedGalItems_ids.push(item._id);
        this.selectedGalItems.push(item);
      }
    }
  }

  display = true;
  onImageEdited(e) {
    if (e) {
      this.display = false;
    }
  }

  // Multi Select
  multiSelect = {
    // Put ".selected" on elements when clicking after longPress or Ctrl+Click
    // Initial Variables
    longPressTime: 500, // in ms unit
    verifyLongPress: 0,
    multiSelect: false,
    verifyDragStarted: false,
    ctrlMode: false,
    firstContainer: null as unknown as HTMLElement,

    selectDrag(el: HTMLElement) {
      while (!el.classList.contains('cdk-drag')) {
        el = el.parentElement as HTMLElement;
      }
      return el;
    },

    mouseDown(e: Event) {
      let target = this.selectDrag(e.target as HTMLElement);
      let ctrlKey = (e as KeyboardEvent).ctrlKey;

      if (this.multiSelect) {
        // If multiSelect is enabled

        /* The responsibility for removing only the first ".selected" has to be with mouseDown and not with mouseUp.
           if not you can't add the first one */

        // Remove
        let allSelected = this.document.querySelectorAll('.selected').length;
        if (allSelected == 1 && target.classList.contains('selected') && (this.ctrlMode ? ctrlKey : true)) {
          // If only have one ".selected" and it was clicked
          target.classList.remove('selected', 'last'); // remove ".selected" and ".last"
          this.multiSelect = false; // turns off multiSelect
        }
      } else {
        // If multiSelect is disabled
        // Do this
        let addSelected = () => {
          this.multiSelect = true; // enable multiSelect
          this.firstContainer = target.parentElement as HTMLElement; //saves the container of the first selected element
          target.classList.add('selected', 'last'); // and add ".selected" and ".last" to the current element clicked
        };

        // If using CTRL
        if (ctrlKey) {
          this.ctrlMode = true;
          addSelected();
        }

        // If using longPress
        this.verifyLongPress = <any>setTimeout(() => {
          // If there is a LongPress
          this.ctrlMode = false;
          addSelected();
        }, this.longPressTime); // after "longPressTime"(ms)
      }
    },

    mouseUp(e: Event) {
      clearTimeout(this.verifyLongPress); // cancel LongPress

      if (this.multiSelect && !this.verifyDragStarted) {
        // If multiSelect is enabled AND not start DragStarted
        let target = this.selectDrag(e.target as HTMLElement);
        let allSelected = this.document.querySelectorAll('.selected');
        let ctrlKey = (e as KeyboardEvent).ctrlKey;
        let last = this.document.querySelector('.last');

        // If use Shift
        if (last && (e as KeyboardEvent).shiftKey) {
          // take range informations
          let containerLast: any = Array.from(last.parentElement!.children);
          let lastIndex = containerLast.indexOf(last);
          let currIndex = containerLast.indexOf(target);
          let max = Math.max(lastIndex, currIndex);
          let min = Math.min(lastIndex, currIndex);

          // toggle .selected in the range
          for (let i = min; i <= max; i++) {
            if (i != lastIndex) {
              // Does not toggle the penult element clicked
              containerLast[i].classList.toggle('selected');
            }
          }

          // put .last if last clicked was selected at end
          if (target.classList.contains('selected')) {
            last && last.classList.remove('last'); // remove .last from penult element clicked
            target.classList.add('last'); // and add ".last" to the current element
          }
        }

        //If don't use shift
        else {
          // To remove from selection
          /* responsibility to remove from selection assigned to mouseUp */
          if (target.classList.contains('selected') && allSelected.length > 1 && (this.ctrlMode ? ctrlKey : true)) {
            // If the clicked element already has ".selected" AND If you have more than 1 (not to remove the first one added)
            target.classList.remove('selected'); // remove ".selected"
            target.classList.remove('last'); // remove ".last"
          }

          // To add to selection
          else {
            // if the clicked element does not have the ".selected"
            if (this.firstContainer == target.parentElement && (this.ctrlMode ? ctrlKey : true)) {
              //if the item click is made within the same container
              last && last.classList.remove('last'); // remove .last from penult element clicked
              target.classList.add('selected', 'last'); // add ".selected" and ".last"
            } else if (this.ctrlMode ? ctrlKey : true) {
              // if in different container, and with ctrl (if ctrl)
              allSelected.forEach(el => {
                // remove all selected from last container
                el.classList.remove('selected', 'hide', 'last');
              });
              this.firstContainer = target.parentElement as HTMLElement; //saves the container of the new selected element
              target.classList.add('selected', 'last'); // and add ".selected" to the element clicked in the new container
            }
          }
        }
      }
    },

    dragStarted() {
      this.verifyDragStarted = true; // shows to mouseDown and mouseUp that Drag started
      clearTimeout(this.verifyLongPress); // cancel longPress
    },

    dragEnded() {
      this.verifyDragStarted = false; // show mouseDown and mouseUp that Drag is over
    },

    dropListDropped(e: CdkDragDrop<string[]>) {
      let el = e.item.element.nativeElement;
      if (el.classList.contains('selected')) {
        // the dragged element was of the "selected" class
        this.multiSelect = false; // disable multiSelect
      }
    },
  };

  /**
   * Handles the mouse down event for selecting or deselecting an item in the gallery.
   * It supports multiple item selection with the `Ctrl` key and toggles the selection.
   *
   * @param {Event} e - The mouse down event, including information on key modifiers like `Ctrl`.
   * @param {any} item - The item that is being selected or deselected.
   */
  mouseDown(e, item) {
    // Check if the `Ctrl` key is pressed during the mouse down event
    let ctrlKey = (e as KeyboardEvent).ctrlKey;

    // If the `Ctrl` key is pressed
    if (ctrlKey) {
      // If no items are selected, reset the selected items arrays
      if (this.selectedGalItems.length < 1) {
        this.selectedGalItems = [];
        this.selectedGalItems_ids = [];
      }

      // Close the image editor and reset selected gallery item details
      this.openEditorImage = false;
      this.selectedGallaryItem = null;
      this.selectedGallaryItemPath = null;
      this.libImageEditor?._distroyImageEditor();

      // Check if the current item is already selected
      let isexist = this.selectedGalItems_ids.filter(n => n == item._id);

      // If the item is not already in the selection, add it
      if (isexist.length < 1) {
        this.selectedGalItems_ids.push(item._id);
        this.selectedGalItems.push(item);
      } else {
        // If the item is already in the selection, remove it
        this.selectedGalItems_ids.map((itm, idx) => {
          if (itm == isexist[0]) {
            this.selectedGalItems_ids.splice(idx, 1);
            this.selectedGalItems.splice(idx, 1);
          }
        });
      }
    }
  }

  // Multi Drag
  multiDrag = {
    // Adjusts clicked items that have ".selected" to organize together
    // Initial Variables
    dragList: [''], // has the value of the selected items in sequence from listData
    dragListCopy: [''], // a copy of the listData, but with the selected elements marked with "DragErase" to delete later
    dragErase: Symbol('DragErase') as any, // a symbol to have unique value when deleting

    dragStarted(e: CdkDragStart) {
      if (e.source.element.nativeElement.classList.contains('selected')) {
        // If the dragged element has ".selected"
        //prepare
        let listData = e.source.dropContainer.data; // get list data value
        this.dragList = []; // reset the dragList
        this.dragListCopy = [...listData]; // copy listData into variable
        let DOMdragEl = e.source.element.nativeElement; // dragged element
        let DOMcontainer = Array.from(DOMdragEl.parentElement!.children); // container where all draggable elements are
        let DOMdragElIndex = DOMcontainer.indexOf(DOMdragEl); // index of the dragged element
        let allSelected = this.document.querySelectorAll('.selected'); // get all the ".selected"

        // Goes through all ".selected"
        allSelected.forEach(eli => {
          // get index of current element
          let CurrDOMelIndexi = DOMcontainer.indexOf(eli);

          // Add listData of current ".selected" to dragList
          this.dragList.push(listData[CurrDOMelIndexi]);

          // Replaces current position in dragListCopy with "DragErase" (to erase exact position later)
          this.dragListCopy[CurrDOMelIndexi] = this.dragErase;

          // Put opacity effect (by CSS class ".hide") on elements (after starting Drag)
          if (DOMdragElIndex !== CurrDOMelIndexi) {
            eli.classList.add('hide');
          }
        });
      }
    },

    dropListDropped(e: CdkDragDrop<string[]>) {
      if (e.previousContainer === e.container) {
        // If in the same container

        let posAdjust = e.previousIndex < e.currentIndex ? 1 : 0; // Adjusts the placement position
        this.dragListCopy.splice(e.currentIndex + posAdjust, 0, ...this.dragList); // put elements in dragListCopy
        this.dragListCopy = this.dragListCopy.filter(el => el !== this.dragErase); // remove the "DragErase" from the list

        // Pass item by item to final list
        for (let i = 0; i < e.container.data.length; i++) {
          e.container.data[i] = this.dragListCopy[i];
        }
      } else {
        // If in different containers

        // remove the "DragErase" from the list
        this.dragListCopy = this.dragListCopy.filter(el => el !== this.dragErase);

        // Pass item by item to initial list
        for (let i = 0; i < e.previousContainer.data.length; i++) {
          e.previousContainer.data[i] = this.dragListCopy[i];
        }
        for (let i = 0; i < this.dragList.length; i++) {
          e.previousContainer.data.pop();
        }

        let otherListCopy = [...e.container.data]; // list of new container
        otherListCopy.splice(e.currentIndex, 0, ...this.dragList); // put elements in otherListCopy

        // Pass item by item to final list
        for (let i = 0; i < otherListCopy.length; i++) {
          e.container.data[i] = otherListCopy[i];
        }
      }

      // Remove ".hide"
      let allHidden = this.document.querySelectorAll('.hide');
      allHidden.forEach(el => {
        el.classList.remove('hide');
      });
      // Remove ".selected" after 300ms
      setTimeout(() => {
        let allSelected = this.document.querySelectorAll('.selected');
        allSelected.forEach(el => {
          el.classList.remove('selected', 'last');
        });
      }, 300);

      this.dragListCopy = []; // reset the dragListCopy
      this.dragList = []; // reset the dragList
    },
  };
  /* END TWO OBJECTS */

  isItemSelected(selectedItemList: any[] = [], singleSelectedItem: any, item): boolean {
    if (selectedItemList?.some(value => value?._id === item?._id) || singleSelectedItem?._id === item?._id) {
      this.trashLibraryData = this.trashLibraryData?.map(el => {
        if (el?._id == item?._id) {
          return (el = { ...el, is_Selected: true });
        } else {
          return el;
        }
      });
      return true;
    }
    return false;
  }

  triggerPdffile() {
    let el: HTMLElement = this.pdffile.nativeElement;
    el.click();
  }

  thatEmpdata = null;
  pdfConverting: boolean = false;
  pdfFile: any = null;
  pdfPages: any = [];
  /**
   * Handles the conversion of a PDF file to images.
   * The function is triggered when a file is selected, and it processes the PDF by converting each page into an image.
   *
   * @param {Event} event - The event triggered when the file is selected.
   * @param {FileList} files - The list of files selected by the user.
   */
  async convertPDF(event, files: FileList) {
    // Store the event that triggered the file selection
    this.filesuploadEvent = event;

    // Get the first file from the FileList (assumes only one file is selected)
    let file = files.item(0);

    // Store the selected file as the PDF file
    this.pdfFile = file;

    // Prepare an array to store files ready for upload (currently only includes the selected PDF file)
    this.readyToUploadFiles = [file];

    // Set a flag to indicate that PDF conversion is in progress
    this.pdfConverting = true;

    // Call the service to convert the PDF to image data URLs asynchronously
    this.pdfService.pdfToAllImageDataURLAsync(file).then(response => {
      // When the conversion is complete, store the resulting image data URLs for each page of the PDF
      this.pdfPages = response;

      // Reset the flag indicating that conversion is finished
      this.pdfConverting = false;

      // Clear any search keywords (not used in the function but may relate to another part of the app)
      this.searchKeyword = '';
    });
  }

  /**
   * Handles the upload process for a selected PDF page converted to a base64 image.
   * This function initializes the upload process, manages progress updates, and sends the data to the server.
   *
   * @param {string} base64Image - The base64-encoded image representation of the PDF page.
   */
  uploadSelectPdfPage(base64Image) {
    // Store the base64-encoded image data
    this.thatEmpdata = base64Image;

    // Calculate the initial percentage for the upload progress
    this.percentageLoading = 100 / this.readyToUploadFiles?.length;

    // Initialize upload progress status for each file
    this.filesUploadProgressStatus = this.readyToUploadFiles?.map((record: any, index: number) => ({
      id: index,
      name: record?.name || '',
      percentage: 0,
      drag: false,
    }));

    // Emit the initial file upload progress status
    this.filesUploadingStatus.next(this.filesUploadProgressStatus);

    let number = 0;

    // Emit the initial loader percentage
    this.loaderPercentage.next(Math.round(this.percentageLoading * number));

    // Set loading state
    this.fileUploadingLoader = this.loading = true;

    // Construct the parameters for the API request
    let param = {
      user_id: this.authUserID,
      office_id: this.activeOfficeId,
      group_id: '',
      type: 'file',
      library_type: this.library_type,
      file: [{ name: this.pdfFile?.name, fileSrc: base64Image }],
      parentId: this.searchedResultId,
      name: '',
      private_file_access: this.file_type_nature === 'private' ? true : false,
    };

    // Add `propertyId` if the category is 'useroffice'
    if (this.category === 'useroffice') {
      param['propertyId'] = this.propertyId;
    }

    // Determine the API endpoint based on the category
    let endpoint = this.category === 'useroffice' ? '/library/office-library/add-folder-file' : '/library/add-folder-file';
    this.eoi_Id && (param['eoi_id'] = this.eoi_Id);
    // Make the HTTP POST request to upload the file
    this.http
      .post(`${this.Api.baseUrl}${endpoint}`, param, {
        headers: {
          Authorization: 'Bearer ' + this.tokenService.getToken(),
        },
        reportProgress: true,
        observe: 'events',
      })
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          const { type, loaded = 0, total = 0, body } = response || { type: null, loaded: 0, total: 0, body: null };

          // Handle file upload progress updates
          if (type === HttpEventType.UploadProgress) {
            let progress = Math.round((100 * loaded) / total);
            this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
              if (record?.id === number) {
                record = { ...record, percentage: progress || -1 };
              }
              return record;
            });

            // Emit the updated progress status
            this.filesUploadingStatus.next(this.filesUploadProgressStatus);
          }
          // Handle response when upload is complete
          else if (type === HttpEventType.Response) {
            const { status } = body;

            if (status) {
              // Mark the upload as complete (100%)
              this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                if (record?.id === number) {
                  record = { ...record, percentage: 100 };
                }
                return record;
              });
              this.filesUploadingStatus.next(this.filesUploadProgressStatus);
              this.fileUploadingLoader = this.loading = true;
            } else {
              // Mark the upload as failed (-1%)
              this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                if (record?.id === number) {
                  record = { ...record, percentage: -1 };
                }
                return record;
              });
              this.fileUploadingLoader = this.loading = true;
            }

            // Emit the updated progress status
            this.filesUploadingStatus.next(this.filesUploadProgressStatus);
          }
        },
        error: err => {
          // Handle errors during file upload
          this.loading = false;
          this.toastr.error(err?.error?.message ? err?.error?.message : 'Something went wrong');

          // Reset various UI states upon error
          this.fileUploadingLoader = this.addFolderModal = this.isWorkspace = this.loading = false;
        },
        complete: () => {
          // Mark upload as complete and update UI
          this.tempFix = true;
          this.sideBarLev1(null);
          this.loaderPercentage.next(Math.round(this.percentageLoading * number));
        },
      });
  }

  hoverDisable = false;
  isDragable = true;
  /**
   * Handles the "drag enter" event when an item is dragged over a specific area.
   * It prevents default behavior, stops event propagation, and updates UI states accordingly.
   *
   * @param {Event} event - The drag enter event.
   */
  onEnter(event) {
    event?.preventDefault(); // Prevents the default behavior of the event (e.g., file opening)
    event?.stopPropagation(); // Stops the event from propagating further in the DOM
    // Disable hover effects and tooltips when an item is dragged over
    this.hoverDisable = true;
    this.isTooltipDisabled = true;
    // Disable dragging to prevent interference with the drop action
    this.isDragable = false;
  }

  /**
   * Handles the "drag leave" event when an item leaves a specific drop area.
   * It restores UI states to their original values.
   *
   * @param {Event} event - The drag leave event.
   */
  onLeave(event) {
    event?.preventDefault(); // Prevents any unintended behavior when leaving the drag area
    event?.stopPropagation(); // Stops the event from propagating further in the DOM
    // Re-enable hover effects and tooltips when dragging is no longer active
    this.hoverDisable = false;
    this.isTooltipDisabled = false;
    // Re-enable dragging since the item has left the drop area
    this.isDragable = true;
  }

  /**
   * Converts a selected PDF file into images, uploads it to the server,
   * and tracks the upload progress.
   *
   * @param {Event} event - The file input change event.
   * @param {FileList} files - The list of selected files.
   */
  async _convertPDF(event, files: FileList) {
    this.filesuploadEvent = event; // Stores the file upload event for reference
    let file = files.item(0); // Retrieves the first selected file
    this.readyToUploadFiles = [file]; // Stores the file for upload processing

    // Converts the PDF to a base64 image using the PDF service
    this.pdfService._pdfToImageDataURLAsync(file).then(base64Image => {
      this.thatEmpdata = base64Image; // Stores the converted base64 image data

      // Initializes upload progress tracking
      this.percentageLoading = 100 / this.readyToUploadFiles?.length;
      this.filesUploadProgressStatus = this.readyToUploadFiles?.map((record: any, index: number) => ({
        id: index,
        name: record?.name || '',
        percentage: 0,
        drag: false,
      }));
      this.filesUploadingStatus.next(this.filesUploadProgressStatus); // Updates progress status

      let number = 0;
      this.loaderPercentage.next(Math.round(this.percentageLoading * number));

      // Flags that the file upload process has started
      this.fileUploadingLoader = this.loading = true;

      // Constructs the request payload for uploading the converted file
      var param = {
        user_id: this.authUserID,
        office_id: this.activeOfficeId,
        group_id: '',
        type: 'file',
        library_type: this.library_type,
        file: [{ name: file?.name, fileSrc: base64Image }],
        parentId: this.searchedResultId,
        name: '',
        private_file_access: this.file_type_nature === 'private' ? true : false,
      };

      // Sends the file upload request to the API
      this.http
        .post(`${this.Api.baseUrl}/library/add-folder-file`, param, {
          headers: {
            Authorization: 'Bearer ' + this.tokenService.getToken(),
          },
          reportProgress: true,
          observe: 'events',
        })
        .subscribe({
          next: (response: any) => {
            this.loading = false; // Stops loading once response is received
            const { type, loaded = 0, total = 0, body } = response || { type: null, loaded: 0, total: 0, body: null };

            if (type === HttpEventType.UploadProgress) {
              // Updates the upload progress percentage
              let progress = Math.round((100 * loaded) / total);
              this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                if (record?.id === number) {
                  record = { ...record, percentage: progress || -1 };
                }
                return record;
              });
              this.filesUploadingStatus.next(this.filesUploadProgressStatus);
            } else if (type === HttpEventType.Response) {
              const { status } = body;
              if (status) {
                // Marks the upload as completed successfully
                this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                  if (record?.id === number) {
                    record = { ...record, percentage: 100 };
                  }
                  return record;
                });
                this.filesUploadingStatus.next(this.filesUploadProgressStatus);
                this.fileUploadingLoader = this.loading = true;
              } else {
                // Handles upload failure by marking progress as -1 (error)
                this.filesUploadProgressStatus = this.filesUploadProgressStatus?.map((record: any) => {
                  if (record?.id === number) {
                    record = { ...record, percentage: -1 };
                  }
                  return record;
                });
                this.fileUploadingLoader = this.loading = true;
              }
              this.filesUploadingStatus.next(this.filesUploadProgressStatus);
            }
          },
          error: err => {
            // Handles upload errors by showing a toast notification
            this.loading = false;
            this.toastr.error(err?.error?.message ? err?.error?.message : 'Something went wrong');
            this.fileUploadingLoader = this.addFolderModal = this.isWorkspace = this.loading = false;
          },
          complete: () => {
            // Finalizes the process and refreshes the data
            this.tempFix = true;
            this.getAllData();
          },
        });
    });
  }

  portalImages: any[] = [];
  /**
   * Handles the drag-and-drop functionality for images between different containers.
   * Ensures users have the required permissions before allowing reordering.
   *
   * @param {CdkDragDrop<any>} event - The drag-and-drop event object.
   */
  drop(event: CdkDragDrop<any>) {
    // Check if the user has the necessary permissions to reorder images
    if (!(this.userRole == 'master admin' || this.userRole == 'operations manager' || this.userPermission.includes('reorder_images.update'))) {
      this.toastr.error("You don't have permission to reorder");
      return;
    }

    const draggedImage = event?.previousContainer?.data['itm']; // Extracts the dragged item

    // Handling item reordering within the same container
    if (event.previousContainer.id === event.container.id) {
      if (draggedImage?.type !== 'folder') {
        // Ensures folders are not reordered
        if (event.container.id === 'galImgList') {
          // Moves the item within the gallery images list
          this.array_move(this.galItems, event.previousContainer.data.index, event.container.data.index);
        } else if (event.container.id === 'portalImgList') {
          // Moves the item within the portal images list
          this.array_move(this.portalImages, event.previousContainer.data.index, event.container.data.index);
        }
        this.saveSort(); // Saves the updated order
      }
    } else {
      // Handling item movement between different containers

      if (event.previousContainer.id === 'galImgList') {
        if (draggedImage?.type !== 'folder') {
          // Ensures folders are not moved
          draggedImage['is_offline'] = true; // Marks the image as offline
          this.portalImages.push(draggedImage); // Adds the image to the portal images list

          // Removes the image from the gallery list
          const index = this.galItems.findIndex(item => item._id === draggedImage._id);
          if (index !== -1) {
            this.galItems.splice(index, 1);
          }
          this.saveSort(draggedImage, event.previousIndex); // Saves the new order
        }
      } else if (event.container.id === 'galImgList') {
        // Moving an item into the gallery list
        draggedImage['is_offline'] = false; // Marks the image as online
        this.galItems.push(draggedImage); // Adds the image to the gallery list

        // Removes the image from the portal list
        const index = this.portalImages.findIndex(item => item._id === draggedImage._id);
        if (index !== -1) {
          this.portalImages.splice(index, 1);
        }
        this.saveSort(draggedImage, event.previousIndex); // Saves the new order
      } else if (event.previousContainer.id === 'portalImgList' && event.container.id !== 'galImgList') {
        // Moving an item out of the portal list to another unknown location
        draggedImage['is_offline'] = false; // Marks the image as online
        this.galItems.push(draggedImage); // Adds the image to the gallery list

        // Removes the image from the portal list
        const index = this.portalImages.findIndex(item => item._id === draggedImage._id);
        if (index !== -1) {
          this.portalImages.splice(index, 1);
        }
        this.saveSort(draggedImage, event.previousIndex); // Saves the new order
      }
    }
  }

  /**
   * Calculates the right padding based on the number of images and screen width.
   * This is used for aligning images properly, especially for the last row.
   *
   * @param {number} imageCount - The number of images in the row.
   * @param {boolean} isLast - Flag indicating whether this is the last row.
   * @returns {{ [key: string]: string } | null} - CSS styles for padding, or null if no padding is needed.
   */
  calculatePadding(imageCount: number, isLast: boolean): { [key: string]: string } | null {
    // Only applies padding if this is the last row and contains 7 or fewer images
    if (isLast && imageCount <= 7) {
      let paddingValue; // Stores the calculated padding value

      // Determines padding based on image count and screen width
      if (imageCount == 7) this.innerWidth > 1900 ? (paddingValue = '8vw') : (paddingValue = '0vw');
      if (imageCount == 6) this.innerWidth > 1900 ? (paddingValue = '23vw') : (paddingValue = '6vw');
      if (imageCount == 5) this.innerWidth > 1900 ? (paddingValue = '35vw') : (paddingValue = '18vw');
      if (imageCount == 4) this.innerWidth > 1900 ? (paddingValue = '47vw') : (paddingValue = '30vw');
      if (imageCount == 3) this.innerWidth > 1900 ? (paddingValue = '59vw') : (paddingValue = '42vw');
      if (imageCount == 2) this.innerWidth > 1900 ? (paddingValue = '71vw') : (paddingValue = '54vw');
      if (imageCount == 1) this.innerWidth > 1900 ? (paddingValue = '83vw') : (paddingValue = '70vw');

      // Returns the computed padding style
      const styles: { [key: string]: string } = {
        'padding-right': paddingValue,
      };

      return styles;
    } else {
      return null; // No padding needed if not the last row or more than 7 images
    }
  }

  /**
   * Checks if a user is either an agent or an admin for a given item.
   *
   * @param {any} item - The item being checked.
   * @returns {boolean} - Returns true if the user is an admin or an agent, otherwise false.
   */
  isAgentOrAdmin = (item: any) => {
    let bol = true; // Default value is true

    // If the item type is "reports" and the user is neither an admin nor the owner, return false
    if (item?.type === 'reports' && !this.isAdmin && item.user_id !== this.authUserID) {
      bol = false;
    }

    return bol; // Returns the final boolean value
  };

  internal: any[] = [];
  loadInternalUsers = () => {
    // Construct API URL to fetch internal project-associated contacts
    let url = `/project-internal-association/${this.propertyId}`;

    // Fetch internal contacts using Redux state management
    this.redux.getSetProjectInfo(true, 'internal-' + this.propertyId, url, ReduxService.BURST_FRESH_MS).subscribe(res => {
      this.internal = JSON.parse(JSON.stringify(res.data)).filter(f => f?.is_user === true);
      this.internal = this.internal.map((f: any) => ({ ...f, full_name: `${f.name}` }));
      console.log('internal :>> ', this.internal);
    });
  };

  onLoadSliderImages(event: any) {
    console.log('Event', event);
  }
}
declare global {
  export type SVGGraphics = any;
}
